import { Country, ICountry } from '../../page-builder/interface/dataInterface';

export const countries: Country[] = [
  { name: 'United States', code: 'US', phoneCode: '1' },
  { name: 'Afghanistan', code: 'AF', phoneCode: '93' },
  { name: 'Albania', code: 'AL', phoneCode: '355' },
  { name: 'Algeria', code: 'DZ', phoneCode: '213' },
  { name: 'Andorra', code: 'AD', phoneCode: '376' },
  { name: 'Angola', code: 'AO', phoneCode: '244' },
  { name: 'Antigua and Barbuda', code: 'AG', phoneCode: '1' },
  { name: 'Argentina', code: 'AR', phoneCode: '54' },
  { name: 'Armenia', code: 'AM', phoneCode: '374' },
  { name: 'Australia', code: 'AU', phoneCode: '61' },
  { name: 'Austria', code: 'AT', phoneCode: '43' },
  { name: 'Azerbaijan', code: 'AZ', phoneCode: '994' },
  { name: 'Bahamas', code: 'BS', phoneCode: '1' },
  { name: 'Bahrain', code: 'BH', phoneCode: '973' },
  { name: 'Bangladesh', code: 'BD', phoneCode: '880' },
  { name: 'Barbados', code: 'BB', phoneCode: '1' },
  { name: 'Belarus', code: 'BY', phoneCode: '375' },
  { name: 'Belgium', code: 'BE', phoneCode: '32' },
  { name: 'Belize', code: 'BZ', phoneCode: '501' },
  { name: 'Benin', code: 'BJ', phoneCode: '229' },
  { name: 'Bhutan', code: 'BT', phoneCode: '975' },
  { name: 'Bolivia', code: 'BO', phoneCode: '591' },
  { name: 'Bosnia and Herzegovina', code: 'BA', phoneCode: '387' },
  { name: 'Botswana', code: 'BW', phoneCode: '267' },
  { name: 'Brazil', code: 'BR', phoneCode: '55' },
  { name: 'Brunei', code: 'BN', phoneCode: '673' },
  { name: 'Bulgaria', code: 'BG', phoneCode: '359' },
  { name: 'Burkina Faso', code: 'BF', phoneCode: '226' },
  { name: 'Burundi', code: 'BI', phoneCode: '257' },
  { name: 'Cabo Verde', code: 'CV', phoneCode: '238' },
  { name: 'Cambodia', code: 'KH', phoneCode: '855' },
  { name: 'Cameroon', code: 'CM', phoneCode: '237' },
  { name: 'Canada', code: 'CA', phoneCode: '1' },
  { name: 'Central African Republic', code: 'CF', phoneCode: '236' },
  { name: 'Chad', code: 'TD', phoneCode: '235' },
  { name: 'Chile', code: 'CL', phoneCode: '56' },
  { name: 'China', code: 'CN', phoneCode: '86' },
  { name: 'Colombia', code: 'CO', phoneCode: '57' },
  { name: 'Comoros', code: 'KM', phoneCode: '269' },
  { name: 'Congo', code: 'CG', phoneCode: '242' },
  { name: 'Costa Rica', code: 'CR', phoneCode: '506' },
  { name: 'Croatia', code: 'HR', phoneCode: '385' },
  { name: 'Cuba', code: 'CU', phoneCode: '53' },
  { name: 'Cyprus', code: 'CY', phoneCode: '357' },
  { name: 'Czech Republic', code: 'CZ', phoneCode: '420' },
  { name: 'Denmark', code: 'DK', phoneCode: '45' },
  { name: 'Djibouti', code: 'DJ', phoneCode: '253' },
  { name: 'Dominica', code: 'DM', phoneCode: '1' },
  { name: 'Dominican Republic', code: 'DO', phoneCode: '1' },
  { name: 'Ecuador', code: 'EC', phoneCode: '593' },
  { name: 'Egypt', code: 'EG', phoneCode: '20' },
  { name: 'El Salvador', code: 'SV', phoneCode: '503' },
  { name: 'Equatorial Guinea', code: 'GQ', phoneCode: '240' },
  { name: 'Eritrea', code: 'ER', phoneCode: '291' },
  { name: 'Estonia', code: 'EE', phoneCode: '372' },
  { name: 'Eswatini', code: 'SZ', phoneCode: '268' },
  { name: 'Ethiopia', code: 'ET', phoneCode: '251' },
  { name: 'Fiji', code: 'FJ', phoneCode: '679' },
  { name: 'Finland', code: 'FI', phoneCode: '358' },
  { name: 'France', code: 'FR', phoneCode: '33' },
  { name: 'Gabon', code: 'GA', phoneCode: '241' },
  { name: 'Gambia', code: 'GM', phoneCode: '220' },
  { name: 'Georgia', code: 'GE', phoneCode: '995' },
  { name: 'Germany', code: 'DE', phoneCode: '49' },
  { name: 'Ghana', code: 'GH', phoneCode: '233' },
  { name: 'Greece', code: 'GR', phoneCode: '30' },
  { name: 'Grenada', code: 'GD', phoneCode: '1' },
  { name: 'Guatemala', code: 'GT', phoneCode: '502' },
  { name: 'Guinea', code: 'GN', phoneCode: '224' },
  { name: 'Guinea-Bissau', code: 'GW', phoneCode: '245' },
  { name: 'Guyana', code: 'GY', phoneCode: '592' },
  { name: 'Haiti', code: 'HT', phoneCode: '509' },
  { name: 'Honduras', code: 'HN', phoneCode: '504' },
  { name: 'Hungary', code: 'HU', phoneCode: '36' },
  { name: 'Iceland', code: 'IS', phoneCode: '354' },
  { name: 'India', code: 'IN', phoneCode: '91' },
  { name: 'Indonesia', code: 'ID', phoneCode: '62' },
  { name: 'Iran', code: 'IR', phoneCode: '98' },
  { name: 'Iraq', code: 'IQ', phoneCode: '964' },
  { name: 'Ireland', code: 'IE', phoneCode: '353' },
  { name: 'Israel', code: 'IL', phoneCode: '972' },
  { name: 'Italy', code: 'IT', phoneCode: '39' },
  { name: 'Jamaica', code: 'JM', phoneCode: '1' },
  { name: 'Japan', code: 'JP', phoneCode: '81' },
  { name: 'Jordan', code: 'JO', phoneCode: '962' },
  { name: 'Kazakhstan', code: 'KZ', phoneCode: '7' },
  { name: 'Kenya', code: 'KE', phoneCode: '254' },
  { name: 'Kiribati', code: 'KI', phoneCode: '686' },
  { name: 'Korea (North)', code: 'KP', phoneCode: '850' },
  { name: 'Korea (South)', code: 'KR', phoneCode: '82' },
  { name: 'Kuwait', code: 'KW', phoneCode: '965' },
  { name: 'Kyrgyzstan', code: 'KG', phoneCode: '996' },
  { name: 'Laos', code: 'LA', phoneCode: '856' },
  { name: 'Latvia', code: 'LV', phoneCode: '371' },
  { name: 'Lebanon', code: 'LB', phoneCode: '961' },
  { name: 'Lesotho', code: 'LS', phoneCode: '266' },
  { name: 'Liberia', code: 'LR', phoneCode: '231' },
  { name: 'Libya', code: 'LY', phoneCode: '218' },
  { name: 'Liechtenstein', code: 'LI', phoneCode: '423' },
  { name: 'Lithuania', code: 'LT', phoneCode: '370' },
  { name: 'Luxembourg', code: 'LU', phoneCode: '352' },
  { name: 'Macedonia', code: 'MK', phoneCode: '389' },
  { name: 'Madagascar', code: 'MG', phoneCode: '261' },
  { name: 'Malawi', code: 'MW', phoneCode: '265' },
  { name: 'Malaysia', code: 'MY', phoneCode: '60' },
  { name: 'Maldives', code: 'MV', phoneCode: '960' },
  { name: 'Mali', code: 'ML', phoneCode: '223' },
  { name: 'Malta', code: 'MT', phoneCode: '356' },
  { name: 'Marshall Islands', code: 'MH', phoneCode: '692' },
  { name: 'Mauritania', code: 'MR', phoneCode: '222' },
  { name: 'Mauritius', code: 'MU', phoneCode: '230' },
  { name: 'Mexico', code: 'MX', phoneCode: '52' },
  { name: 'Micronesia', code: 'FM', phoneCode: '691' },
  { name: 'Moldova', code: 'MD', phoneCode: '373' },
  { name: 'Monaco', code: 'MC', phoneCode: '377' },
  { name: 'Mongolia', code: 'MN', phoneCode: '976' },
  { name: 'Montenegro', code: 'ME', phoneCode: '382' },
  { name: 'Morocco', code: 'MA', phoneCode: '212' },
  { name: 'Mozambique', code: 'MZ', phoneCode: '258' },
  { name: 'Myanmar', code: 'MM', phoneCode: '95' },
  { name: 'Namibia', code: 'NA', phoneCode: '264' },
  { name: 'Nauru', code: 'NR', phoneCode: '674' },
  { name: 'Nepal', code: 'NP', phoneCode: '977' },
  { name: 'Netherlands', code: 'NL', phoneCode: '31' },
  { name: 'New Zealand', code: 'NZ', phoneCode: '64' },
  { name: 'Nicaragua', code: 'NI', phoneCode: '505' },
  { name: 'Niger', code: 'NE', phoneCode: '227' },
  { name: 'Nigeria', code: 'NG', phoneCode: '234' },
  { name: 'Norway', code: 'NO', phoneCode: '47' },
  { name: 'Oman', code: 'OM', phoneCode: '968' },
  { name: 'Pakistan', code: 'PK', phoneCode: '92' },
  { name: 'Palau', code: 'PW', phoneCode: '680' },
  { name: 'Palestine, State of', code: 'PS', phoneCode: '970' },
  { name: 'Panama', code: 'PA', phoneCode: '507' },
  { name: 'Papua New Guinea', code: 'PG', phoneCode: '675' },
  { name: 'Paraguay', code: 'PY', phoneCode: '595' },
  { name: 'Peru', code: 'PE', phoneCode: '51' },
  { name: 'Philippines', code: 'PH', phoneCode: '63' },
  { name: 'Poland', code: 'PL', phoneCode: '48' },
  { name: 'Portugal', code: 'PT', phoneCode: '351' },
  { name: 'Qatar', code: 'QA', phoneCode: '974' },
  { name: 'Romania', code: 'RO', phoneCode: '40' },
  { name: 'Russia', code: 'RU', phoneCode: '7' },
  { name: 'Rwanda', code: 'RW', phoneCode: '250' },
  { name: 'Saint Kitts and Nevis', code: 'KN', phoneCode: '1' },
  { name: 'Saint Lucia', code: 'LC', phoneCode: '1' },
  { name: 'Saint Vincent and the Grenadines', code: 'VC', phoneCode: '1' },
  { name: 'Samoa', code: 'WS', phoneCode: '685' },
  { name: 'San Marino', code: 'SM', phoneCode: '378' },
  { name: 'Sao Tome and Principe', code: 'ST', phoneCode: '239' },
  { name: 'Saudi Arabia', code: 'SA', phoneCode: '966' },
  { name: 'Senegal', code: 'SN', phoneCode: '221' },
  { name: 'Serbia', code: 'RS', phoneCode: '381' },
  { name: 'Seychelles', code: 'SC', phoneCode: '248' },
  { name: 'Sierra Leone', code: 'SL', phoneCode: '232' },
  { name: 'Singapore', code: 'SG', phoneCode: '65' },
  { name: 'Slovakia', code: 'SK', phoneCode: '421' },
  { name: 'Slovenia', code: 'SI', phoneCode: '386' },
  { name: 'Solomon Islands', code: 'SB', phoneCode: '677' },
  { name: 'Somalia', code: 'SO', phoneCode: '252' },
  { name: 'South Africa', code: 'ZA', phoneCode: '27' },
  { name: 'South Sudan', code: 'SS', phoneCode: '211' },
  { name: 'Spain', code: 'ES', phoneCode: '34' },
  { name: 'Sri Lanka', code: 'LK', phoneCode: '94' },
  { name: 'Sudan', code: 'SD', phoneCode: '249' },
  { name: 'Suriname', code: 'SR', phoneCode: '597' },
  { name: 'Sweden', code: 'SE', phoneCode: '46' },
  { name: 'Switzerland', code: 'CH', phoneCode: '41' },
  { name: 'Syria', code: 'SY', phoneCode: '963' },
  { name: 'Taiwan', code: 'TW', phoneCode: '886' },
  { name: 'Tajikistan', code: 'TJ', phoneCode: '992' },
  { name: 'Tanzania', code: 'TZ', phoneCode: '255' },
  { name: 'Thailand', code: 'TH', phoneCode: '66' },
  { name: 'Timor-Leste', code: 'TL', phoneCode: '670' },
  { name: 'Togo', code: 'TG', phoneCode: '228' },
  { name: 'Tonga', code: 'TO', phoneCode: '676' },
  { name: 'Trinidad and Tobago', code: 'TT', phoneCode: '1' },
  { name: 'Tunisia', code: 'TN', phoneCode: '216' },
  { name: 'Turkey', code: 'TR', phoneCode: '90' },
  { name: 'Turkmenistan', code: 'TM', phoneCode: '993' },
  { name: 'Tuvalu', code: 'TV', phoneCode: '688' },
  { name: 'Uganda', code: 'UG', phoneCode: '256' },
  { name: 'Ukraine', code: 'UA', phoneCode: '380' },
  { name: 'United Arab Emirates', code: 'AE', phoneCode: '971' },
  { name: 'United Kingdom', code: 'GB', phoneCode: '44' },
  { name: 'Uruguay', code: 'UY', phoneCode: '598' },
  { name: 'Uzbekistan', code: 'UZ', phoneCode: '998' },
  { name: 'Vanuatu', code: 'VU', phoneCode: '678' },
  { name: 'Vatican City', code: 'VA', phoneCode: '39' },
  { name: 'Venezuela', code: 'VE', phoneCode: '58' },
  { name: 'Vietnam', code: 'VN', phoneCode: '84' },
  { name: 'Yemen', code: 'YE', phoneCode: '967' },
  { name: 'Zambia', code: 'ZM', phoneCode: '260' },
  { name: 'Zimbabwe', code: 'ZW', phoneCode: '263' },
];

export const CountryWithStateList: ICountry[] = [
  {
    id: 539836579958,
    name: 'Afghanistan',
    code: 'AF',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 518032031862,
    name: 'Aland Islands',
    code: 'AX',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 518032064630,
    name: 'Albania',
    code: 'AL',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 539834581110,
    name: 'Algeria',
    code: 'DZ',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 518032097398,
    name: 'Andorra',
    code: 'AD',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 539834613878,
    name: 'Angola',
    code: 'AO',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 518033178742,
    name: 'Anguilla',
    code: 'AI',
    tax_name: 'GST',
    tax: 0,
    provinces: [],
  },
  {
    id: 518033211510,
    name: 'Antigua And Barbuda',
    code: 'AG',
    tax_name: 'ABST',
    tax: 0,
    provinces: [],
  },
  {
    id: 518035013750,
    name: 'Argentina',
    code: 'AR',
    tax_name: 'VAT',
    tax: 0,
    provinces: [
      {
        country_id: 518035013750,
        id: 5741017956470,
        name: 'Buenos Aires',
        code: 'B',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035013750,
        id: 5741017989238,
        name: 'Catamarca',
        code: 'K',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035013750,
        id: 5741018022006,
        name: 'Chaco',
        code: 'H',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035013750,
        id: 5741018054774,
        name: 'Chubut',
        code: 'U',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035013750,
        id: 5741018087542,
        name: 'Ciudad Autónoma de Buenos Aires',
        code: 'C',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035013750,
        id: 5741018120310,
        name: 'Córdoba',
        code: 'X',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035013750,
        id: 5741018153078,
        name: 'Corrientes',
        code: 'W',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035013750,
        id: 5741018185846,
        name: 'Entre Ríos',
        code: 'E',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035013750,
        id: 5741018218614,
        name: 'Formosa',
        code: 'P',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035013750,
        id: 5741018251382,
        name: 'Jujuy',
        code: 'Y',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035013750,
        id: 5741018284150,
        name: 'La Pampa',
        code: 'L',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035013750,
        id: 5741018316918,
        name: 'La Rioja',
        code: 'F',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035013750,
        id: 5741018349686,
        name: 'Mendoza',
        code: 'M',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035013750,
        id: 5741018382454,
        name: 'Misiones',
        code: 'N',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035013750,
        id: 5741018415222,
        name: 'Neuquén',
        code: 'Q',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035013750,
        id: 5741018447990,
        name: 'Río Negro',
        code: 'R',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035013750,
        id: 5741018480758,
        name: 'Salta',
        code: 'A',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035013750,
        id: 5741018513526,
        name: 'San Juan',
        code: 'J',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035013750,
        id: 5741018546294,
        name: 'San Luis',
        code: 'D',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035013750,
        id: 5741018579062,
        name: 'Santa Cruz',
        code: 'Z',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035013750,
        id: 5741018611830,
        name: 'Santa Fe',
        code: 'S',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035013750,
        id: 5741018644598,
        name: 'Santiago Del Estero',
        code: 'G',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035013750,
        id: 5741018677366,
        name: 'Tierra Del Fuego',
        code: 'V',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035013750,
        id: 5741018710134,
        name: 'Tucumán',
        code: 'T',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
    ],
  },
  {
    id: 518030819446,
    name: 'Armenia',
    code: 'AM',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 518033244278,
    name: 'Aruba',
    code: 'AW',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 539834646646,
    name: 'Ascension Island',
    code: 'AC',
    tax_name: 'Tax',
    tax: 0,
    provinces: [],
  },
  {
    id: 508180201590,
    name: 'Australia',
    code: 'AU',
    tax_name: 'GST',
    tax: 0,
    provinces: [
      {
        country_id: 508180201590,
        id: 5603099934838,
        name: 'Australian Capital Territory',
        code: 'ACT',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180201590,
        id: 5603099967606,
        name: 'New South Wales',
        code: 'NSW',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180201590,
        id: 5603100000374,
        name: 'Northern Territory',
        code: 'NT',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180201590,
        id: 5603100033142,
        name: 'Queensland',
        code: 'QLD',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180201590,
        id: 5603100065910,
        name: 'South Australia',
        code: 'SA',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180201590,
        id: 5603100098678,
        name: 'Tasmania',
        code: 'TAS',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180201590,
        id: 5603100131446,
        name: 'Victoria',
        code: 'VIC',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180201590,
        id: 5603100164214,
        name: 'Western Australia',
        code: 'WA',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
    ],
  },
  {
    id: 508180168822,
    name: 'Austria',
    code: 'AT',
    tax_name: 'AT VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 518030852214,
    name: 'Azerbaijan',
    code: 'AZ',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 518033277046,
    name: 'Bahamas',
    code: 'BS',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 518030884982,
    name: 'Bahrain',
    code: 'BH',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 518030917750,
    name: 'Bangladesh',
    code: 'BD',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 518033309814,
    name: 'Barbados',
    code: 'BB',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 518032130166,
    name: 'Belarus',
    code: 'BY',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 508180234358,
    name: 'Belgium',
    code: 'BE',
    tax_name: 'BE TVA',
    tax: 0,
    provinces: [],
  },
  {
    id: 518033342582,
    name: 'Belize',
    code: 'BZ',
    tax_name: 'GST',
    tax: 0,
    provinces: [],
  },
  {
    id: 539834679414,
    name: 'Benin',
    code: 'BJ',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 518033375350,
    name: 'Bermuda',
    code: 'BM',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 518030950518,
    name: 'Bhutan',
    code: 'BT',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 518035046518,
    name: 'Bolivia',
    code: 'BO',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 518032162934,
    name: 'Bosnia And Herzegovina',
    code: 'BA',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 539834712182,
    name: 'Botswana',
    code: 'BW',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 518035079286,
    name: 'Brazil',
    code: 'BR',
    tax_name: 'VAT',
    tax: 0,
    provinces: [
      {
        country_id: 518035079286,
        id: 5741018742902,
        name: 'Acre',
        code: 'AC',
        tax_name: 'ICMS',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035079286,
        id: 5741018775670,
        name: 'Alagoas',
        code: 'AL',
        tax_name: 'ICMS',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035079286,
        id: 5741018808438,
        name: 'Amapá',
        code: 'AP',
        tax_name: 'ICMS',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035079286,
        id: 5741018841206,
        name: 'Amazonas',
        code: 'AM',
        tax_name: 'ICMS',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035079286,
        id: 5741018873974,
        name: 'Bahia',
        code: 'BA',
        tax_name: 'ICMS',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035079286,
        id: 5741018906742,
        name: 'Ceará',
        code: 'CE',
        tax_name: 'ICMS',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035079286,
        id: 5741018939510,
        name: 'Distrito Federal',
        code: 'DF',
        tax_name: 'ICMS',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035079286,
        id: 5741018972278,
        name: 'Espírito Santo',
        code: 'ES',
        tax_name: 'ICMS',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035079286,
        id: 5741019005046,
        name: 'Goiás',
        code: 'GO',
        tax_name: 'ICMS',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035079286,
        id: 5741019037814,
        name: 'Maranhão',
        code: 'MA',
        tax_name: 'ICMS',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035079286,
        id: 5741019070582,
        name: 'Mato Grosso',
        code: 'MT',
        tax_name: 'ICMS',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035079286,
        id: 5741019103350,
        name: 'Mato Grosso do Sul',
        code: 'MS',
        tax_name: 'ICMS',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035079286,
        id: 5741019136118,
        name: 'Minas Gerais',
        code: 'MG',
        tax_name: 'ICMS',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035079286,
        id: 5741019168886,
        name: 'Pará',
        code: 'PA',
        tax_name: 'ICMS',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035079286,
        id: 5741019201654,
        name: 'Paraíba',
        code: 'PB',
        tax_name: 'ICMS',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035079286,
        id: 5741019234422,
        name: 'Paraná',
        code: 'PR',
        tax_name: 'ICMS',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035079286,
        id: 5741019267190,
        name: 'Pernambuco',
        code: 'PE',
        tax_name: 'ICMS',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035079286,
        id: 5741019299958,
        name: 'Piauí',
        code: 'PI',
        tax_name: 'ICMS',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035079286,
        id: 5741019398262,
        name: 'Rio de Janeiro',
        code: 'RJ',
        tax_name: 'ICMS',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035079286,
        id: 5741019332726,
        name: 'Rio Grande do Norte',
        code: 'RN',
        tax_name: 'ICMS',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035079286,
        id: 5741019365494,
        name: 'Rio Grande do Sul',
        code: 'RS',
        tax_name: 'ICMS',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035079286,
        id: 5741019431030,
        name: 'Rondônia',
        code: 'RO',
        tax_name: 'ICMS',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035079286,
        id: 5741019463798,
        name: 'Roraima',
        code: 'RR',
        tax_name: 'ICMS',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035079286,
        id: 5741019496566,
        name: 'Santa Catarina',
        code: 'SC',
        tax_name: 'ICMS',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035079286,
        id: 5741019529334,
        name: 'São Paulo',
        code: 'SP',
        tax_name: 'ICMS',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035079286,
        id: 5741019562102,
        name: 'Sergipe',
        code: 'SE',
        tax_name: 'ICMS',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035079286,
        id: 5741019594870,
        name: 'Tocantins',
        code: 'TO',
        tax_name: 'ICMS',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
    ],
  },
  {
    id: 539834744950,
    name: 'British Indian Ocean Territory',
    code: 'IO',
    tax_name: 'Tax',
    tax: 0,
    provinces: [],
  },
  {
    id: 518030983286,
    name: 'Brunei',
    code: 'BN',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 518032195702,
    name: 'Bulgaria',
    code: 'BG',
    tax_name: 'BG VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 539834777718,
    name: 'Burkina Faso',
    code: 'BF',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 539834810486,
    name: 'Burundi',
    code: 'BI',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 518031016054,
    name: 'Cambodia',
    code: 'KH',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 508180267126,
    name: 'Canada',
    code: 'CA',
    tax_name: 'GST',
    tax: 0,
    provinces: [
      {
        country_id: 508180267126,
        id: 5603100196982,
        name: 'Alberta',
        code: 'AB',
        tax_name: 'PST',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180267126,
        id: 5603100229750,
        name: 'British Columbia',
        code: 'BC',
        tax_name: 'PST',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180267126,
        id: 5603100262518,
        name: 'Manitoba',
        code: 'MB',
        tax_name: 'RST',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180267126,
        id: 5603100295286,
        name: 'New Brunswick',
        code: 'NB',
        tax_name: 'HST',
        tax_type: 'harmonized',
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180267126,
        id: 5603100328054,
        name: 'Newfoundland and Labrador',
        code: 'NL',
        tax_name: 'HST',
        tax_type: 'harmonized',
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180267126,
        id: 5603100360822,
        name: 'Northwest Territories',
        code: 'NT',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180267126,
        id: 5603100393590,
        name: 'Nova Scotia',
        code: 'NS',
        tax_name: 'HST',
        tax_type: 'harmonized',
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180267126,
        id: 5603100426358,
        name: 'Nunavut',
        code: 'NU',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180267126,
        id: 5603100459126,
        name: 'Ontario',
        code: 'ON',
        tax_name: 'HST',
        tax_type: 'harmonized',
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180267126,
        id: 5603100491894,
        name: 'Prince Edward Island',
        code: 'PE',
        tax_name: 'HST',
        tax_type: 'harmonized',
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180267126,
        id: 5603100524662,
        name: 'Quebec',
        code: 'QC',
        tax_name: 'QST',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180267126,
        id: 5603100557430,
        name: 'Saskatchewan',
        code: 'SK',
        tax_name: 'PST',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180267126,
        id: 5603100590198,
        name: 'Yukon',
        code: 'YT',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
    ],
  },
  {
    id: 539834876022,
    name: 'Cape Verde',
    code: 'CV',
    tax_name: 'IVA',
    tax: 0,
    provinces: [],
  },
  {
    id: 518033440886,
    name: 'Caribbean Netherlands',
    code: 'BQ',
    tax_name: 'ABB',
    tax: 0,
    provinces: [],
  },
  {
    id: 518033473654,
    name: 'Cayman Islands',
    code: 'KY',
    tax_name: 'Tax',
    tax: 0,
    provinces: [],
  },
  {
    id: 539834908790,
    name: 'Central African Republic',
    code: 'CF',
    tax_name: 'Tax',
    tax: 0,
    provinces: [],
  },
  {
    id: 539834941558,
    name: 'Chad',
    code: 'TD',
    tax_name: 'Tax',
    tax: 0,
    provinces: [],
  },
  {
    id: 518035112054,
    name: 'Chile',
    code: 'CL',
    tax_name: 'VAT',
    tax: 0,
    provinces: [
      {
        country_id: 518035112054,
        id: 5741019693174,
        name: 'Antofagasta',
        code: 'AN',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035112054,
        id: 5741019988086,
        name: 'Araucanía',
        code: 'AR',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035112054,
        id: 5741019627638,
        name: 'Arica and Parinacota',
        code: 'AP',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035112054,
        id: 5741019725942,
        name: 'Atacama',
        code: 'AT',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035112054,
        id: 5741020086390,
        name: 'Aysén',
        code: 'AI',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035112054,
        id: 5741019955318,
        name: 'Biobío',
        code: 'BI',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035112054,
        id: 5741019758710,
        name: 'Coquimbo',
        code: 'CO',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035112054,
        id: 5741020053622,
        name: 'Los Lagos',
        code: 'LL',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035112054,
        id: 5741020020854,
        name: 'Los Ríos',
        code: 'LR',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035112054,
        id: 5741020119158,
        name: 'Magallanes',
        code: 'MA',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035112054,
        id: 5741019889782,
        name: 'Maule',
        code: 'ML',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035112054,
        id: 5741019922550,
        name: 'Ñuble',
        code: 'NB',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035112054,
        id: 5741019857014,
        name: "O'Higgins",
        code: 'LI',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035112054,
        id: 5741019824246,
        name: 'Santiago',
        code: 'RM',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035112054,
        id: 5741019660406,
        name: 'Tarapacá',
        code: 'TA',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035112054,
        id: 5741019791478,
        name: 'Valparaíso',
        code: 'VS',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
    ],
  },
  {
    id: 539836612726,
    name: 'China',
    code: 'CN',
    tax_name: 'VAT',
    tax: 0,
    provinces: [
      {
        country_id: 539836612726,
        id: 6043602780278,
        name: 'Anhui',
        code: 'AH',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539836612726,
        id: 6043602813046,
        name: 'Beijing',
        code: 'BJ',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539836612726,
        id: 6043602845814,
        name: 'Chongqing',
        code: 'CQ',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539836612726,
        id: 6043602878582,
        name: 'Fujian',
        code: 'FJ',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539836612726,
        id: 6043602911350,
        name: 'Gansu',
        code: 'GS',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539836612726,
        id: 6043602944118,
        name: 'Guangdong',
        code: 'GD',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539836612726,
        id: 6043602976886,
        name: 'Guangxi',
        code: 'GX',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539836612726,
        id: 6043603009654,
        name: 'Guizhou',
        code: 'GZ',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539836612726,
        id: 6043603042422,
        name: 'Hainan',
        code: 'HI',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539836612726,
        id: 6043603075190,
        name: 'Hebei',
        code: 'HE',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539836612726,
        id: 6043603107958,
        name: 'Heilongjiang',
        code: 'HL',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539836612726,
        id: 6043603140726,
        name: 'Henan',
        code: 'HA',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539836612726,
        id: 6043603173494,
        name: 'Hubei',
        code: 'HB',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539836612726,
        id: 6043603206262,
        name: 'Hunan',
        code: 'HN',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539836612726,
        id: 6043603239030,
        name: 'Inner Mongolia',
        code: 'NM',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539836612726,
        id: 6043603271798,
        name: 'Jiangsu',
        code: 'JS',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539836612726,
        id: 6043603304566,
        name: 'Jiangxi',
        code: 'JX',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539836612726,
        id: 6043603337334,
        name: 'Jilin',
        code: 'JL',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539836612726,
        id: 6043603370102,
        name: 'Liaoning',
        code: 'LN',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539836612726,
        id: 6043603402870,
        name: 'Ningxia',
        code: 'NX',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539836612726,
        id: 6043603435638,
        name: 'Qinghai',
        code: 'QH',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539836612726,
        id: 6043603468406,
        name: 'Shaanxi',
        code: 'SN',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539836612726,
        id: 6043603501174,
        name: 'Shandong',
        code: 'SD',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539836612726,
        id: 6043603533942,
        name: 'Shanghai',
        code: 'SH',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539836612726,
        id: 6043603566710,
        name: 'Shanxi',
        code: 'SX',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539836612726,
        id: 6043603599478,
        name: 'Sichuan',
        code: 'SC',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539836612726,
        id: 6043603632246,
        name: 'Tianjin',
        code: 'TJ',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539836612726,
        id: 6043603665014,
        name: 'Xinjiang',
        code: 'XJ',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539836612726,
        id: 6043603697782,
        name: 'Xizang',
        code: 'YZ',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539836612726,
        id: 6043603730550,
        name: 'Yunnan',
        code: 'YN',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539836612726,
        id: 6043603763318,
        name: 'Zhejiang',
        code: 'ZJ',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
    ],
  },
  {
    id: 518034358390,
    name: 'Christmas Island',
    code: 'CX',
    tax_name: 'Tax',
    tax: 0,
    provinces: [],
  },
  {
    id: 518034391158,
    name: 'Cocos (Keeling) Islands',
    code: 'CC',
    tax_name: 'Tax',
    tax: 0,
    provinces: [],
  },
  {
    id: 518035144822,
    name: 'Colombia',
    code: 'CO',
    tax_name: 'VAT',
    tax: 0,
    provinces: [
      {
        country_id: 518035144822,
        id: 5741020184694,
        name: 'Amazonas',
        code: 'AMA',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035144822,
        id: 5741020217462,
        name: 'Antioquia',
        code: 'ANT',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035144822,
        id: 5741020250230,
        name: 'Arauca',
        code: 'ARA',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035144822,
        id: 5741020282998,
        name: 'Atlántico',
        code: 'ATL',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035144822,
        id: 5741020151926,
        name: 'Bogotá, D.C.',
        code: 'DC',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035144822,
        id: 5741020315766,
        name: 'Bolívar',
        code: 'BOL',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035144822,
        id: 5741020348534,
        name: 'Boyacá',
        code: 'BOY',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035144822,
        id: 5741020381302,
        name: 'Caldas',
        code: 'CAL',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035144822,
        id: 5741020414070,
        name: 'Caquetá',
        code: 'CAQ',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035144822,
        id: 5741020446838,
        name: 'Casanare',
        code: 'CAS',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035144822,
        id: 5741020479606,
        name: 'Cauca',
        code: 'CAU',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035144822,
        id: 5741020512374,
        name: 'Cesar',
        code: 'CES',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035144822,
        id: 5741020545142,
        name: 'Chocó',
        code: 'CHO',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035144822,
        id: 5741020577910,
        name: 'Córdoba',
        code: 'COR',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035144822,
        id: 5741020610678,
        name: 'Cundinamarca',
        code: 'CUN',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035144822,
        id: 5741020643446,
        name: 'Guainía',
        code: 'GUA',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035144822,
        id: 5741020676214,
        name: 'Guaviare',
        code: 'GUV',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035144822,
        id: 5741020708982,
        name: 'Huila',
        code: 'HUI',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035144822,
        id: 5741020741750,
        name: 'La Guajira',
        code: 'LAG',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035144822,
        id: 5741020774518,
        name: 'Magdalena',
        code: 'MAG',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035144822,
        id: 5741020807286,
        name: 'Meta',
        code: 'MET',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035144822,
        id: 5741020840054,
        name: 'Nariño',
        code: 'NAR',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035144822,
        id: 5741020872822,
        name: 'Norte de Santander',
        code: 'NSA',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035144822,
        id: 5741020905590,
        name: 'Putumayo',
        code: 'PUT',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035144822,
        id: 5741020938358,
        name: 'Quindío',
        code: 'QUI',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035144822,
        id: 5741020971126,
        name: 'Risaralda',
        code: 'RIS',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035144822,
        id: 5741021003894,
        name: 'San Andrés, Providencia y Santa Catalina',
        code: 'SAP',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035144822,
        id: 5741021036662,
        name: 'Santander',
        code: 'SAN',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035144822,
        id: 5741021069430,
        name: 'Sucre',
        code: 'SUC',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035144822,
        id: 5741021102198,
        name: 'Tolima',
        code: 'TOL',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035144822,
        id: 5741021134966,
        name: 'Valle del Cauca',
        code: 'VAC',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035144822,
        id: 5741021167734,
        name: 'Vaupés',
        code: 'VAU',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035144822,
        id: 5741021200502,
        name: 'Vichada',
        code: 'VID',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
    ],
  },
  {
    id: 539834974326,
    name: 'Comoros',
    code: 'KM',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 539835007094,
    name: 'Congo',
    code: 'CG',
    tax_name: 'Tax',
    tax: 0,
    provinces: [],
  },
  {
    id: 539835039862,
    name: 'Congo, The Democratic Republic Of The',
    code: 'CD',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 518034423926,
    name: 'Cook Islands',
    code: 'CK',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 518033506422,
    name: 'Costa Rica',
    code: 'CR',
    tax_name: 'VAT',
    tax: 0,
    provinces: [
      {
        country_id: 518033506422,
        id: 5741015072886,
        name: 'Alajuela',
        code: 'CR-A',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518033506422,
        id: 5741015105654,
        name: 'Cartago',
        code: 'CR-C',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518033506422,
        id: 5741015138422,
        name: 'Guanacaste',
        code: 'CR-G',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518033506422,
        id: 5741015171190,
        name: 'Heredia',
        code: 'CR-H',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518033506422,
        id: 5741015203958,
        name: 'Limón',
        code: 'CR-L',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518033506422,
        id: 5741015236726,
        name: 'Puntarenas',
        code: 'CR-P',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518033506422,
        id: 5741015269494,
        name: 'San José',
        code: 'CR-SJ',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
    ],
  },
  {
    id: 518032228470,
    name: 'Croatia',
    code: 'HR',
    tax_name: 'HR VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 518033539190,
    name: 'Curaçao',
    code: 'CW',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 518031048822,
    name: 'Cyprus',
    code: 'CY',
    tax_name: 'CY VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 508180332662,
    name: 'Czech Republic',
    code: 'CZ',
    tax_name: 'CZ VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 539835072630,
    name: "Côte d'Ivoire",
    code: 'CI',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 508180398198,
    name: 'Denmark',
    code: 'DK',
    tax_name: 'DK Moms',
    tax: 0,
    provinces: [],
  },
  {
    id: 539835105398,
    name: 'Djibouti',
    code: 'DJ',
    tax_name: 'TVA',
    tax: 0,
    provinces: [],
  },
  {
    id: 518033571958,
    name: 'Dominica',
    code: 'DM',
    tax_name: 'Tax',
    tax: 0,
    provinces: [],
  },
  {
    id: 518033604726,
    name: 'Dominican Republic',
    code: 'DO',
    tax_name: 'ITBIS',
    tax: 0,
    provinces: [],
  },
  {
    id: 518035177590,
    name: 'Ecuador',
    code: 'EC',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 539835138166,
    name: 'Egypt',
    code: 'EG',
    tax_name: 'GST',
    tax: 0,
    provinces: [
      {
        country_id: 539835138166,
        id: 6043600617590,
        name: '6th of October',
        code: 'SU',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539835138166,
        id: 6043600650358,
        name: 'Al Sharqia',
        code: 'SHR',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539835138166,
        id: 6043600683126,
        name: 'Alexandria',
        code: 'ALX',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539835138166,
        id: 6043600715894,
        name: 'Aswan',
        code: 'ASN',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539835138166,
        id: 6043600748662,
        name: 'Asyut',
        code: 'AST',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539835138166,
        id: 6043600781430,
        name: 'Beheira',
        code: 'BH',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539835138166,
        id: 6043600814198,
        name: 'Beni Suef',
        code: 'BNS',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539835138166,
        id: 6043600846966,
        name: 'Cairo',
        code: 'C',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539835138166,
        id: 6043600879734,
        name: 'Dakahlia',
        code: 'DK',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539835138166,
        id: 6043600912502,
        name: 'Damietta',
        code: 'DT',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539835138166,
        id: 6043600945270,
        name: 'Faiyum',
        code: 'FYM',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539835138166,
        id: 6043600978038,
        name: 'Gharbia',
        code: 'GH',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539835138166,
        id: 6043601010806,
        name: 'Giza',
        code: 'GZ',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539835138166,
        id: 6043601043574,
        name: 'Helwan',
        code: 'HU',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539835138166,
        id: 6043601076342,
        name: 'Ismailia',
        code: 'IS',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539835138166,
        id: 6043601109110,
        name: 'Kafr el-Sheikh',
        code: 'KFS',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539835138166,
        id: 6043601141878,
        name: 'Luxor',
        code: 'LX',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539835138166,
        id: 6043601174646,
        name: 'Matrouh',
        code: 'MT',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539835138166,
        id: 6043601207414,
        name: 'Minya',
        code: 'MN',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539835138166,
        id: 6043601240182,
        name: 'Monufia',
        code: 'MNF',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539835138166,
        id: 6043601272950,
        name: 'New Valley',
        code: 'WAD',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539835138166,
        id: 6043601305718,
        name: 'North Sinai',
        code: 'SIN',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539835138166,
        id: 6043601338486,
        name: 'Port Said',
        code: 'PTS',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539835138166,
        id: 6043601371254,
        name: 'Qalyubia',
        code: 'KB',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539835138166,
        id: 6043601404022,
        name: 'Qena',
        code: 'KN',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539835138166,
        id: 6043601436790,
        name: 'Red Sea',
        code: 'BA',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539835138166,
        id: 6043601469558,
        name: 'Sohag',
        code: 'SHG',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539835138166,
        id: 6043601502326,
        name: 'South Sinai',
        code: 'JS',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539835138166,
        id: 6043601535094,
        name: 'Suez',
        code: 'SUZ',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
    ],
  },
  {
    id: 518033637494,
    name: 'El Salvador',
    code: 'SV',
    tax_name: 'VAT',
    tax: 0,
    provinces: [
      {
        country_id: 518033637494,
        id: 5741015302262,
        name: 'Ahuachapán',
        code: 'SV-AH',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518033637494,
        id: 5741015335030,
        name: 'Cabañas',
        code: 'SV-CA',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518033637494,
        id: 5741015367798,
        name: 'Chalatenango',
        code: 'SV-CH',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518033637494,
        id: 5741015400566,
        name: 'Cuscatlán',
        code: 'SV-CU',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518033637494,
        id: 5741015433334,
        name: 'La Libertad',
        code: 'SV-LI',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518033637494,
        id: 5741015466102,
        name: 'La Paz',
        code: 'SV-PA',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518033637494,
        id: 5741015498870,
        name: 'La Unión',
        code: 'SV-UN',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518033637494,
        id: 5741015531638,
        name: 'Morazán',
        code: 'SV-MO',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518033637494,
        id: 5741015564406,
        name: 'San Miguel',
        code: 'SV-SM',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518033637494,
        id: 5741015597174,
        name: 'San Salvador',
        code: 'SV-SS',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518033637494,
        id: 5741015629942,
        name: 'San Vicente',
        code: 'SV-SV',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518033637494,
        id: 5741015662710,
        name: 'Santa Ana',
        code: 'SV-SA',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518033637494,
        id: 5741015695478,
        name: 'Sonsonate',
        code: 'SV-SO',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518033637494,
        id: 5741015728246,
        name: 'Usulután',
        code: 'SV-US',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
    ],
  },
  {
    id: 539835170934,
    name: 'Equatorial Guinea',
    code: 'GQ',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 539835203702,
    name: 'Eritrea',
    code: 'ER',
    tax_name: 'Tax',
    tax: 0,
    provinces: [],
  },
  {
    id: 518032261238,
    name: 'Estonia',
    code: 'EE',
    tax_name: 'EE VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 539835236470,
    name: 'Eswatini',
    code: 'SZ',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 539835269238,
    name: 'Ethiopia',
    code: 'ET',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 518035210358,
    name: 'Falkland Islands (Malvinas)',
    code: 'FK',
    tax_name: 'Tax',
    tax: 0,
    provinces: [],
  },
  {
    id: 518032294006,
    name: 'Faroe Islands',
    code: 'FO',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 518034456694,
    name: 'Fiji',
    code: 'FJ',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 508180463734,
    name: 'Finland',
    code: 'FI',
    tax_name: 'FI ALV',
    tax: 0,
    provinces: [],
  },
  {
    id: 508180496502,
    name: 'France',
    code: 'FR',
    tax_name: 'FR TVA',
    tax: 0,
    provinces: [],
  },
  {
    id: 518035243126,
    name: 'French Guiana',
    code: 'GF',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 518034489462,
    name: 'French Polynesia',
    code: 'PF',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 539835302006,
    name: 'French Southern Territories',
    code: 'TF',
    tax_name: 'Tax',
    tax: 0,
    provinces: [],
  },
  {
    id: 539835334774,
    name: 'Gabon',
    code: 'GA',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 539835367542,
    name: 'Gambia',
    code: 'GM',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 518031081590,
    name: 'Georgia',
    code: 'GE',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 508180365430,
    name: 'Germany',
    code: 'DE',
    tax_name: 'DE MwSt',
    tax: 0,
    provinces: [],
  },
  {
    id: 539835400310,
    name: 'Ghana',
    code: 'GH',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 518032326774,
    name: 'Gibraltar',
    code: 'GI',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 518032359542,
    name: 'Greece',
    code: 'GR',
    tax_name: 'GR VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 518033670262,
    name: 'Greenland',
    code: 'GL',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 518033703030,
    name: 'Grenada',
    code: 'GD',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 518033735798,
    name: 'Guadeloupe',
    code: 'GP',
    tax_name: 'TVA',
    tax: 0,
    provinces: [],
  },
  {
    id: 518033768566,
    name: 'Guatemala',
    code: 'GT',
    tax_name: 'IVA',
    tax: 0,
    provinces: [
      {
        country_id: 518033768566,
        id: 5741015761014,
        name: 'Alta Verapaz',
        code: 'AVE',
        tax_name: 'IVA',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518033768566,
        id: 5741015793782,
        name: 'Baja Verapaz',
        code: 'BVE',
        tax_name: 'IVA',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518033768566,
        id: 5741015826550,
        name: 'Chimaltenango',
        code: 'CMT',
        tax_name: 'IVA',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518033768566,
        id: 5741015859318,
        name: 'Chiquimula',
        code: 'CQM',
        tax_name: 'IVA',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518033768566,
        id: 5741015892086,
        name: 'El Progreso',
        code: 'EPR',
        tax_name: 'IVA',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518033768566,
        id: 5741015924854,
        name: 'Escuintla',
        code: 'ESC',
        tax_name: 'IVA',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518033768566,
        id: 5741015957622,
        name: 'Guatemala',
        code: 'GUA',
        tax_name: 'IVA',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518033768566,
        id: 5741015990390,
        name: 'Huehuetenango',
        code: 'HUE',
        tax_name: 'IVA',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518033768566,
        id: 5741016023158,
        name: 'Izabal',
        code: 'IZA',
        tax_name: 'IVA',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518033768566,
        id: 5741016055926,
        name: 'Jalapa',
        code: 'JAL',
        tax_name: 'IVA',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518033768566,
        id: 5741016088694,
        name: 'Jutiapa',
        code: 'JUT',
        tax_name: 'IVA',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518033768566,
        id: 5741016121462,
        name: 'Petén',
        code: 'PET',
        tax_name: 'IVA',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518033768566,
        id: 5741016154230,
        name: 'Quetzaltenango',
        code: 'QUE',
        tax_name: 'IVA',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518033768566,
        id: 5741016186998,
        name: 'Quiché',
        code: 'QUI',
        tax_name: 'IVA',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518033768566,
        id: 5741016219766,
        name: 'Retalhuleu',
        code: 'RET',
        tax_name: 'IVA',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518033768566,
        id: 5741016252534,
        name: 'Sacatepéquez',
        code: 'SAC',
        tax_name: 'IVA',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518033768566,
        id: 5741016285302,
        name: 'San Marcos',
        code: 'SMA',
        tax_name: 'IVA',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518033768566,
        id: 5741016318070,
        name: 'Santa Rosa',
        code: 'SRO',
        tax_name: 'IVA',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518033768566,
        id: 5741016350838,
        name: 'Sololá',
        code: 'SOL',
        tax_name: 'IVA',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518033768566,
        id: 5741016383606,
        name: 'Suchitepéquez',
        code: 'SUC',
        tax_name: 'IVA',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518033768566,
        id: 5741016416374,
        name: 'Totonicapán',
        code: 'TOT',
        tax_name: 'IVA',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518033768566,
        id: 5741016449142,
        name: 'Zacapa',
        code: 'ZAC',
        tax_name: 'IVA',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
    ],
  },
  {
    id: 518032392310,
    name: 'Guernsey',
    code: 'GG',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 539835433078,
    name: 'Guinea',
    code: 'GN',
    tax_name: 'TVA',
    tax: 0,
    provinces: [],
  },
  {
    id: 539835465846,
    name: 'Guinea Bissau',
    code: 'GW',
    tax_name: 'IGV',
    tax: 0,
    provinces: [],
  },
  {
    id: 518035275894,
    name: 'Guyana',
    code: 'GY',
    tax_name: 'GST',
    tax: 0,
    provinces: [],
  },
  {
    id: 518033801334,
    name: 'Haiti',
    code: 'HT',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 518033145974,
    name: 'Holy See (Vatican City State)',
    code: 'VA',
    tax_name: 'Tax',
    tax: 0,
    provinces: [],
  },
  {
    id: 518033834102,
    name: 'Honduras',
    code: 'HN',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 508180562038,
    name: 'Hong Kong',
    code: 'HK',
    tax_name: 'VAT',
    tax: 0,
    provinces: [
      {
        country_id: 508180562038,
        id: 5603102490742,
        name: 'Hong Kong Island',
        code: 'HK',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180562038,
        id: 5603102523510,
        name: 'Kowloon',
        code: 'KL',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180562038,
        id: 5603102556278,
        name: 'New Territories',
        code: 'NT',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
    ],
  },
  {
    id: 518032425078,
    name: 'Hungary',
    code: 'HU',
    tax_name: 'HU VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 518032457846,
    name: 'Iceland',
    code: 'IS',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 539836645494,
    name: 'India',
    code: 'IN',
    tax_name: 'CGST',
    tax: 0,
    provinces: [
      {
        country_id: 539836645494,
        id: 6043603796086,
        name: 'Andaman and Nicobar Islands',
        code: 'AN',
        tax_name: 'IGST',
        tax_type: 'harmonized',
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539836645494,
        id: 6043603828854,
        name: 'Andhra Pradesh',
        code: 'AP',
        tax_name: 'IGST',
        tax_type: 'harmonized',
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539836645494,
        id: 6043603861622,
        name: 'Arunachal Pradesh',
        code: 'AR',
        tax_name: 'IGST',
        tax_type: 'harmonized',
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539836645494,
        id: 6043603894390,
        name: 'Assam',
        code: 'AS',
        tax_name: 'IGST',
        tax_type: 'harmonized',
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539836645494,
        id: 6043603927158,
        name: 'Bihar',
        code: 'BR',
        tax_name: 'IGST',
        tax_type: 'harmonized',
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539836645494,
        id: 6043603959926,
        name: 'Chandigarh',
        code: 'CH',
        tax_name: 'IGST',
        tax_type: 'harmonized',
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539836645494,
        id: 6043603992694,
        name: 'Chhattisgarh',
        code: 'CG',
        tax_name: 'IGST',
        tax_type: 'harmonized',
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539836645494,
        id: 6043604025462,
        name: 'Dadra and Nagar Haveli',
        code: 'DN',
        tax_name: 'IGST',
        tax_type: 'harmonized',
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539836645494,
        id: 6043604058230,
        name: 'Daman and Diu',
        code: 'DD',
        tax_name: 'IGST',
        tax_type: 'harmonized',
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539836645494,
        id: 6043604090998,
        name: 'Delhi',
        code: 'DL',
        tax_name: 'IGST',
        tax_type: 'harmonized',
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539836645494,
        id: 6043604123766,
        name: 'Goa',
        code: 'GA',
        tax_name: 'IGST',
        tax_type: 'harmonized',
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539836645494,
        id: 6043604156534,
        name: 'Gujarat',
        code: 'GJ',
        tax_name: 'IGST',
        tax_type: 'harmonized',
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539836645494,
        id: 6043604189302,
        name: 'Haryana',
        code: 'HR',
        tax_name: 'IGST',
        tax_type: 'harmonized',
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539836645494,
        id: 6043604222070,
        name: 'Himachal Pradesh',
        code: 'HP',
        tax_name: 'IGST',
        tax_type: 'harmonized',
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539836645494,
        id: 6043604254838,
        name: 'Jammu and Kashmir',
        code: 'JK',
        tax_name: 'IGST',
        tax_type: 'harmonized',
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539836645494,
        id: 6043604287606,
        name: 'Jharkhand',
        code: 'JH',
        tax_name: 'IGST',
        tax_type: 'harmonized',
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539836645494,
        id: 6043604320374,
        name: 'Karnataka',
        code: 'KA',
        tax_name: 'SGST',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539836645494,
        id: 6043604353142,
        name: 'Kerala',
        code: 'KL',
        tax_name: 'IGST',
        tax_type: 'harmonized',
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539836645494,
        id: 6043604385910,
        name: 'Ladakh',
        code: 'LA',
        tax_name: 'IGST',
        tax_type: 'harmonized',
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539836645494,
        id: 6043604418678,
        name: 'Lakshadweep',
        code: 'LD',
        tax_name: 'IGST',
        tax_type: 'harmonized',
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539836645494,
        id: 6043604451446,
        name: 'Madhya Pradesh',
        code: 'MP',
        tax_name: 'IGST',
        tax_type: 'harmonized',
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539836645494,
        id: 6043604484214,
        name: 'Maharashtra',
        code: 'MH',
        tax_name: 'IGST',
        tax_type: 'harmonized',
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539836645494,
        id: 6043604516982,
        name: 'Manipur',
        code: 'MN',
        tax_name: 'IGST',
        tax_type: 'harmonized',
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539836645494,
        id: 6043604549750,
        name: 'Meghalaya',
        code: 'ML',
        tax_name: 'IGST',
        tax_type: 'harmonized',
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539836645494,
        id: 6043604582518,
        name: 'Mizoram',
        code: 'MZ',
        tax_name: 'IGST',
        tax_type: 'harmonized',
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539836645494,
        id: 6043604615286,
        name: 'Nagaland',
        code: 'NL',
        tax_name: 'IGST',
        tax_type: 'harmonized',
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539836645494,
        id: 6043604648054,
        name: 'Odisha',
        code: 'OR',
        tax_name: 'IGST',
        tax_type: 'harmonized',
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539836645494,
        id: 6043604680822,
        name: 'Puducherry',
        code: 'PY',
        tax_name: 'IGST',
        tax_type: 'harmonized',
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539836645494,
        id: 6043604713590,
        name: 'Punjab',
        code: 'PB',
        tax_name: 'IGST',
        tax_type: 'harmonized',
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539836645494,
        id: 6043604746358,
        name: 'Rajasthan',
        code: 'RJ',
        tax_name: 'IGST',
        tax_type: 'harmonized',
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539836645494,
        id: 6043604779126,
        name: 'Sikkim',
        code: 'SK',
        tax_name: 'IGST',
        tax_type: 'harmonized',
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539836645494,
        id: 6043604811894,
        name: 'Tamil Nadu',
        code: 'TN',
        tax_name: 'IGST',
        tax_type: 'harmonized',
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539836645494,
        id: 6043604844662,
        name: 'Telangana',
        code: 'TS',
        tax_name: 'IGST',
        tax_type: 'harmonized',
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539836645494,
        id: 6043604877430,
        name: 'Tripura',
        code: 'TR',
        tax_name: 'IGST',
        tax_type: 'harmonized',
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539836645494,
        id: 6043604910198,
        name: 'Uttar Pradesh',
        code: 'UP',
        tax_name: 'IGST',
        tax_type: 'harmonized',
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539836645494,
        id: 6043604942966,
        name: 'Uttarakhand',
        code: 'UK',
        tax_name: 'IGST',
        tax_type: 'harmonized',
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539836645494,
        id: 6043604975734,
        name: 'West Bengal',
        code: 'WB',
        tax_name: 'IGST',
        tax_type: 'harmonized',
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
    ],
  },
  {
    id: 518031114358,
    name: 'Indonesia',
    code: 'ID',
    tax_name: 'VAT',
    tax: 0,
    provinces: [
      {
        country_id: 518031114358,
        id: 5741004456054,
        name: 'Aceh',
        code: 'AC',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031114358,
        id: 5741004488822,
        name: 'Bali',
        code: 'BA',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031114358,
        id: 5741004521590,
        name: 'Bangka Belitung',
        code: 'BB',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031114358,
        id: 5741004554358,
        name: 'Banten',
        code: 'BT',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031114358,
        id: 5741004587126,
        name: 'Bengkulu',
        code: 'BE',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031114358,
        id: 5741004619894,
        name: 'Gorontalo',
        code: 'GO',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031114358,
        id: 5741004652662,
        name: 'Jakarta',
        code: 'JK',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031114358,
        id: 5741004685430,
        name: 'Jambi',
        code: 'JA',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031114358,
        id: 5741004718198,
        name: 'Jawa Barat',
        code: 'JB',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031114358,
        id: 5741004750966,
        name: 'Jawa Tengah',
        code: 'JT',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031114358,
        id: 5741004783734,
        name: 'Jawa Timur',
        code: 'JI',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031114358,
        id: 5741004816502,
        name: 'Kalimantan Barat',
        code: 'KB',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031114358,
        id: 5741004849270,
        name: 'Kalimantan Selatan',
        code: 'KS',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031114358,
        id: 5741004882038,
        name: 'Kalimantan Tengah',
        code: 'KT',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031114358,
        id: 5741004914806,
        name: 'Kalimantan Timur',
        code: 'KI',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031114358,
        id: 5741004947574,
        name: 'Kalimantan Utara',
        code: 'KU',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031114358,
        id: 5741004980342,
        name: 'Kepulauan Riau',
        code: 'KR',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031114358,
        id: 5741005013110,
        name: 'Lampung',
        code: 'LA',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031114358,
        id: 5741005045878,
        name: 'Maluku',
        code: 'MA',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031114358,
        id: 5741005078646,
        name: 'Maluku Utara',
        code: 'MU',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031114358,
        id: 5741005111414,
        name: 'North Sumatra',
        code: 'SU',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031114358,
        id: 5741005144182,
        name: 'Nusa Tenggara Barat',
        code: 'NB',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031114358,
        id: 5741005176950,
        name: 'Nusa Tenggara Timur',
        code: 'NT',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031114358,
        id: 5741005209718,
        name: 'Papua',
        code: 'PA',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031114358,
        id: 5741005242486,
        name: 'Papua Barat',
        code: 'PB',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031114358,
        id: 5741005275254,
        name: 'Riau',
        code: 'RI',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031114358,
        id: 5741005308022,
        name: 'South Sumatra',
        code: 'SS',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031114358,
        id: 5741005340790,
        name: 'Sulawesi Barat',
        code: 'SR',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031114358,
        id: 5741005373558,
        name: 'Sulawesi Selatan',
        code: 'SN',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031114358,
        id: 5741005406326,
        name: 'Sulawesi Tengah',
        code: 'ST',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031114358,
        id: 5741005439094,
        name: 'Sulawesi Tenggara',
        code: 'SG',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031114358,
        id: 5741005471862,
        name: 'Sulawesi Utara',
        code: 'SA',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031114358,
        id: 5741005504630,
        name: 'West Sumatra',
        code: 'SB',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031114358,
        id: 5741005537398,
        name: 'Yogyakarta',
        code: 'YO',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
    ],
  },
  {
    id: 539836678262,
    name: 'Iraq',
    code: 'IQ',
    tax_name: 'Tax',
    tax: 0,
    provinces: [],
  },
  {
    id: 508180594806,
    name: 'Ireland',
    code: 'IE',
    tax_name: 'IE VAT',
    tax: 0,
    provinces: [
      {
        country_id: 508180594806,
        id: 5603102589046,
        name: 'Carlow',
        code: 'CW',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180594806,
        id: 5603102621814,
        name: 'Cavan',
        code: 'CN',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180594806,
        id: 5603102654582,
        name: 'Clare',
        code: 'CE',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180594806,
        id: 5603102687350,
        name: 'Cork',
        code: 'CO',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180594806,
        id: 5603102720118,
        name: 'Donegal',
        code: 'DL',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180594806,
        id: 5603102752886,
        name: 'Dublin',
        code: 'D',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180594806,
        id: 5603102785654,
        name: 'Galway',
        code: 'G',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180594806,
        id: 5603102818422,
        name: 'Kerry',
        code: 'KY',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180594806,
        id: 5603102851190,
        name: 'Kildare',
        code: 'KE',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180594806,
        id: 5603102883958,
        name: 'Kilkenny',
        code: 'KK',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180594806,
        id: 5603102916726,
        name: 'Laois',
        code: 'LS',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180594806,
        id: 5603102949494,
        name: 'Leitrim',
        code: 'LM',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180594806,
        id: 5603102982262,
        name: 'Limerick',
        code: 'LK',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180594806,
        id: 5603103015030,
        name: 'Longford',
        code: 'LD',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180594806,
        id: 5603103047798,
        name: 'Louth',
        code: 'LH',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180594806,
        id: 5603103080566,
        name: 'Mayo',
        code: 'MO',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180594806,
        id: 5603103113334,
        name: 'Meath',
        code: 'MH',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180594806,
        id: 5603103146102,
        name: 'Monaghan',
        code: 'MN',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180594806,
        id: 5603103178870,
        name: 'Offaly',
        code: 'OY',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180594806,
        id: 5603103211638,
        name: 'Roscommon',
        code: 'RN',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180594806,
        id: 5603103244406,
        name: 'Sligo',
        code: 'SO',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180594806,
        id: 5603103277174,
        name: 'Tipperary',
        code: 'TA',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180594806,
        id: 5603103309942,
        name: 'Waterford',
        code: 'WD',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180594806,
        id: 5603103342710,
        name: 'Westmeath',
        code: 'WH',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180594806,
        id: 5603103375478,
        name: 'Wexford',
        code: 'WX',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180594806,
        id: 5603103408246,
        name: 'Wicklow',
        code: 'WW',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
    ],
  },
  {
    id: 518032490614,
    name: 'Isle Of Man',
    code: 'IM',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 508180627574,
    name: 'Israel',
    code: 'IL',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 508180660342,
    name: 'Italy',
    code: 'IT',
    tax_name: 'IT IVA',
    tax: 0,
    provinces: [
      {
        country_id: 508180660342,
        id: 5603103441014,
        name: 'Agrigento',
        code: 'AG',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603103473782,
        name: 'Alessandria',
        code: 'AL',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603103506550,
        name: 'Ancona',
        code: 'AN',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603103539318,
        name: 'Aosta',
        code: 'AO',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603103572086,
        name: 'Arezzo',
        code: 'AR',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603103604854,
        name: 'Ascoli Piceno',
        code: 'AP',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603103637622,
        name: 'Asti',
        code: 'AT',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603103670390,
        name: 'Avellino',
        code: 'AV',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603103703158,
        name: 'Bari',
        code: 'BA',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603103735926,
        name: 'Barletta-Andria-Trani',
        code: 'BT',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603103768694,
        name: 'Belluno',
        code: 'BL',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603103801462,
        name: 'Benevento',
        code: 'BN',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603103834230,
        name: 'Bergamo',
        code: 'BG',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603103866998,
        name: 'Biella',
        code: 'BI',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603103899766,
        name: 'Bologna',
        code: 'BO',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603103932534,
        name: 'Bolzano',
        code: 'BZ',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603103965302,
        name: 'Brescia',
        code: 'BS',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603103998070,
        name: 'Brindisi',
        code: 'BR',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603104030838,
        name: 'Cagliari',
        code: 'CA',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603104063606,
        name: 'Caltanissetta',
        code: 'CL',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603104096374,
        name: 'Campobasso',
        code: 'CB',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603104129142,
        name: 'Carbonia-Iglesias',
        code: 'CI',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603104161910,
        name: 'Caserta',
        code: 'CE',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603104194678,
        name: 'Catania',
        code: 'CT',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603104227446,
        name: 'Catanzaro',
        code: 'CZ',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603104260214,
        name: 'Chieti',
        code: 'CH',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603104292982,
        name: 'Como',
        code: 'CO',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603104325750,
        name: 'Cosenza',
        code: 'CS',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603104358518,
        name: 'Cremona',
        code: 'CR',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603104391286,
        name: 'Crotone',
        code: 'KR',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603104424054,
        name: 'Cuneo',
        code: 'CN',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603104456822,
        name: 'Enna',
        code: 'EN',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603104489590,
        name: 'Fermo',
        code: 'FM',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603104522358,
        name: 'Ferrara',
        code: 'FE',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603104555126,
        name: 'Firenze',
        code: 'FI',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603104587894,
        name: 'Foggia',
        code: 'FG',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603104620662,
        name: 'Forlì-Cesena',
        code: 'FC',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603104653430,
        name: 'Frosinone',
        code: 'FR',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603104686198,
        name: 'Genova',
        code: 'GE',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603104718966,
        name: 'Gorizia',
        code: 'GO',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603104751734,
        name: 'Grosseto',
        code: 'GR',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603104784502,
        name: 'Imperia',
        code: 'IM',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603104817270,
        name: 'Isernia',
        code: 'IS',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603104850038,
        name: "L'Aquila",
        code: 'AQ',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603104882806,
        name: 'La Spezia',
        code: 'SP',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603104915574,
        name: 'Latina',
        code: 'LT',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603104948342,
        name: 'Lecce',
        code: 'LE',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603104981110,
        name: 'Lecco',
        code: 'LC',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603105013878,
        name: 'Livorno',
        code: 'LI',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603105046646,
        name: 'Lodi',
        code: 'LO',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603105079414,
        name: 'Lucca',
        code: 'LU',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603105112182,
        name: 'Macerata',
        code: 'MC',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603105144950,
        name: 'Mantova',
        code: 'MN',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603105177718,
        name: 'Massa-Carrara',
        code: 'MS',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603105210486,
        name: 'Matera',
        code: 'MT',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603105243254,
        name: 'Medio Campidano',
        code: 'VS',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603105276022,
        name: 'Messina',
        code: 'ME',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603105308790,
        name: 'Milano',
        code: 'MI',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603105341558,
        name: 'Modena',
        code: 'MO',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603105374326,
        name: 'Monza e Brianza',
        code: 'MB',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603105407094,
        name: 'Napoli',
        code: 'NA',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603105439862,
        name: 'Novara',
        code: 'NO',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603105472630,
        name: 'Nuoro',
        code: 'NU',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603105505398,
        name: 'Ogliastra',
        code: 'OG',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603105538166,
        name: 'Olbia-Tempio',
        code: 'OT',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603105570934,
        name: 'Oristano',
        code: 'OR',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603105603702,
        name: 'Padova',
        code: 'PD',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603105636470,
        name: 'Palermo',
        code: 'PA',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603105669238,
        name: 'Parma',
        code: 'PR',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603105702006,
        name: 'Pavia',
        code: 'PV',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603105734774,
        name: 'Perugia',
        code: 'PG',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603105767542,
        name: 'Pesaro e Urbino',
        code: 'PU',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603105800310,
        name: 'Pescara',
        code: 'PE',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603105833078,
        name: 'Piacenza',
        code: 'PC',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603105865846,
        name: 'Pisa',
        code: 'PI',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603105898614,
        name: 'Pistoia',
        code: 'PT',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603105931382,
        name: 'Pordenone',
        code: 'PN',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603105964150,
        name: 'Potenza',
        code: 'PZ',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603105996918,
        name: 'Prato',
        code: 'PO',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603106029686,
        name: 'Ragusa',
        code: 'RG',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603106062454,
        name: 'Ravenna',
        code: 'RA',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603106095222,
        name: 'Reggio Calabria',
        code: 'RC',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603106127990,
        name: 'Reggio Emilia',
        code: 'RE',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603106160758,
        name: 'Rieti',
        code: 'RI',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603106193526,
        name: 'Rimini',
        code: 'RN',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603106226294,
        name: 'Roma',
        code: 'RM',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603106259062,
        name: 'Rovigo',
        code: 'RO',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603106291830,
        name: 'Salerno',
        code: 'SA',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603106324598,
        name: 'Sassari',
        code: 'SS',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603106357366,
        name: 'Savona',
        code: 'SV',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603106390134,
        name: 'Siena',
        code: 'SI',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603106422902,
        name: 'Siracusa',
        code: 'SR',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603106455670,
        name: 'Sondrio',
        code: 'SO',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603106488438,
        name: 'Taranto',
        code: 'TA',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603106521206,
        name: 'Teramo',
        code: 'TE',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603106553974,
        name: 'Terni',
        code: 'TR',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603106586742,
        name: 'Torino',
        code: 'TO',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603106619510,
        name: 'Trapani',
        code: 'TP',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603106652278,
        name: 'Trento',
        code: 'TN',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603106685046,
        name: 'Treviso',
        code: 'TV',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603106717814,
        name: 'Trieste',
        code: 'TS',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603106750582,
        name: 'Udine',
        code: 'UD',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603106783350,
        name: 'Varese',
        code: 'VA',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603106816118,
        name: 'Venezia',
        code: 'VE',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603106848886,
        name: 'Verbano-Cusio-Ossola',
        code: 'VB',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603106881654,
        name: 'Vercelli',
        code: 'VC',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603106914422,
        name: 'Verona',
        code: 'VR',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603106947190,
        name: 'Vibo Valentia',
        code: 'VV',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603106979958,
        name: 'Vicenza',
        code: 'VI',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180660342,
        id: 5603107012726,
        name: 'Viterbo',
        code: 'VT',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
    ],
  },
  {
    id: 518033866870,
    name: 'Jamaica',
    code: 'JM',
    tax_name: 'GCT',
    tax: 0,
    provinces: [],
  },
  {
    id: 508180693110,
    name: 'Japan',
    code: 'JP',
    tax_name: 'CT',
    tax: 0,
    provinces: [
      {
        country_id: 508180693110,
        id: 5603107766390,
        name: 'Aichi',
        code: 'JP-23',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180693110,
        id: 5603107176566,
        name: 'Akita',
        code: 'JP-05',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180693110,
        id: 5603107078262,
        name: 'Aomori',
        code: 'JP-02',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180693110,
        id: 5603107405942,
        name: 'Chiba',
        code: 'JP-12',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180693110,
        id: 5603108257910,
        name: 'Ehime',
        code: 'JP-38',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180693110,
        id: 5603107602550,
        name: 'Fukui',
        code: 'JP-18',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180693110,
        id: 5603108323446,
        name: 'Fukuoka',
        code: 'JP-40',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180693110,
        id: 5603107242102,
        name: 'Fukushima',
        code: 'JP-07',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180693110,
        id: 5603107700854,
        name: 'Gifu',
        code: 'JP-21',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180693110,
        id: 5603107340406,
        name: 'Gunma',
        code: 'JP-10',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180693110,
        id: 5603108126838,
        name: 'Hiroshima',
        code: 'JP-34',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180693110,
        id: 5603107045494,
        name: 'Hokkaidō',
        code: 'JP-01',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180693110,
        id: 5603107930230,
        name: 'Hyōgo',
        code: 'JP-28',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180693110,
        id: 5603107274870,
        name: 'Ibaraki',
        code: 'JP-08',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180693110,
        id: 5603107569782,
        name: 'Ishikawa',
        code: 'JP-17',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180693110,
        id: 5603107111030,
        name: 'Iwate',
        code: 'JP-03',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180693110,
        id: 5603108225142,
        name: 'Kagawa',
        code: 'JP-37',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180693110,
        id: 5603108520054,
        name: 'Kagoshima',
        code: 'JP-46',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180693110,
        id: 5603107471478,
        name: 'Kanagawa',
        code: 'JP-14',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180693110,
        id: 5603108290678,
        name: 'Kōchi',
        code: 'JP-39',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180693110,
        id: 5603108421750,
        name: 'Kumamoto',
        code: 'JP-43',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180693110,
        id: 5603107864694,
        name: 'Kyōto',
        code: 'JP-26',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180693110,
        id: 5603107799158,
        name: 'Mie',
        code: 'JP-24',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180693110,
        id: 5603107143798,
        name: 'Miyagi',
        code: 'JP-04',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180693110,
        id: 5603108487286,
        name: 'Miyazaki',
        code: 'JP-45',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180693110,
        id: 5603107668086,
        name: 'Nagano',
        code: 'JP-20',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180693110,
        id: 5603108388982,
        name: 'Nagasaki',
        code: 'JP-42',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180693110,
        id: 5603107962998,
        name: 'Nara',
        code: 'JP-29',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180693110,
        id: 5603107504246,
        name: 'Niigata',
        code: 'JP-15',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180693110,
        id: 5603108454518,
        name: 'Ōita',
        code: 'JP-44',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180693110,
        id: 5603108094070,
        name: 'Okayama',
        code: 'JP-33',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180693110,
        id: 5603108552822,
        name: 'Okinawa',
        code: 'JP-47',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180693110,
        id: 5603107897462,
        name: 'Ōsaka',
        code: 'JP-27',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180693110,
        id: 5603108356214,
        name: 'Saga',
        code: 'JP-41',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180693110,
        id: 5603107373174,
        name: 'Saitama',
        code: 'JP-11',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180693110,
        id: 5603107831926,
        name: 'Shiga',
        code: 'JP-25',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180693110,
        id: 5603108061302,
        name: 'Shimane',
        code: 'JP-32',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180693110,
        id: 5603107733622,
        name: 'Shizuoka',
        code: 'JP-22',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180693110,
        id: 5603107307638,
        name: 'Tochigi',
        code: 'JP-09',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180693110,
        id: 5603108192374,
        name: 'Tokushima',
        code: 'JP-36',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180693110,
        id: 5603107438710,
        name: 'Tōkyō',
        code: 'JP-13',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180693110,
        id: 5603108028534,
        name: 'Tottori',
        code: 'JP-31',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180693110,
        id: 5603107537014,
        name: 'Toyama',
        code: 'JP-16',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180693110,
        id: 5603107995766,
        name: 'Wakayama',
        code: 'JP-30',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180693110,
        id: 5603107209334,
        name: 'Yamagata',
        code: 'JP-06',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180693110,
        id: 5603108159606,
        name: 'Yamaguchi',
        code: 'JP-35',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180693110,
        id: 5603107635318,
        name: 'Yamanashi',
        code: 'JP-19',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
    ],
  },
  {
    id: 518032523382,
    name: 'Jersey',
    code: 'JE',
    tax_name: 'GST',
    tax: 0,
    provinces: [],
  },
  {
    id: 518031147126,
    name: 'Jordan',
    code: 'JO',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 518031179894,
    name: 'Kazakhstan',
    code: 'KZ',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 539835498614,
    name: 'Kenya',
    code: 'KE',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 518034522230,
    name: 'Kiribati',
    code: 'KI',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 518032556150,
    name: 'Kosovo',
    code: 'XK',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 518031212662,
    name: 'Kuwait',
    code: 'KW',
    tax_name: 'VAT',
    tax: 0,
    provinces: [
      {
        country_id: 518031212662,
        id: 5741005570166,
        name: 'Al Ahmadi',
        code: 'KW-AH',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031212662,
        id: 5741005602934,
        name: 'Al Asimah',
        code: 'KW-KU',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031212662,
        id: 5741005635702,
        name: 'Al Farwaniyah',
        code: 'KW-FA',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031212662,
        id: 5741005668470,
        name: 'Al Jahra',
        code: 'KW-JA',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031212662,
        id: 5741005701238,
        name: 'Hawalli',
        code: 'KW-HA',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031212662,
        id: 5741005734006,
        name: 'Mubarak Al-Kabeer',
        code: 'KW-MU',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
    ],
  },
  {
    id: 518031245430,
    name: 'Kyrgyzstan',
    code: 'KG',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 518031278198,
    name: "Lao People's Democratic Republic",
    code: 'LA',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 518032588918,
    name: 'Latvia',
    code: 'LV',
    tax_name: 'LV VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 518031310966,
    name: 'Lebanon',
    code: 'LB',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 539835531382,
    name: 'Lesotho',
    code: 'LS',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 539835564150,
    name: 'Liberia',
    code: 'LR',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 539835596918,
    name: 'Libyan Arab Jamahiriya',
    code: 'LY',
    tax_name: 'Tax',
    tax: 0,
    provinces: [],
  },
  {
    id: 518032621686,
    name: 'Liechtenstein',
    code: 'LI',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 518032654454,
    name: 'Lithuania',
    code: 'LT',
    tax_name: 'LT VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 518032687222,
    name: 'Luxembourg',
    code: 'LU',
    tax_name: 'LU VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 518031343734,
    name: 'Macao',
    code: 'MO',
    tax_name: 'Tax',
    tax: 0,
    provinces: [],
  },
  {
    id: 539835629686,
    name: 'Madagascar',
    code: 'MG',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 539835662454,
    name: 'Malawi',
    code: 'MW',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 508180758646,
    name: 'Malaysia',
    code: 'MY',
    tax_name: 'SST',
    tax: 0,
    provinces: [
      {
        country_id: 508180758646,
        id: 5603109142646,
        name: 'Johor',
        code: 'JHR',
        tax_name: 'SST',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180758646,
        id: 5603109175414,
        name: 'Kedah',
        code: 'KDH',
        tax_name: 'SST',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180758646,
        id: 5603109208182,
        name: 'Kelantan',
        code: 'KTN',
        tax_name: 'SST',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180758646,
        id: 5603109240950,
        name: 'Kuala Lumpur',
        code: 'KUL',
        tax_name: 'SST',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180758646,
        id: 5603109273718,
        name: 'Labuan',
        code: 'LBN',
        tax_name: 'SST',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180758646,
        id: 5603109306486,
        name: 'Melaka',
        code: 'MLK',
        tax_name: 'SST',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180758646,
        id: 5603109339254,
        name: 'Negeri Sembilan',
        code: 'NSN',
        tax_name: 'SST',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180758646,
        id: 5603109372022,
        name: 'Pahang',
        code: 'PHG',
        tax_name: 'SST',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180758646,
        id: 5603109404790,
        name: 'Penang',
        code: 'PNG',
        tax_name: 'SST',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180758646,
        id: 5603109437558,
        name: 'Perak',
        code: 'PRK',
        tax_name: 'SST',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180758646,
        id: 5603109470326,
        name: 'Perlis',
        code: 'PLS',
        tax_name: 'SST',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180758646,
        id: 5603109503094,
        name: 'Putrajaya',
        code: 'PJY',
        tax_name: 'SST',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180758646,
        id: 5603109535862,
        name: 'Sabah',
        code: 'SBH',
        tax_name: 'SST',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180758646,
        id: 5603109568630,
        name: 'Sarawak',
        code: 'SWK',
        tax_name: 'SST',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180758646,
        id: 5603109601398,
        name: 'Selangor',
        code: 'SGR',
        tax_name: 'SST',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180758646,
        id: 5603109634166,
        name: 'Terengganu',
        code: 'TRG',
        tax_name: 'SST',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
    ],
  },
  {
    id: 518031376502,
    name: 'Maldives',
    code: 'MV',
    tax_name: 'GST',
    tax: 0,
    provinces: [],
  },
  {
    id: 539835695222,
    name: 'Mali',
    code: 'ML',
    tax_name: 'TVA',
    tax: 0,
    provinces: [],
  },
  {
    id: 518032719990,
    name: 'Malta',
    code: 'MT',
    tax_name: 'MT VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 518033899638,
    name: 'Martinique',
    code: 'MQ',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 539835727990,
    name: 'Mauritania',
    code: 'MR',
    tax_name: 'TVA',
    tax: 0,
    provinces: [],
  },
  {
    id: 539835760758,
    name: 'Mauritius',
    code: 'MU',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 539835793526,
    name: 'Mayotte',
    code: 'YT',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 518033932406,
    name: 'Mexico',
    code: 'MX',
    tax_name: 'VAT',
    tax: 0,
    provinces: [
      {
        country_id: 518033932406,
        id: 5741016481910,
        name: 'Aguascalientes',
        code: 'AGS',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518033932406,
        id: 5741016514678,
        name: 'Baja California',
        code: 'BC',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518033932406,
        id: 5741016547446,
        name: 'Baja California Sur',
        code: 'BCS',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518033932406,
        id: 5741016580214,
        name: 'Campeche',
        code: 'CAMP',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518033932406,
        id: 5741016612982,
        name: 'Chiapas',
        code: 'CHIS',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518033932406,
        id: 5741016645750,
        name: 'Chihuahua',
        code: 'CHIH',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518033932406,
        id: 5741016678518,
        name: 'Ciudad de México',
        code: 'DF',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518033932406,
        id: 5741016711286,
        name: 'Coahuila',
        code: 'COAH',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518033932406,
        id: 5741016744054,
        name: 'Colima',
        code: 'COL',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518033932406,
        id: 5741016776822,
        name: 'Durango',
        code: 'DGO',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518033932406,
        id: 5741016809590,
        name: 'Guanajuato',
        code: 'GTO',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518033932406,
        id: 5741016842358,
        name: 'Guerrero',
        code: 'GRO',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518033932406,
        id: 5741016875126,
        name: 'Hidalgo',
        code: 'HGO',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518033932406,
        id: 5741016907894,
        name: 'Jalisco',
        code: 'JAL',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518033932406,
        id: 5741016940662,
        name: 'México',
        code: 'MEX',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518033932406,
        id: 5741016973430,
        name: 'Michoacán',
        code: 'MICH',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518033932406,
        id: 5741017006198,
        name: 'Morelos',
        code: 'MOR',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518033932406,
        id: 5741017038966,
        name: 'Nayarit',
        code: 'NAY',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518033932406,
        id: 5741017071734,
        name: 'Nuevo León',
        code: 'NL',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518033932406,
        id: 5741017104502,
        name: 'Oaxaca',
        code: 'OAX',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518033932406,
        id: 5741017137270,
        name: 'Puebla',
        code: 'PUE',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518033932406,
        id: 5741017170038,
        name: 'Querétaro',
        code: 'QRO',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518033932406,
        id: 5741017202806,
        name: 'Quintana Roo',
        code: 'Q ROO',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518033932406,
        id: 5741017235574,
        name: 'San Luis Potosí',
        code: 'SLP',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518033932406,
        id: 5741017268342,
        name: 'Sinaloa',
        code: 'SIN',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518033932406,
        id: 5741017301110,
        name: 'Sonora',
        code: 'SON',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518033932406,
        id: 5741017333878,
        name: 'Tabasco',
        code: 'TAB',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518033932406,
        id: 5741017366646,
        name: 'Tamaulipas',
        code: 'TAMPS',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518033932406,
        id: 5741017399414,
        name: 'Tlaxcala',
        code: 'TLAX',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518033932406,
        id: 5741017432182,
        name: 'Veracruz',
        code: 'VER',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518033932406,
        id: 5741017464950,
        name: 'Yucatán',
        code: 'YUC',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518033932406,
        id: 5741017497718,
        name: 'Zacatecas',
        code: 'ZAC',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
    ],
  },
  {
    id: 518032752758,
    name: 'Moldova, Republic of',
    code: 'MD',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 518032785526,
    name: 'Monaco',
    code: 'MC',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 518031409270,
    name: 'Mongolia',
    code: 'MN',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 518032818294,
    name: 'Montenegro',
    code: 'ME',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 518033965174,
    name: 'Montserrat',
    code: 'MS',
    tax_name: 'Tax',
    tax: 0,
    provinces: [],
  },
  {
    id: 539835826294,
    name: 'Morocco',
    code: 'MA',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 539835859062,
    name: 'Mozambique',
    code: 'MZ',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 518031442038,
    name: 'Myanmar',
    code: 'MM',
    tax_name: 'GST',
    tax: 0,
    provinces: [],
  },
  {
    id: 539835891830,
    name: 'Namibia',
    code: 'NA',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 518034554998,
    name: 'Nauru',
    code: 'NR',
    tax_name: 'Tax',
    tax: 0,
    provinces: [],
  },
  {
    id: 518031474806,
    name: 'Nepal',
    code: 'NP',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 508180791414,
    name: 'Netherlands',
    code: 'NL',
    tax_name: 'NL btw',
    tax: 0,
    provinces: [],
  },
  {
    id: 518034587766,
    name: 'New Caledonia',
    code: 'NC',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 508180856950,
    name: 'New Zealand',
    code: 'NZ',
    tax_name: 'GST',
    tax: 0,
    provinces: [
      {
        country_id: 508180856950,
        id: 5603109666934,
        name: 'Auckland',
        code: 'AUK',
        tax_name: 'GST',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180856950,
        id: 5603109699702,
        name: 'Bay of Plenty',
        code: 'BOP',
        tax_name: 'GST',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180856950,
        id: 5603109732470,
        name: 'Canterbury',
        code: 'CAN',
        tax_name: 'GST',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180856950,
        id: 5603109765238,
        name: 'Chatham Islands',
        code: 'CIT',
        tax_name: 'GST',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180856950,
        id: 5603109798006,
        name: 'Gisborne',
        code: 'GIS',
        tax_name: 'GST',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180856950,
        id: 5603109830774,
        name: "Hawke's Bay",
        code: 'HKB',
        tax_name: 'GST',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180856950,
        id: 5603109863542,
        name: 'Manawatu-Wanganui',
        code: 'MWT',
        tax_name: 'GST',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180856950,
        id: 5603109896310,
        name: 'Marlborough',
        code: 'MBH',
        tax_name: 'GST',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180856950,
        id: 5603109929078,
        name: 'Nelson',
        code: 'NSN',
        tax_name: 'GST',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180856950,
        id: 5603109961846,
        name: 'Northland',
        code: 'NTL',
        tax_name: 'GST',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180856950,
        id: 5603109994614,
        name: 'Otago',
        code: 'OTA',
        tax_name: 'GST',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180856950,
        id: 5603110027382,
        name: 'Southland',
        code: 'STL',
        tax_name: 'GST',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180856950,
        id: 5603110060150,
        name: 'Taranaki',
        code: 'TKI',
        tax_name: 'GST',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180856950,
        id: 5603110092918,
        name: 'Tasman',
        code: 'TAS',
        tax_name: 'GST',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180856950,
        id: 5603110125686,
        name: 'Waikato',
        code: 'WKO',
        tax_name: 'GST',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180856950,
        id: 5603110158454,
        name: 'Wellington',
        code: 'WGN',
        tax_name: 'GST',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180856950,
        id: 5603110191222,
        name: 'West Coast',
        code: 'WTC',
        tax_name: 'GST',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
    ],
  },
  {
    id: 518033997942,
    name: 'Nicaragua',
    code: 'NI',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 539835924598,
    name: 'Niger',
    code: 'NE',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 539835957366,
    name: 'Nigeria',
    code: 'NG',
    tax_name: 'VAT',
    tax: 0,
    provinces: [
      {
        country_id: 539835957366,
        id: 6043601567862,
        name: 'Abia',
        code: 'AB',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539835957366,
        id: 6043601600630,
        name: 'Abuja Federal Capital Territory',
        code: 'FC',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539835957366,
        id: 6043601633398,
        name: 'Adamawa',
        code: 'AD',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539835957366,
        id: 6043601666166,
        name: 'Akwa Ibom',
        code: 'AK',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539835957366,
        id: 6043601698934,
        name: 'Anambra',
        code: 'AN',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539835957366,
        id: 6043601731702,
        name: 'Bauchi',
        code: 'BA',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539835957366,
        id: 6043601764470,
        name: 'Bayelsa',
        code: 'BY',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539835957366,
        id: 6043601797238,
        name: 'Benue',
        code: 'BE',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539835957366,
        id: 6043601830006,
        name: 'Borno',
        code: 'BO',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539835957366,
        id: 6043601862774,
        name: 'Cross River',
        code: 'CR',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539835957366,
        id: 6043601895542,
        name: 'Delta',
        code: 'DE',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539835957366,
        id: 6043601928310,
        name: 'Ebonyi',
        code: 'EB',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539835957366,
        id: 6043601961078,
        name: 'Edo',
        code: 'ED',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539835957366,
        id: 6043601993846,
        name: 'Ekiti',
        code: 'EK',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539835957366,
        id: 6043602026614,
        name: 'Enugu',
        code: 'EN',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539835957366,
        id: 6043602059382,
        name: 'Gombe',
        code: 'GO',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539835957366,
        id: 6043602092150,
        name: 'Imo',
        code: 'IM',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539835957366,
        id: 6043602124918,
        name: 'Jigawa',
        code: 'JI',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539835957366,
        id: 6043602157686,
        name: 'Kaduna',
        code: 'KD',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539835957366,
        id: 6043602190454,
        name: 'Kano',
        code: 'KN',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539835957366,
        id: 6043602223222,
        name: 'Katsina',
        code: 'KT',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539835957366,
        id: 6043602255990,
        name: 'Kebbi',
        code: 'KE',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539835957366,
        id: 6043602288758,
        name: 'Kogi',
        code: 'KO',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539835957366,
        id: 6043602321526,
        name: 'Kwara',
        code: 'KW',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539835957366,
        id: 6043602354294,
        name: 'Lagos',
        code: 'LA',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539835957366,
        id: 6043602387062,
        name: 'Nasarawa',
        code: 'NA',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539835957366,
        id: 6043602419830,
        name: 'Niger',
        code: 'NI',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539835957366,
        id: 6043602452598,
        name: 'Ogun',
        code: 'OG',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539835957366,
        id: 6043602485366,
        name: 'Ondo',
        code: 'ON',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539835957366,
        id: 6043602518134,
        name: 'Osun',
        code: 'OS',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539835957366,
        id: 6043602550902,
        name: 'Oyo',
        code: 'OY',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539835957366,
        id: 6043602583670,
        name: 'Plateau',
        code: 'PL',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539835957366,
        id: 6043602616438,
        name: 'Rivers',
        code: 'RI',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539835957366,
        id: 6043602649206,
        name: 'Sokoto',
        code: 'SO',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539835957366,
        id: 6043602681974,
        name: 'Taraba',
        code: 'TA',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539835957366,
        id: 6043602714742,
        name: 'Yobe',
        code: 'YO',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 539835957366,
        id: 6043602747510,
        name: 'Zamfara',
        code: 'ZA',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
    ],
  },
  {
    id: 518034620534,
    name: 'Niue',
    code: 'NU',
    tax_name: 'Tax',
    tax: 0,
    provinces: [],
  },
  {
    id: 518034653302,
    name: 'Norfolk Island',
    code: 'NF',
    tax_name: 'Tax',
    tax: 0,
    provinces: [],
  },
  {
    id: 518032851062,
    name: 'North Macedonia',
    code: 'MK',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 508180824182,
    name: 'Norway',
    code: 'NO',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 518031507574,
    name: 'Oman',
    code: 'OM',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 518031540342,
    name: 'Pakistan',
    code: 'PK',
    tax_name: 'GST',
    tax: 0,
    provinces: [],
  },
  {
    id: 518031573110,
    name: 'Palestinian Territory, Occupied',
    code: 'PS',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 518034030710,
    name: 'Panama',
    code: 'PA',
    tax_name: 'ITBMS',
    tax: 0,
    provinces: [
      {
        country_id: 518034030710,
        id: 5741017530486,
        name: 'Bocas del Toro',
        code: 'PA-1',
        tax_name: 'ITBMS',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518034030710,
        id: 5741017563254,
        name: 'Chiriquí',
        code: 'PA-4',
        tax_name: 'ITBMS',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518034030710,
        id: 5741017596022,
        name: 'Coclé',
        code: 'PA-2',
        tax_name: 'ITBMS',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518034030710,
        id: 5741017628790,
        name: 'Colón',
        code: 'PA-3',
        tax_name: 'ITBMS',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518034030710,
        id: 5741017661558,
        name: 'Darién',
        code: 'PA-5',
        tax_name: 'ITBMS',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518034030710,
        id: 5741017694326,
        name: 'Emberá',
        code: 'PA-EM',
        tax_name: 'ITBMS',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518034030710,
        id: 5741017727094,
        name: 'Herrera',
        code: 'PA-6',
        tax_name: 'ITBMS',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518034030710,
        id: 5741017759862,
        name: 'Kuna Yala',
        code: 'PA-KY',
        tax_name: 'ITBMS',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518034030710,
        id: 5741017792630,
        name: 'Los Santos',
        code: 'PA-7',
        tax_name: 'ITBMS',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518034030710,
        id: 5741017825398,
        name: 'Ngöbe-Buglé',
        code: 'PA-NB',
        tax_name: 'ITBMS',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518034030710,
        id: 5741017858166,
        name: 'Panamá',
        code: 'PA-8',
        tax_name: 'ITBMS',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518034030710,
        id: 5741017890934,
        name: 'Panamá Oeste',
        code: 'PA-10',
        tax_name: 'ITBMS',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518034030710,
        id: 5741017923702,
        name: 'Veraguas',
        code: 'PA-9',
        tax_name: 'ITBMS',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
    ],
  },
  {
    id: 518034686070,
    name: 'Papua New Guinea',
    code: 'PG',
    tax_name: 'GST',
    tax: 0,
    provinces: [],
  },
  {
    id: 518035308662,
    name: 'Paraguay',
    code: 'PY',
    tax_name: 'IVA',
    tax: 0,
    provinces: [],
  },
  {
    id: 518035341430,
    name: 'Peru',
    code: 'PE',
    tax_name: 'IGV',
    tax: 0,
    provinces: [
      {
        country_id: 518035341430,
        id: 5741021233270,
        name: 'Amazonas',
        code: 'PE-AMA',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035341430,
        id: 5741021266038,
        name: 'Áncash',
        code: 'PE-ANC',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035341430,
        id: 5741021298806,
        name: 'Apurímac',
        code: 'PE-APU',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035341430,
        id: 5741021331574,
        name: 'Arequipa',
        code: 'PE-ARE',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035341430,
        id: 5741021364342,
        name: 'Ayacucho',
        code: 'PE-AYA',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035341430,
        id: 5741021397110,
        name: 'Cajamarca',
        code: 'PE-CAJ',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035341430,
        id: 5741021429878,
        name: 'Callao',
        code: 'PE-CAL',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035341430,
        id: 5741021462646,
        name: 'Cuzco',
        code: 'PE-CUS',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035341430,
        id: 5741021495414,
        name: 'Huancavelica',
        code: 'PE-HUV',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035341430,
        id: 5741021528182,
        name: 'Huánuco',
        code: 'PE-HUC',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035341430,
        id: 5741021560950,
        name: 'Ica',
        code: 'PE-ICA',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035341430,
        id: 5741021593718,
        name: 'Junín',
        code: 'PE-JUN',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035341430,
        id: 5741021626486,
        name: 'La Libertad',
        code: 'PE-LAL',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035341430,
        id: 5741021659254,
        name: 'Lambayeque',
        code: 'PE-LAM',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035341430,
        id: 5741021692022,
        name: 'Lima (departamento)',
        code: 'PE-LIM',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035341430,
        id: 5741021724790,
        name: 'Lima (provincia)',
        code: 'PE-LMA',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035341430,
        id: 5741021757558,
        name: 'Loreto',
        code: 'PE-LOR',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035341430,
        id: 5741021790326,
        name: 'Madre de Dios',
        code: 'PE-MDD',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035341430,
        id: 5741021823094,
        name: 'Moquegua',
        code: 'PE-MOQ',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035341430,
        id: 5741021855862,
        name: 'Pasco',
        code: 'PE-PAS',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035341430,
        id: 5741021888630,
        name: 'Piura',
        code: 'PE-PIU',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035341430,
        id: 5741021921398,
        name: 'Puno',
        code: 'PE-PUN',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035341430,
        id: 5741021954166,
        name: 'San Martín',
        code: 'PE-SAM',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035341430,
        id: 5741021986934,
        name: 'Tacna',
        code: 'PE-TAC',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035341430,
        id: 5741022019702,
        name: 'Tumbes',
        code: 'PE-TUM',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035341430,
        id: 5741022052470,
        name: 'Ucayali',
        code: 'PE-UCA',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
    ],
  },
  {
    id: 518031605878,
    name: 'Philippines',
    code: 'PH',
    tax_name: 'VAT',
    tax: 0,
    provinces: [
      {
        country_id: 518031605878,
        id: 5741005766774,
        name: 'Abra',
        code: 'PH-ABR',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741005799542,
        name: 'Agusan del Norte',
        code: 'PH-AGN',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741005832310,
        name: 'Agusan del Sur',
        code: 'PH-AGS',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741005865078,
        name: 'Aklan',
        code: 'PH-AKL',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741005897846,
        name: 'Albay',
        code: 'PH-ALB',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741005930614,
        name: 'Antique',
        code: 'PH-ANT',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741005963382,
        name: 'Apayao',
        code: 'PH-APA',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741005996150,
        name: 'Aurora',
        code: 'PH-AUR',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741006028918,
        name: 'Basilan',
        code: 'PH-BAS',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741006061686,
        name: 'Bataan',
        code: 'PH-BAN',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741006094454,
        name: 'Batanes',
        code: 'PH-BTN',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741006127222,
        name: 'Batangas',
        code: 'PH-BTG',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741006159990,
        name: 'Benguet',
        code: 'PH-BEN',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741006192758,
        name: 'Biliran',
        code: 'PH-BIL',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741006225526,
        name: 'Bohol',
        code: 'PH-BOH',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741006258294,
        name: 'Bukidnon',
        code: 'PH-BUK',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741006291062,
        name: 'Bulacan',
        code: 'PH-BUL',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741006323830,
        name: 'Cagayan',
        code: 'PH-CAG',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741006356598,
        name: 'Camarines Norte',
        code: 'PH-CAN',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741006389366,
        name: 'Camarines Sur',
        code: 'PH-CAS',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741006422134,
        name: 'Camiguin',
        code: 'PH-CAM',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741006454902,
        name: 'Capiz',
        code: 'PH-CAP',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741006487670,
        name: 'Catanduanes',
        code: 'PH-CAT',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741006520438,
        name: 'Cavite',
        code: 'PH-CAV',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741006553206,
        name: 'Cebu',
        code: 'PH-CEB',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741006585974,
        name: 'Cotabato',
        code: 'PH-NCO',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741006684278,
        name: 'Davao de Oro',
        code: 'PH-COM',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741006717046,
        name: 'Davao del Norte',
        code: 'PH-DAV',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741006749814,
        name: 'Davao del Sur',
        code: 'PH-DAS',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741006618742,
        name: 'Davao Occidental',
        code: 'PH-DVO',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741006651510,
        name: 'Davao Oriental',
        code: 'PH-DAO',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741006782582,
        name: 'Dinagat Islands',
        code: 'PH-DIN',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741006815350,
        name: 'Eastern Samar',
        code: 'PH-EAS',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741006848118,
        name: 'Guimaras',
        code: 'PH-GUI',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741006880886,
        name: 'Ifugao',
        code: 'PH-IFU',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741006913654,
        name: 'Ilocos Norte',
        code: 'PH-ILN',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741006946422,
        name: 'Ilocos Sur',
        code: 'PH-ILS',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741006979190,
        name: 'Iloilo',
        code: 'PH-ILI',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741007011958,
        name: 'Isabela',
        code: 'PH-ISA',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741007044726,
        name: 'Kalinga',
        code: 'PH-KAL',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741007077494,
        name: 'La Union',
        code: 'PH-LUN',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741007110262,
        name: 'Laguna',
        code: 'PH-LAG',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741007143030,
        name: 'Lanao del Norte',
        code: 'PH-LAN',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741007175798,
        name: 'Lanao del Sur',
        code: 'PH-LAS',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741007208566,
        name: 'Leyte',
        code: 'PH-LEY',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741007241334,
        name: 'Maguindanao',
        code: 'PH-MAG',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741007274102,
        name: 'Marinduque',
        code: 'PH-MAD',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741007306870,
        name: 'Masbate',
        code: 'PH-MAS',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741007339638,
        name: 'Metro Manila',
        code: 'PH-00',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741007372406,
        name: 'Misamis Occidental',
        code: 'PH-MSC',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741007405174,
        name: 'Misamis Oriental',
        code: 'PH-MSR',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741007437942,
        name: 'Mountain Province',
        code: 'PH-MOU',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741007470710,
        name: 'Negros Occidental',
        code: 'PH-NEC',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741007503478,
        name: 'Negros Oriental',
        code: 'PH-NER',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741007536246,
        name: 'Northern Samar',
        code: 'PH-NSA',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741007569014,
        name: 'Nueva Ecija',
        code: 'PH-NUE',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741007601782,
        name: 'Nueva Vizcaya',
        code: 'PH-NUV',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741007634550,
        name: 'Occidental Mindoro',
        code: 'PH-MDC',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741007667318,
        name: 'Oriental Mindoro',
        code: 'PH-MDR',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741007700086,
        name: 'Palawan',
        code: 'PH-PLW',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741007732854,
        name: 'Pampanga',
        code: 'PH-PAM',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741007765622,
        name: 'Pangasinan',
        code: 'PH-PAN',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741007798390,
        name: 'Quezon',
        code: 'PH-QUE',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741007831158,
        name: 'Quirino',
        code: 'PH-QUI',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741007863926,
        name: 'Rizal',
        code: 'PH-RIZ',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741007896694,
        name: 'Romblon',
        code: 'PH-ROM',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741007929462,
        name: 'Samar',
        code: 'PH-WSA',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741007962230,
        name: 'Sarangani',
        code: 'PH-SAR',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741007994998,
        name: 'Siquijor',
        code: 'PH-SIG',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741008027766,
        name: 'Sorsogon',
        code: 'PH-SOR',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741008060534,
        name: 'South Cotabato',
        code: 'PH-SCO',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741008093302,
        name: 'Southern Leyte',
        code: 'PH-SLE',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741008126070,
        name: 'Sultan Kudarat',
        code: 'PH-SUK',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741008158838,
        name: 'Sulu',
        code: 'PH-SLU',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741008191606,
        name: 'Surigao del Norte',
        code: 'PH-SUN',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741008224374,
        name: 'Surigao del Sur',
        code: 'PH-SUR',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741008257142,
        name: 'Tarlac',
        code: 'PH-TAR',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741008289910,
        name: 'Tawi-Tawi',
        code: 'PH-TAW',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741008322678,
        name: 'Zambales',
        code: 'PH-ZMB',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741008388214,
        name: 'Zamboanga del Norte',
        code: 'PH-ZAN',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741008420982,
        name: 'Zamboanga del Sur',
        code: 'PH-ZAS',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031605878,
        id: 5741008355446,
        name: 'Zamboanga Sibugay',
        code: 'PH-ZSI',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
    ],
  },
  {
    id: 518034718838,
    name: 'Pitcairn',
    code: 'PN',
    tax_name: 'Tax',
    tax: 0,
    provinces: [],
  },
  {
    id: 508180889718,
    name: 'Poland',
    code: 'PL',
    tax_name: 'PL VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 508180922486,
    name: 'Portugal',
    code: 'PT',
    tax_name: 'PT VAT',
    tax: 0,
    provinces: [
      {
        country_id: 508180922486,
        id: 5603110223990,
        name: 'Açores',
        code: 'PT-20',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180922486,
        id: 5603110256758,
        name: 'Aveiro',
        code: 'PT-01',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180922486,
        id: 5603110289526,
        name: 'Beja',
        code: 'PT-02',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180922486,
        id: 5603110322294,
        name: 'Braga',
        code: 'PT-03',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180922486,
        id: 5603110355062,
        name: 'Bragança',
        code: 'PT-04',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180922486,
        id: 5603110387830,
        name: 'Castelo Branco',
        code: 'PT-05',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180922486,
        id: 5603110420598,
        name: 'Coimbra',
        code: 'PT-06',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180922486,
        id: 5603110453366,
        name: 'Évora',
        code: 'PT-07',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180922486,
        id: 5603110486134,
        name: 'Faro',
        code: 'PT-08',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180922486,
        id: 5603110518902,
        name: 'Guarda',
        code: 'PT-09',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180922486,
        id: 5603110551670,
        name: 'Leiria',
        code: 'PT-10',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180922486,
        id: 5603110584438,
        name: 'Lisboa',
        code: 'PT-11',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180922486,
        id: 5603110617206,
        name: 'Madeira',
        code: 'PT-30',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180922486,
        id: 5603110649974,
        name: 'Portalegre',
        code: 'PT-12',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180922486,
        id: 5603110682742,
        name: 'Porto',
        code: 'PT-13',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180922486,
        id: 5603110715510,
        name: 'Santarém',
        code: 'PT-14',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180922486,
        id: 5603110748278,
        name: 'Setúbal',
        code: 'PT-15',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180922486,
        id: 5603110781046,
        name: 'Viana do Castelo',
        code: 'PT-16',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180922486,
        id: 5603110813814,
        name: 'Vila Real',
        code: 'PT-17',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180922486,
        id: 5603110846582,
        name: 'Viseu',
        code: 'PT-18',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
    ],
  },
  {
    id: 518031638646,
    name: 'Qatar',
    code: 'QA',
    tax_name: 'Tax',
    tax: 0,
    provinces: [],
  },
  {
    id: 539834843254,
    name: 'Republic of Cameroon',
    code: 'CM',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 539835990134,
    name: 'Reunion',
    code: 'RE',
    tax_name: 'TVA',
    tax: 0,
    provinces: [],
  },
  {
    id: 518032883830,
    name: 'Romania',
    code: 'RO',
    tax_name: 'RO VAT',
    tax: 0,
    provinces: [
      {
        country_id: 518032883830,
        id: 5741011009654,
        name: 'Alba',
        code: 'AB',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032883830,
        id: 5741011042422,
        name: 'Arad',
        code: 'AR',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032883830,
        id: 5741011075190,
        name: 'Argeș',
        code: 'AG',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032883830,
        id: 5741011107958,
        name: 'Bacău',
        code: 'BC',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032883830,
        id: 5741011140726,
        name: 'Bihor',
        code: 'BH',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032883830,
        id: 5741011173494,
        name: 'Bistrița-Năsăud',
        code: 'BN',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032883830,
        id: 5741011206262,
        name: 'Botoșani',
        code: 'BT',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032883830,
        id: 5741011239030,
        name: 'Brăila',
        code: 'BR',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032883830,
        id: 5741011271798,
        name: 'Brașov',
        code: 'BV',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032883830,
        id: 5741011304566,
        name: 'București',
        code: 'B',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032883830,
        id: 5741011337334,
        name: 'Buzău',
        code: 'BZ',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032883830,
        id: 5741011501174,
        name: 'Călărași',
        code: 'CL',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032883830,
        id: 5741011370102,
        name: 'Caraș-Severin',
        code: 'CS',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032883830,
        id: 5741011402870,
        name: 'Cluj',
        code: 'CJ',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032883830,
        id: 5741011435638,
        name: 'Constanța',
        code: 'CT',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032883830,
        id: 5741011468406,
        name: 'Covasna',
        code: 'CV',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032883830,
        id: 5741011566710,
        name: 'Dâmbovița',
        code: 'DB',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032883830,
        id: 5741011533942,
        name: 'Dolj',
        code: 'DJ',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032883830,
        id: 5741011599478,
        name: 'Galați',
        code: 'GL',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032883830,
        id: 5741011632246,
        name: 'Giurgiu',
        code: 'GR',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032883830,
        id: 5741011665014,
        name: 'Gorj',
        code: 'GJ',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032883830,
        id: 5741011697782,
        name: 'Harghita',
        code: 'HR',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032883830,
        id: 5741011730550,
        name: 'Hunedoara',
        code: 'HD',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032883830,
        id: 5741011763318,
        name: 'Ialomița',
        code: 'IL',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032883830,
        id: 5741011796086,
        name: 'Iași',
        code: 'IS',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032883830,
        id: 5741011828854,
        name: 'Ilfov',
        code: 'IF',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032883830,
        id: 5741011861622,
        name: 'Maramureș',
        code: 'MM',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032883830,
        id: 5741011894390,
        name: 'Mehedinți',
        code: 'MH',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032883830,
        id: 5741011927158,
        name: 'Mureș',
        code: 'MS',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032883830,
        id: 5741011959926,
        name: 'Neamț',
        code: 'NT',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032883830,
        id: 5741011992694,
        name: 'Olt',
        code: 'OT',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032883830,
        id: 5741012025462,
        name: 'Prahova',
        code: 'PH',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032883830,
        id: 5741012058230,
        name: 'Sălaj',
        code: 'SJ',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032883830,
        id: 5741012090998,
        name: 'Satu Mare',
        code: 'SM',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032883830,
        id: 5741012123766,
        name: 'Sibiu',
        code: 'SB',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032883830,
        id: 5741012156534,
        name: 'Suceava',
        code: 'SV',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032883830,
        id: 5741012189302,
        name: 'Teleorman',
        code: 'TR',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032883830,
        id: 5741012222070,
        name: 'Timiș',
        code: 'TM',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032883830,
        id: 5741012254838,
        name: 'Tulcea',
        code: 'TL',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032883830,
        id: 5741012287606,
        name: 'Vâlcea',
        code: 'VL',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032883830,
        id: 5741012320374,
        name: 'Vaslui',
        code: 'VS',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032883830,
        id: 5741012353142,
        name: 'Vrancea',
        code: 'VN',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
    ],
  },
  {
    id: 518032916598,
    name: 'Russia',
    code: 'RU',
    tax_name: 'VAT',
    tax: 0,
    provinces: [
      {
        country_id: 518032916598,
        id: 5741012385910,
        name: 'Altai Krai',
        code: 'ALT',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741012418678,
        name: 'Altai Republic',
        code: 'AL',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741012451446,
        name: 'Amur Oblast',
        code: 'AMU',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741012484214,
        name: 'Arkhangelsk Oblast',
        code: 'ARK',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741012516982,
        name: 'Astrakhan Oblast',
        code: 'AST',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741012549750,
        name: 'Belgorod Oblast',
        code: 'BEL',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741012582518,
        name: 'Bryansk Oblast',
        code: 'BRY',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741012615286,
        name: 'Chechen Republic',
        code: 'CE',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741012648054,
        name: 'Chelyabinsk Oblast',
        code: 'CHE',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741012680822,
        name: 'Chukotka Autonomous Okrug',
        code: 'CHU',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741012713590,
        name: 'Chuvash Republic',
        code: 'CU',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741012746358,
        name: 'Irkutsk Oblast',
        code: 'IRK',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741012779126,
        name: 'Ivanovo Oblast',
        code: 'IVA',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741012811894,
        name: 'Jewish Autonomous Oblast',
        code: 'YEV',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741012844662,
        name: 'Kabardino-Balkarian Republic',
        code: 'KB',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741012877430,
        name: 'Kaliningrad Oblast',
        code: 'KGD',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741012910198,
        name: 'Kaluga Oblast',
        code: 'KLU',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741012942966,
        name: 'Kamchatka Krai',
        code: 'KAM',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741012975734,
        name: 'Karachay–Cherkess Republic',
        code: 'KC',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741013008502,
        name: 'Kemerovo Oblast',
        code: 'KEM',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741013041270,
        name: 'Khabarovsk Krai',
        code: 'KHA',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741013074038,
        name: 'Khanty-Mansi Autonomous Okrug',
        code: 'KHM',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741013106806,
        name: 'Kirov Oblast',
        code: 'KIR',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741013139574,
        name: 'Komi Republic',
        code: 'KO',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741013172342,
        name: 'Kostroma Oblast',
        code: 'KOS',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741013205110,
        name: 'Krasnodar Krai',
        code: 'KDA',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741013237878,
        name: 'Krasnoyarsk Krai',
        code: 'KYA',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741013270646,
        name: 'Kurgan Oblast',
        code: 'KGN',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741013303414,
        name: 'Kursk Oblast',
        code: 'KRS',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741013336182,
        name: 'Leningrad Oblast',
        code: 'LEN',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741013368950,
        name: 'Lipetsk Oblast',
        code: 'LIP',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741013401718,
        name: 'Magadan Oblast',
        code: 'MAG',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741013434486,
        name: 'Mari El Republic',
        code: 'ME',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741013467254,
        name: 'Moscow',
        code: 'MOW',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741013500022,
        name: 'Moscow Oblast',
        code: 'MOS',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741013532790,
        name: 'Murmansk Oblast',
        code: 'MUR',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741013565558,
        name: 'Nizhny Novgorod Oblast',
        code: 'NIZ',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741013598326,
        name: 'Novgorod Oblast',
        code: 'NGR',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741013631094,
        name: 'Novosibirsk Oblast',
        code: 'NVS',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741013663862,
        name: 'Omsk Oblast',
        code: 'OMS',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741013696630,
        name: 'Orenburg Oblast',
        code: 'ORE',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741013729398,
        name: 'Oryol Oblast',
        code: 'ORL',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741013762166,
        name: 'Penza Oblast',
        code: 'PNZ',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741013794934,
        name: 'Perm Krai',
        code: 'PER',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741013827702,
        name: 'Primorsky Krai',
        code: 'PRI',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741013860470,
        name: 'Pskov Oblast',
        code: 'PSK',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741013893238,
        name: 'Republic of Adygeya',
        code: 'AD',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741013926006,
        name: 'Republic of Bashkortostan',
        code: 'BA',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741013958774,
        name: 'Republic of Buryatia',
        code: 'BU',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741013991542,
        name: 'Republic of Dagestan',
        code: 'DA',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741014024310,
        name: 'Republic of Ingushetia',
        code: 'IN',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741014057078,
        name: 'Republic of Kalmykia',
        code: 'KL',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741014089846,
        name: 'Republic of Karelia',
        code: 'KR',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741014122614,
        name: 'Republic of Khakassia',
        code: 'KK',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741014155382,
        name: 'Republic of Mordovia',
        code: 'MO',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741014188150,
        name: 'Republic of North Ossetia–Alania',
        code: 'SE',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741014220918,
        name: 'Republic of Tatarstan',
        code: 'TA',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741014253686,
        name: 'Rostov Oblast',
        code: 'ROS',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741014286454,
        name: 'Ryazan Oblast',
        code: 'RYA',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741014319222,
        name: 'Saint Petersburg',
        code: 'SPE',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741014351990,
        name: 'Sakha Republic (Yakutia)',
        code: 'SA',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741014384758,
        name: 'Sakhalin Oblast',
        code: 'SAK',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741014417526,
        name: 'Samara Oblast',
        code: 'SAM',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741014450294,
        name: 'Saratov Oblast',
        code: 'SAR',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741014483062,
        name: 'Smolensk Oblast',
        code: 'SMO',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741014515830,
        name: 'Stavropol Krai',
        code: 'STA',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741014548598,
        name: 'Sverdlovsk Oblast',
        code: 'SVE',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741014581366,
        name: 'Tambov Oblast',
        code: 'TAM',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741014614134,
        name: 'Tomsk Oblast',
        code: 'TOM',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741014646902,
        name: 'Tula Oblast',
        code: 'TUL',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741014679670,
        name: 'Tver Oblast',
        code: 'TVE',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741014712438,
        name: 'Tyumen Oblast',
        code: 'TYU',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741014745206,
        name: 'Tyva Republic',
        code: 'TY',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741014777974,
        name: 'Udmurtia',
        code: 'UD',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741014810742,
        name: 'Ulyanovsk Oblast',
        code: 'ULY',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741014843510,
        name: 'Vladimir Oblast',
        code: 'VLA',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741014876278,
        name: 'Volgograd Oblast',
        code: 'VGG',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741014909046,
        name: 'Vologda Oblast',
        code: 'VLG',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741014941814,
        name: 'Voronezh Oblast',
        code: 'VOR',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741014974582,
        name: 'Yamalo-Nenets Autonomous Okrug',
        code: 'YAN',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741015007350,
        name: 'Yaroslavl Oblast',
        code: 'YAR',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518032916598,
        id: 5741015040118,
        name: 'Zabaykalsky Krai',
        code: 'ZAB',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
    ],
  },
  {
    id: 539836022902,
    name: 'Rwanda',
    code: 'RW',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 518034096246,
    name: 'Saint Barthélemy',
    code: 'BL',
    tax_name: 'Tax',
    tax: 0,
    provinces: [],
  },
  {
    id: 539836252278,
    name: 'Saint Helena',
    code: 'SH',
    tax_name: 'Tax',
    tax: 0,
    provinces: [],
  },
  {
    id: 518034129014,
    name: 'Saint Kitts And Nevis',
    code: 'KN',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 518034161782,
    name: 'Saint Lucia',
    code: 'LC',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 518034194550,
    name: 'Saint Martin',
    code: 'MF',
    tax_name: 'TOT',
    tax: 0,
    provinces: [],
  },
  {
    id: 518034227318,
    name: 'Saint Pierre And Miquelon',
    code: 'PM',
    tax_name: 'Tax',
    tax: 0,
    provinces: [],
  },
  {
    id: 518034751606,
    name: 'Samoa',
    code: 'WS',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 518032949366,
    name: 'San Marino',
    code: 'SM',
    tax_name: 'Tax',
    tax: 0,
    provinces: [],
  },
  {
    id: 539836055670,
    name: 'Sao Tome And Principe',
    code: 'ST',
    tax_name: 'GST',
    tax: 0,
    provinces: [],
  },
  {
    id: 518031671414,
    name: 'Saudi Arabia',
    code: 'SA',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 539836088438,
    name: 'Senegal',
    code: 'SN',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 518032982134,
    name: 'Serbia',
    code: 'RS',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 539836121206,
    name: 'Seychelles',
    code: 'SC',
    tax_name: 'GST',
    tax: 0,
    provinces: [],
  },
  {
    id: 539836153974,
    name: 'Sierra Leone',
    code: 'SL',
    tax_name: 'GST',
    tax: 0,
    provinces: [],
  },
  {
    id: 508180988022,
    name: 'Singapore',
    code: 'SG',
    tax_name: 'GST',
    tax: 0,
    provinces: [],
  },
  {
    id: 518034063478,
    name: 'Sint Maarten',
    code: 'SX',
    tax_name: 'TOT',
    tax: 0,
    provinces: [],
  },
  {
    id: 518033014902,
    name: 'Slovakia',
    code: 'SK',
    tax_name: 'SK VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 518033047670,
    name: 'Slovenia',
    code: 'SI',
    tax_name: 'SI VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 518034784374,
    name: 'Solomon Islands',
    code: 'SB',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 539836186742,
    name: 'Somalia',
    code: 'SO',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 538588315766,
    name: 'South Africa',
    code: 'ZA',
    tax_name: 'VAT',
    tax: 0,
    provinces: [
      {
        country_id: 538588315766,
        id: 6026415702134,
        name: 'Eastern Cape',
        code: 'EC',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 538588315766,
        id: 6026415734902,
        name: 'Free State',
        code: 'FS',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 538588315766,
        id: 6026415767670,
        name: 'Gauteng',
        code: 'GP',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 538588315766,
        id: 6026415800438,
        name: 'KwaZulu-Natal',
        code: 'NL',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 538588315766,
        id: 6026415833206,
        name: 'Limpopo',
        code: 'LP',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 538588315766,
        id: 6026415865974,
        name: 'Mpumalanga',
        code: 'MP',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 538588315766,
        id: 6026415898742,
        name: 'North West',
        code: 'NW',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 538588315766,
        id: 6026415931510,
        name: 'Northern Cape',
        code: 'NC',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 538588315766,
        id: 6026415964278,
        name: 'Western Cape',
        code: 'WC',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
    ],
  },
  {
    id: 518035374198,
    name: 'South Georgia And The South Sandwich Islands',
    code: 'GS',
    tax_name: 'Tax',
    tax: 0,
    provinces: [],
  },
  {
    id: 508180725878,
    name: 'South Korea',
    code: 'KR',
    tax_name: 'VAT',
    tax: 0,
    provinces: [
      {
        country_id: 508180725878,
        id: 5603108585590,
        name: 'Busan',
        code: 'KR-26',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180725878,
        id: 5603108618358,
        name: 'Chungbuk',
        code: 'KR-43',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180725878,
        id: 5603108651126,
        name: 'Chungnam',
        code: 'KR-44',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180725878,
        id: 5603108683894,
        name: 'Daegu',
        code: 'KR-27',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180725878,
        id: 5603108716662,
        name: 'Daejeon',
        code: 'KR-30',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180725878,
        id: 5603108749430,
        name: 'Gangwon',
        code: 'KR-42',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180725878,
        id: 5603108782198,
        name: 'Gwangju',
        code: 'KR-29',
        tax_name: '0.0',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180725878,
        id: 5603108814966,
        name: 'Gyeongbuk',
        code: 'KR-47',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180725878,
        id: 5603108847734,
        name: 'Gyeonggi',
        code: 'KR-41',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180725878,
        id: 5603108880502,
        name: 'Gyeongnam',
        code: 'KR-48',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180725878,
        id: 5603108913270,
        name: 'Incheon',
        code: 'KR-28',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180725878,
        id: 5603108946038,
        name: 'Jeju',
        code: 'KR-49',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180725878,
        id: 5603108978806,
        name: 'Jeonbuk',
        code: 'KR-45',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180725878,
        id: 5603109011574,
        name: 'Jeonnam',
        code: 'KR-46',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180725878,
        id: 5603109044342,
        name: 'Sejong',
        code: 'KR-50',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180725878,
        id: 5603109077110,
        name: 'Seoul',
        code: 'KR-11',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180725878,
        id: 5603109109878,
        name: 'Ulsan',
        code: 'KR-31',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
    ],
  },
  {
    id: 539836219510,
    name: 'South Sudan',
    code: 'SS',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 508180430966,
    name: 'Spain',
    code: 'ES',
    tax_name: 'ES IVA',
    tax: 0,
    provinces: [
      {
        country_id: 508180430966,
        id: 5603100622966,
        name: 'A Coruña',
        code: 'C',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180430966,
        id: 5603100655734,
        name: 'Álava',
        code: 'VI',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180430966,
        id: 5603100688502,
        name: 'Albacete',
        code: 'AB',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180430966,
        id: 5603100721270,
        name: 'Alicante',
        code: 'A',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180430966,
        id: 5603100754038,
        name: 'Almería',
        code: 'AL',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180430966,
        id: 5603100786806,
        name: 'Asturias',
        code: 'O',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180430966,
        id: 5603100819574,
        name: 'Ávila',
        code: 'AV',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180430966,
        id: 5603100852342,
        name: 'Badajoz',
        code: 'BA',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180430966,
        id: 5603100885110,
        name: 'Balears',
        code: 'PM',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180430966,
        id: 5603100917878,
        name: 'Barcelona',
        code: 'B',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180430966,
        id: 5603100950646,
        name: 'Burgos',
        code: 'BU',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180430966,
        id: 5603100983414,
        name: 'Cáceres',
        code: 'CC',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180430966,
        id: 5603101016182,
        name: 'Cádiz',
        code: 'CA',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180430966,
        id: 5603101048950,
        name: 'Cantabria',
        code: 'S',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180430966,
        id: 5603101081718,
        name: 'Castellón',
        code: 'CS',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180430966,
        id: 5603101114486,
        name: 'Ceuta',
        code: 'CE',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180430966,
        id: 5603101147254,
        name: 'Ciudad Real',
        code: 'CR',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180430966,
        id: 5603101180022,
        name: 'Córdoba',
        code: 'CO',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180430966,
        id: 5603101212790,
        name: 'Cuenca',
        code: 'CU',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180430966,
        id: 5603101245558,
        name: 'Girona',
        code: 'GI',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180430966,
        id: 5603101278326,
        name: 'Granada',
        code: 'GR',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180430966,
        id: 5603101311094,
        name: 'Guadalajara',
        code: 'GU',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180430966,
        id: 5603101343862,
        name: 'Guipúzcoa',
        code: 'SS',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180430966,
        id: 5603101376630,
        name: 'Huelva',
        code: 'H',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180430966,
        id: 5603101409398,
        name: 'Huesca',
        code: 'HU',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180430966,
        id: 5603101442166,
        name: 'Jaén',
        code: 'J',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180430966,
        id: 5603101474934,
        name: 'La Rioja',
        code: 'LO',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180430966,
        id: 5603101507702,
        name: 'Las Palmas',
        code: 'GC',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180430966,
        id: 5603101540470,
        name: 'León',
        code: 'LE',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180430966,
        id: 5603101573238,
        name: 'Lleida',
        code: 'L',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180430966,
        id: 5603101606006,
        name: 'Lugo',
        code: 'LU',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180430966,
        id: 5603101638774,
        name: 'Madrid',
        code: 'M',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180430966,
        id: 5603101671542,
        name: 'Málaga',
        code: 'MA',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180430966,
        id: 5603101704310,
        name: 'Melilla',
        code: 'ML',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180430966,
        id: 5603101737078,
        name: 'Murcia',
        code: 'MU',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180430966,
        id: 5603101769846,
        name: 'Navarra',
        code: 'NA',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180430966,
        id: 5603101802614,
        name: 'Ourense',
        code: 'OR',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180430966,
        id: 5603101835382,
        name: 'Palencia',
        code: 'P',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180430966,
        id: 5603101868150,
        name: 'Pontevedra',
        code: 'PO',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180430966,
        id: 5603101900918,
        name: 'Salamanca',
        code: 'SA',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180430966,
        id: 5603101933686,
        name: 'Santa Cruz de Tenerife',
        code: 'TF',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180430966,
        id: 5603101966454,
        name: 'Segovia',
        code: 'SG',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180430966,
        id: 5603101999222,
        name: 'Sevilla',
        code: 'SE',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180430966,
        id: 5603102031990,
        name: 'Soria',
        code: 'SO',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180430966,
        id: 5603102064758,
        name: 'Tarragona',
        code: 'T',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180430966,
        id: 5603102097526,
        name: 'Teruel',
        code: 'TE',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180430966,
        id: 5603102130294,
        name: 'Toledo',
        code: 'TO',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180430966,
        id: 5603102163062,
        name: 'Valencia',
        code: 'V',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180430966,
        id: 5603102195830,
        name: 'Valladolid',
        code: 'VA',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180430966,
        id: 5603102228598,
        name: 'Vizcaya',
        code: 'BI',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180430966,
        id: 5603102261366,
        name: 'Zamora',
        code: 'ZA',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180430966,
        id: 5603102294134,
        name: 'Zaragoza',
        code: 'Z',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
    ],
  },
  {
    id: 518031704182,
    name: 'Sri Lanka',
    code: 'LK',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 518034260086,
    name: 'St. Vincent',
    code: 'VC',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 539836285046,
    name: 'Sudan',
    code: 'SD',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 518035406966,
    name: 'Suriname',
    code: 'SR',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 518033080438,
    name: 'Svalbard And Jan Mayen',
    code: 'SJ',
    tax_name: 'Tax',
    tax: 0,
    provinces: [],
  },
  {
    id: 508180955254,
    name: 'Sweden',
    code: 'SE',
    tax_name: 'SE Moms',
    tax: 0,
    provinces: [],
  },
  {
    id: 508180299894,
    name: 'Switzerland',
    code: 'CH',
    tax_name: 'MwSt',
    tax: 0,
    provinces: [],
  },
  {
    id: 518031736950,
    name: 'Taiwan',
    code: 'TW',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 518031769718,
    name: 'Tajikistan',
    code: 'TJ',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 539836317814,
    name: 'Tanzania, United Republic Of',
    code: 'TZ',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 518031802486,
    name: 'Thailand',
    code: 'TH',
    tax_name: 'VAT',
    tax: 0,
    provinces: [
      {
        country_id: 518031802486,
        id: 5741008453750,
        name: 'Amnat Charoen',
        code: 'TH-37',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031802486,
        id: 5741008486518,
        name: 'Ang Thong',
        code: 'TH-15',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031802486,
        id: 5741008519286,
        name: 'Bangkok',
        code: 'TH-10',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031802486,
        id: 5741008552054,
        name: 'Bueng Kan',
        code: 'TH-38',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031802486,
        id: 5741008584822,
        name: 'Buriram',
        code: 'TH-31',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031802486,
        id: 5741008617590,
        name: 'Chachoengsao',
        code: 'TH-24',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031802486,
        id: 5741008650358,
        name: 'Chai Nat',
        code: 'TH-18',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031802486,
        id: 5741008683126,
        name: 'Chaiyaphum',
        code: 'TH-36',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031802486,
        id: 5741008715894,
        name: 'Chanthaburi',
        code: 'TH-22',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031802486,
        id: 5741008748662,
        name: 'Chiang Mai',
        code: 'TH-50',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031802486,
        id: 5741008781430,
        name: 'Chiang Rai',
        code: 'TH-57',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031802486,
        id: 5741008814198,
        name: 'Chon Buri',
        code: 'TH-20',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031802486,
        id: 5741008846966,
        name: 'Chumphon',
        code: 'TH-86',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031802486,
        id: 5741008879734,
        name: 'Kalasin',
        code: 'TH-46',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031802486,
        id: 5741008912502,
        name: 'Kamphaeng Phet',
        code: 'TH-62',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031802486,
        id: 5741008945270,
        name: 'Kanchanaburi',
        code: 'TH-71',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031802486,
        id: 5741008978038,
        name: 'Khon Kaen',
        code: 'TH-40',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031802486,
        id: 5741009010806,
        name: 'Krabi',
        code: 'TH-81',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031802486,
        id: 5741009043574,
        name: 'Lampang',
        code: 'TH-52',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031802486,
        id: 5741009076342,
        name: 'Lamphun',
        code: 'TH-51',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031802486,
        id: 5741009109110,
        name: 'Loei',
        code: 'TH-42',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031802486,
        id: 5741009141878,
        name: 'Lopburi',
        code: 'TH-16',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031802486,
        id: 5741009174646,
        name: 'Mae Hong Son',
        code: 'TH-58',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031802486,
        id: 5741009207414,
        name: 'Maha Sarakham',
        code: 'TH-44',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031802486,
        id: 5741009240182,
        name: 'Mukdahan',
        code: 'TH-49',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031802486,
        id: 5741009272950,
        name: 'Nakhon Nayok',
        code: 'TH-26',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031802486,
        id: 5741009305718,
        name: 'Nakhon Pathom',
        code: 'TH-73',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031802486,
        id: 5741009338486,
        name: 'Nakhon Phanom',
        code: 'TH-48',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031802486,
        id: 5741009371254,
        name: 'Nakhon Ratchasima',
        code: 'TH-30',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031802486,
        id: 5741009404022,
        name: 'Nakhon Sawan',
        code: 'TH-60',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031802486,
        id: 5741009436790,
        name: 'Nakhon Si Thammarat',
        code: 'TH-80',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031802486,
        id: 5741009469558,
        name: 'Nan',
        code: 'TH-55',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031802486,
        id: 5741009502326,
        name: 'Narathiwat',
        code: 'TH-96',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031802486,
        id: 5741009535094,
        name: 'Nong Bua Lam Phu',
        code: 'TH-39',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031802486,
        id: 5741009567862,
        name: 'Nong Khai',
        code: 'TH-43',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031802486,
        id: 5741009600630,
        name: 'Nonthaburi',
        code: 'TH-12',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031802486,
        id: 5741009633398,
        name: 'Pathum Thani',
        code: 'TH-13',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031802486,
        id: 5741009666166,
        name: 'Pattani',
        code: 'TH-94',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031802486,
        id: 5741009698934,
        name: 'Pattaya',
        code: 'TH-S',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031802486,
        id: 5741009731702,
        name: 'Phangnga',
        code: 'TH-82',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031802486,
        id: 5741009764470,
        name: 'Phatthalung',
        code: 'TH-93',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031802486,
        id: 5741009797238,
        name: 'Phayao',
        code: 'TH-56',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031802486,
        id: 5741009830006,
        name: 'Phetchabun',
        code: 'TH-67',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031802486,
        id: 5741009862774,
        name: 'Phetchaburi',
        code: 'TH-76',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031802486,
        id: 5741009895542,
        name: 'Phichit',
        code: 'TH-66',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031802486,
        id: 5741009928310,
        name: 'Phitsanulok',
        code: 'TH-65',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031802486,
        id: 5741009961078,
        name: 'Phra Nakhon Si Ayutthaya',
        code: 'TH-14',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031802486,
        id: 5741009993846,
        name: 'Phrae',
        code: 'TH-54',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031802486,
        id: 5741010026614,
        name: 'Phuket',
        code: 'TH-83',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031802486,
        id: 5741010059382,
        name: 'Prachin Buri',
        code: 'TH-25',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031802486,
        id: 5741010092150,
        name: 'Prachuap Khiri Khan',
        code: 'TH-77',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031802486,
        id: 5741010124918,
        name: 'Ranong',
        code: 'TH-85',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031802486,
        id: 5741010157686,
        name: 'Ratchaburi',
        code: 'TH-70',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031802486,
        id: 5741010190454,
        name: 'Rayong',
        code: 'TH-21',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031802486,
        id: 5741010223222,
        name: 'Roi Et',
        code: 'TH-45',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031802486,
        id: 5741010255990,
        name: 'Sa Kaeo',
        code: 'TH-27',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031802486,
        id: 5741010288758,
        name: 'Sakon Nakhon',
        code: 'TH-47',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031802486,
        id: 5741010321526,
        name: 'Samut Prakan',
        code: 'TH-11',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031802486,
        id: 5741010354294,
        name: 'Samut Sakhon',
        code: 'TH-74',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031802486,
        id: 5741010387062,
        name: 'Samut Songkhram',
        code: 'TH-75',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031802486,
        id: 5741010419830,
        name: 'Saraburi',
        code: 'TH-19',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031802486,
        id: 5741010452598,
        name: 'Satun',
        code: 'TH-91',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031802486,
        id: 5741010485366,
        name: 'Sing Buri',
        code: 'TH-17',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031802486,
        id: 5741010518134,
        name: 'Sisaket',
        code: 'TH-33',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031802486,
        id: 5741010550902,
        name: 'Songkhla',
        code: 'TH-90',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031802486,
        id: 5741010583670,
        name: 'Sukhothai',
        code: 'TH-64',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031802486,
        id: 5741010616438,
        name: 'Suphan Buri',
        code: 'TH-72',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031802486,
        id: 5741010649206,
        name: 'Surat Thani',
        code: 'TH-84',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031802486,
        id: 5741010681974,
        name: 'Surin',
        code: 'TH-32',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031802486,
        id: 5741010714742,
        name: 'Tak',
        code: 'TH-63',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031802486,
        id: 5741010747510,
        name: 'Trang',
        code: 'TH-92',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031802486,
        id: 5741010780278,
        name: 'Trat',
        code: 'TH-23',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031802486,
        id: 5741010813046,
        name: 'Ubon Ratchathani',
        code: 'TH-34',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031802486,
        id: 5741010845814,
        name: 'Udon Thani',
        code: 'TH-41',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031802486,
        id: 5741010878582,
        name: 'Uthai Thani',
        code: 'TH-61',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031802486,
        id: 5741010911350,
        name: 'Uttaradit',
        code: 'TH-53',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031802486,
        id: 5741010944118,
        name: 'Yala',
        code: 'TH-95',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518031802486,
        id: 5741010976886,
        name: 'Yasothon',
        code: 'TH-35',
        tax_name: 'Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
    ],
  },
  {
    id: 518031835254,
    name: 'Timor Leste',
    code: 'TL',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 539836350582,
    name: 'Togo',
    code: 'TG',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 518034817142,
    name: 'Tokelau',
    code: 'TK',
    tax_name: 'Tax',
    tax: 0,
    provinces: [],
  },
  {
    id: 518034849910,
    name: 'Tonga',
    code: 'TO',
    tax_name: 'CT',
    tax: 0,
    provinces: [],
  },
  {
    id: 518034292854,
    name: 'Trinidad and Tobago',
    code: 'TT',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 539836383350,
    name: 'Tristan da Cunha',
    code: 'TA',
    tax_name: 'Tax',
    tax: 0,
    provinces: [],
  },
  {
    id: 539836416118,
    name: 'Tunisia',
    code: 'TN',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 518031868022,
    name: 'Turkey',
    code: 'TR',
    tax_name: 'KDV',
    tax: 0,
    provinces: [],
  },
  {
    id: 518031900790,
    name: 'Turkmenistan',
    code: 'TM',
    tax_name: 'Tax',
    tax: 0,
    provinces: [],
  },
  {
    id: 518034325622,
    name: 'Turks and Caicos Islands',
    code: 'TC',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 518034882678,
    name: 'Tuvalu',
    code: 'TV',
    tax_name: 'Tax',
    tax: 0,
    provinces: [],
  },
  {
    id: 539836448886,
    name: 'Uganda',
    code: 'UG',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 508180136054,
    name: 'United Arab Emirates',
    code: 'AE',
    tax_name: 'VAT',
    tax: 0,
    provinces: [
      {
        country_id: 508180136054,
        id: 5603099705462,
        name: 'Abu Dhabi',
        code: 'AZ',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180136054,
        id: 5603099738230,
        name: 'Ajman',
        code: 'AJ',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180136054,
        id: 5603099770998,
        name: 'Dubai',
        code: 'DU',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180136054,
        id: 5603099803766,
        name: 'Fujairah',
        code: 'FU',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180136054,
        id: 5603099836534,
        name: 'Ras al-Khaimah',
        code: 'RK',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180136054,
        id: 5603099869302,
        name: 'Sharjah',
        code: 'SH',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180136054,
        id: 5603099902070,
        name: 'Umm al-Quwain',
        code: 'UQ',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
    ],
  },
  {
    id: 508180529270,
    name: 'United Kingdom',
    code: 'GB',
    tax_name: 'GB VAT',
    tax: 0,
    provinces: [
      {
        country_id: 508180529270,
        id: 5603102326902,
        name: 'British Forces',
        code: 'BFP',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180529270,
        id: 5603102359670,
        name: 'England',
        code: 'ENG',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180529270,
        id: 5603102392438,
        name: 'Northern Ireland',
        code: 'NIR',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180529270,
        id: 5603102425206,
        name: 'Scotland',
        code: 'SCT',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180529270,
        id: 5603102457974,
        name: 'Wales',
        code: 'WLS',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
    ],
  },
  {
    id: 508180103286,
    name: 'United States',
    code: 'US',
    tax_name: 'Federal Tax',
    tax: 0,
    provinces: [
      {
        country_id: 508180103286,
        id: 5603097673846,
        name: 'Alabama',
        code: 'AL',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180103286,
        id: 5603097706614,
        name: 'Alaska',
        code: 'AK',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180103286,
        id: 5603097739382,
        name: 'American Samoa',
        code: 'AS',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180103286,
        id: 5603097772150,
        name: 'Arizona',
        code: 'AZ',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180103286,
        id: 5603097804918,
        name: 'Arkansas',
        code: 'AR',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180103286,
        id: 5603099607158,
        name: 'Armed Forces Americas',
        code: 'AA',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180103286,
        id: 5603099639926,
        name: 'Armed Forces Europe',
        code: 'AE',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180103286,
        id: 5603099672694,
        name: 'Armed Forces Pacific',
        code: 'AP',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180103286,
        id: 5603097837686,
        name: 'California',
        code: 'CA',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180103286,
        id: 5603097870454,
        name: 'Colorado',
        code: 'CO',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180103286,
        id: 5603097903222,
        name: 'Connecticut',
        code: 'CT',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180103286,
        id: 5603097935990,
        name: 'Delaware',
        code: 'DE',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180103286,
        id: 5603099443318,
        name: 'District of Columbia',
        code: 'DC',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180103286,
        id: 5603097968758,
        name: 'Federated States of Micronesia',
        code: 'FM',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180103286,
        id: 5603098001526,
        name: 'Florida',
        code: 'FL',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180103286,
        id: 5603098034294,
        name: 'Georgia',
        code: 'GA',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180103286,
        id: 5603098067062,
        name: 'Guam',
        code: 'GU',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180103286,
        id: 5603098099830,
        name: 'Hawaii',
        code: 'HI',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180103286,
        id: 5603098132598,
        name: 'Idaho',
        code: 'ID',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180103286,
        id: 5603098165366,
        name: 'Illinois',
        code: 'IL',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180103286,
        id: 5603098198134,
        name: 'Indiana',
        code: 'IN',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180103286,
        id: 5603098230902,
        name: 'Iowa',
        code: 'IA',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180103286,
        id: 5603098263670,
        name: 'Kansas',
        code: 'KS',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180103286,
        id: 5603098296438,
        name: 'Kentucky',
        code: 'KY',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180103286,
        id: 5603098329206,
        name: 'Louisiana',
        code: 'LA',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180103286,
        id: 5603098361974,
        name: 'Maine',
        code: 'ME',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180103286,
        id: 5603098394742,
        name: 'Marshall Islands',
        code: 'MH',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180103286,
        id: 5603098427510,
        name: 'Maryland',
        code: 'MD',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180103286,
        id: 5603098460278,
        name: 'Massachusetts',
        code: 'MA',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180103286,
        id: 5603098493046,
        name: 'Michigan',
        code: 'MI',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180103286,
        id: 5603098525814,
        name: 'Minnesota',
        code: 'MN',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180103286,
        id: 5603098558582,
        name: 'Mississippi',
        code: 'MS',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180103286,
        id: 5603098591350,
        name: 'Missouri',
        code: 'MO',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180103286,
        id: 5603098624118,
        name: 'Montana',
        code: 'MT',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180103286,
        id: 5603098656886,
        name: 'Nebraska',
        code: 'NE',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180103286,
        id: 5603098689654,
        name: 'Nevada',
        code: 'NV',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180103286,
        id: 5603098722422,
        name: 'New Hampshire',
        code: 'NH',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180103286,
        id: 5603098755190,
        name: 'New Jersey',
        code: 'NJ',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180103286,
        id: 5603098787958,
        name: 'New Mexico',
        code: 'NM',
        tax_name: 'GRT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180103286,
        id: 5603098820726,
        name: 'New York',
        code: 'NY',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180103286,
        id: 5603098853494,
        name: 'North Carolina',
        code: 'NC',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180103286,
        id: 5603098886262,
        name: 'North Dakota',
        code: 'ND',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180103286,
        id: 5603098919030,
        name: 'Northern Mariana Islands',
        code: 'MP',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180103286,
        id: 5603098951798,
        name: 'Ohio',
        code: 'OH',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180103286,
        id: 5603098984566,
        name: 'Oklahoma',
        code: 'OK',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180103286,
        id: 5603099017334,
        name: 'Oregon',
        code: 'OR',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180103286,
        id: 5603099050102,
        name: 'Palau',
        code: 'PW',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180103286,
        id: 5603099082870,
        name: 'Pennsylvania',
        code: 'PA',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180103286,
        id: 5603099115638,
        name: 'Puerto Rico',
        code: 'PR',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180103286,
        id: 5603099148406,
        name: 'Rhode Island',
        code: 'RI',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180103286,
        id: 5603099181174,
        name: 'South Carolina',
        code: 'SC',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180103286,
        id: 5603099213942,
        name: 'South Dakota',
        code: 'SD',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180103286,
        id: 5603099246710,
        name: 'Tennessee',
        code: 'TN',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180103286,
        id: 5603099279478,
        name: 'Texas',
        code: 'TX',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180103286,
        id: 5603099312246,
        name: 'Utah',
        code: 'UT',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180103286,
        id: 5603099345014,
        name: 'Vermont',
        code: 'VT',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180103286,
        id: 5603099574390,
        name: 'Virgin Islands',
        code: 'VI',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180103286,
        id: 5603099377782,
        name: 'Virginia',
        code: 'VA',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180103286,
        id: 5603099410550,
        name: 'Washington',
        code: 'WA',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180103286,
        id: 5603099476086,
        name: 'West Virginia',
        code: 'WV',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180103286,
        id: 5603099508854,
        name: 'Wisconsin',
        code: 'WI',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 508180103286,
        id: 5603099541622,
        name: 'Wyoming',
        code: 'WY',
        tax_name: 'State Tax',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
    ],
  },
  {
    id: 518034915446,
    name: 'United States Minor Outlying Islands',
    code: 'UM',
    tax_name: 'Tax',
    tax: 0,
    provinces: [],
  },
  {
    id: 518035439734,
    name: 'Uruguay',
    code: 'UY',
    tax_name: 'VAT',
    tax: 0,
    provinces: [
      {
        country_id: 518035439734,
        id: 5741022085238,
        name: 'Artigas',
        code: 'UY-AR',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035439734,
        id: 5741022118006,
        name: 'Canelones',
        code: 'UY-CA',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035439734,
        id: 5741022150774,
        name: 'Cerro Largo',
        code: 'UY-CL',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035439734,
        id: 5741022183542,
        name: 'Colonia',
        code: 'UY-CO',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035439734,
        id: 5741022216310,
        name: 'Durazno',
        code: 'UY-DU',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035439734,
        id: 5741022249078,
        name: 'Flores',
        code: 'UY-FS',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035439734,
        id: 5741022281846,
        name: 'Florida',
        code: 'UY-FD',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035439734,
        id: 5741022314614,
        name: 'Lavalleja',
        code: 'UY-LA',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035439734,
        id: 5741022347382,
        name: 'Maldonado',
        code: 'UY-MA',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035439734,
        id: 5741022380150,
        name: 'Montevideo',
        code: 'UY-MO',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035439734,
        id: 5741022412918,
        name: 'Paysandú',
        code: 'UY-PA',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035439734,
        id: 5741022445686,
        name: 'Río Negro',
        code: 'UY-RN',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035439734,
        id: 5741022478454,
        name: 'Rivera',
        code: 'UY-RV',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035439734,
        id: 5741022511222,
        name: 'Rocha',
        code: 'UY-RO',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035439734,
        id: 5741022543990,
        name: 'Salto',
        code: 'UY-SA',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035439734,
        id: 5741022576758,
        name: 'San José',
        code: 'UY-SJ',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035439734,
        id: 5741022609526,
        name: 'Soriano',
        code: 'UY-SO',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035439734,
        id: 5741022642294,
        name: 'Tacuarembó',
        code: 'UY-TA',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035439734,
        id: 5741022675062,
        name: 'Treinta y Tres',
        code: 'UY-TT',
        tax_name: 'VAT',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
    ],
  },
  {
    id: 518031933558,
    name: 'Uzbekistan',
    code: 'UZ',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 518034948214,
    name: 'Vanuatu',
    code: 'VU',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 518035472502,
    name: 'Venezuela',
    code: 'VE',
    tax_name: 'IVA',
    tax: 0,
    provinces: [
      {
        country_id: 518035472502,
        id: 5741022707830,
        name: 'Amazonas',
        code: 'VE-Z',
        tax_name: 'IVA',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035472502,
        id: 5741022740598,
        name: 'Anzoátegui',
        code: 'VE-B',
        tax_name: 'IVA',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035472502,
        id: 5741022773366,
        name: 'Apure',
        code: 'VE-C',
        tax_name: 'IVA',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035472502,
        id: 5741022806134,
        name: 'Aragua',
        code: 'VE-D',
        tax_name: 'IVA',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035472502,
        id: 5741022838902,
        name: 'Barinas',
        code: 'VE-E',
        tax_name: 'IVA',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035472502,
        id: 5741022871670,
        name: 'Bolívar',
        code: 'VE-F',
        tax_name: 'IVA',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035472502,
        id: 5741022904438,
        name: 'Carabobo',
        code: 'VE-G',
        tax_name: 'IVA',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035472502,
        id: 5741022937206,
        name: 'Cojedes',
        code: 'VE-H',
        tax_name: 'IVA',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035472502,
        id: 5741022969974,
        name: 'Delta Amacuro',
        code: 'VE-Y',
        tax_name: 'IVA',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035472502,
        id: 5741023002742,
        name: 'Dependencias Federales',
        code: 'VE-W',
        tax_name: 'IVA',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035472502,
        id: 5741023035510,
        name: 'Distrito Capital',
        code: 'VE-A',
        tax_name: 'IVA',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035472502,
        id: 5741023068278,
        name: 'Falcón',
        code: 'VE-I',
        tax_name: 'IVA',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035472502,
        id: 5741023101046,
        name: 'Guárico',
        code: 'VE-J',
        tax_name: 'IVA',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035472502,
        id: 5741023133814,
        name: 'La Guaira',
        code: 'VE-X',
        tax_name: 'IVA',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035472502,
        id: 5741023166582,
        name: 'Lara',
        code: 'VE-K',
        tax_name: 'IVA',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035472502,
        id: 5741023199350,
        name: 'Mérida',
        code: 'VE-L',
        tax_name: 'IVA',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035472502,
        id: 5741023232118,
        name: 'Miranda',
        code: 'VE-M',
        tax_name: 'IVA',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035472502,
        id: 5741023264886,
        name: 'Monagas',
        code: 'VE-N',
        tax_name: 'IVA',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035472502,
        id: 5741023297654,
        name: 'Nueva Esparta',
        code: 'VE-O',
        tax_name: 'IVA',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035472502,
        id: 5741023330422,
        name: 'Portuguesa',
        code: 'VE-P',
        tax_name: 'IVA',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035472502,
        id: 5741023363190,
        name: 'Sucre',
        code: 'VE-R',
        tax_name: 'IVA',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035472502,
        id: 5741023395958,
        name: 'Táchira',
        code: 'VE-S',
        tax_name: 'IVA',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035472502,
        id: 5741023428726,
        name: 'Trujillo',
        code: 'VE-T',
        tax_name: 'IVA',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035472502,
        id: 5741023461494,
        name: 'Yaracuy',
        code: 'VE-U',
        tax_name: 'IVA',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
      {
        country_id: 518035472502,
        id: 5741023494262,
        name: 'Zulia',
        code: 'VE-V',
        tax_name: 'IVA',
        tax_type: null,
        shipping_zone_id: null,
        tax: 0,
        tax_percentage: 0,
      },
    ],
  },
  {
    id: 518031966326,
    name: 'Vietnam',
    code: 'VN',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 518033408118,
    name: 'Virgin Islands, British',
    code: 'VG',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 518034980982,
    name: 'Wallis And Futuna',
    code: 'WF',
    tax_name: 'Tax',
    tax: 0,
    provinces: [],
  },
  {
    id: 539836481654,
    name: 'Western Sahara',
    code: 'EH',
    tax_name: 'Tax',
    tax: 0,
    provinces: [],
  },
  {
    id: 518031999094,
    name: 'Yemen',
    code: 'YE',
    tax_name: 'GST',
    tax: 0,
    provinces: [],
  },
  {
    id: 539836514422,
    name: 'Zambia',
    code: 'ZM',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
  {
    id: 539836547190,
    name: 'Zimbabwe',
    code: 'ZW',
    tax_name: 'VAT',
    tax: 0,
    provinces: [],
  },
];

export const stateList = [
  {
    country_id: 518035013750,
    id: 5741017956470,
    name: 'Buenos Aires',
    code: 'B',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035013750,
    id: 5741017989238,
    name: 'Catamarca',
    code: 'K',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035013750,
    id: 5741018022006,
    name: 'Chaco',
    code: 'H',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035013750,
    id: 5741018054774,
    name: 'Chubut',
    code: 'U',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035013750,
    id: 5741018087542,
    name: 'Ciudad Autónoma de Buenos Aires',
    code: 'C',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035013750,
    id: 5741018120310,
    name: 'Córdoba',
    code: 'X',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035013750,
    id: 5741018153078,
    name: 'Corrientes',
    code: 'W',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035013750,
    id: 5741018185846,
    name: 'Entre Ríos',
    code: 'E',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035013750,
    id: 5741018218614,
    name: 'Formosa',
    code: 'P',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035013750,
    id: 5741018251382,
    name: 'Jujuy',
    code: 'Y',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035013750,
    id: 5741018284150,
    name: 'La Pampa',
    code: 'L',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035013750,
    id: 5741018316918,
    name: 'La Rioja',
    code: 'F',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035013750,
    id: 5741018349686,
    name: 'Mendoza',
    code: 'M',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035013750,
    id: 5741018382454,
    name: 'Misiones',
    code: 'N',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035013750,
    id: 5741018415222,
    name: 'Neuquén',
    code: 'Q',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035013750,
    id: 5741018447990,
    name: 'Río Negro',
    code: 'R',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035013750,
    id: 5741018480758,
    name: 'Salta',
    code: 'A',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035013750,
    id: 5741018513526,
    name: 'San Juan',
    code: 'J',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035013750,
    id: 5741018546294,
    name: 'San Luis',
    code: 'D',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035013750,
    id: 5741018579062,
    name: 'Santa Cruz',
    code: 'Z',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035013750,
    id: 5741018611830,
    name: 'Santa Fe',
    code: 'S',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035013750,
    id: 5741018644598,
    name: 'Santiago Del Estero',
    code: 'G',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035013750,
    id: 5741018677366,
    name: 'Tierra Del Fuego',
    code: 'V',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035013750,
    id: 5741018710134,
    name: 'Tucumán',
    code: 'T',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180201590,
    id: 5603099934838,
    name: 'Australian Capital Territory',
    code: 'ACT',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180201590,
    id: 5603099967606,
    name: 'New South Wales',
    code: 'NSW',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180201590,
    id: 5603100000374,
    name: 'Northern Territory',
    code: 'NT',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180201590,
    id: 5603100033142,
    name: 'Queensland',
    code: 'QLD',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180201590,
    id: 5603100065910,
    name: 'South Australia',
    code: 'SA',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180201590,
    id: 5603100098678,
    name: 'Tasmania',
    code: 'TAS',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180201590,
    id: 5603100131446,
    name: 'Victoria',
    code: 'VIC',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180201590,
    id: 5603100164214,
    name: 'Western Australia',
    code: 'WA',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035079286,
    id: 5741018742902,
    name: 'Acre',
    code: 'AC',
    tax_name: 'ICMS',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035079286,
    id: 5741018775670,
    name: 'Alagoas',
    code: 'AL',
    tax_name: 'ICMS',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035079286,
    id: 5741018808438,
    name: 'Amapá',
    code: 'AP',
    tax_name: 'ICMS',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035079286,
    id: 5741018841206,
    name: 'Amazonas',
    code: 'AM',
    tax_name: 'ICMS',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035079286,
    id: 5741018873974,
    name: 'Bahia',
    code: 'BA',
    tax_name: 'ICMS',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035079286,
    id: 5741018906742,
    name: 'Ceará',
    code: 'CE',
    tax_name: 'ICMS',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035079286,
    id: 5741018939510,
    name: 'Distrito Federal',
    code: 'DF',
    tax_name: 'ICMS',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035079286,
    id: 5741018972278,
    name: 'Espírito Santo',
    code: 'ES',
    tax_name: 'ICMS',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035079286,
    id: 5741019005046,
    name: 'Goiás',
    code: 'GO',
    tax_name: 'ICMS',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035079286,
    id: 5741019037814,
    name: 'Maranhão',
    code: 'MA',
    tax_name: 'ICMS',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035079286,
    id: 5741019070582,
    name: 'Mato Grosso',
    code: 'MT',
    tax_name: 'ICMS',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035079286,
    id: 5741019103350,
    name: 'Mato Grosso do Sul',
    code: 'MS',
    tax_name: 'ICMS',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035079286,
    id: 5741019136118,
    name: 'Minas Gerais',
    code: 'MG',
    tax_name: 'ICMS',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035079286,
    id: 5741019168886,
    name: 'Pará',
    code: 'PA',
    tax_name: 'ICMS',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035079286,
    id: 5741019201654,
    name: 'Paraíba',
    code: 'PB',
    tax_name: 'ICMS',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035079286,
    id: 5741019234422,
    name: 'Paraná',
    code: 'PR',
    tax_name: 'ICMS',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035079286,
    id: 5741019267190,
    name: 'Pernambuco',
    code: 'PE',
    tax_name: 'ICMS',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035079286,
    id: 5741019299958,
    name: 'Piauí',
    code: 'PI',
    tax_name: 'ICMS',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035079286,
    id: 5741019398262,
    name: 'Rio de Janeiro',
    code: 'RJ',
    tax_name: 'ICMS',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035079286,
    id: 5741019332726,
    name: 'Rio Grande do Norte',
    code: 'RN',
    tax_name: 'ICMS',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035079286,
    id: 5741019365494,
    name: 'Rio Grande do Sul',
    code: 'RS',
    tax_name: 'ICMS',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035079286,
    id: 5741019431030,
    name: 'Rondônia',
    code: 'RO',
    tax_name: 'ICMS',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035079286,
    id: 5741019463798,
    name: 'Roraima',
    code: 'RR',
    tax_name: 'ICMS',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035079286,
    id: 5741019496566,
    name: 'Santa Catarina',
    code: 'SC',
    tax_name: 'ICMS',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035079286,
    id: 5741019529334,
    name: 'São Paulo',
    code: 'SP',
    tax_name: 'ICMS',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035079286,
    id: 5741019562102,
    name: 'Sergipe',
    code: 'SE',
    tax_name: 'ICMS',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035079286,
    id: 5741019594870,
    name: 'Tocantins',
    code: 'TO',
    tax_name: 'ICMS',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180267126,
    id: 5603100196982,
    name: 'Alberta',
    code: 'AB',
    tax_name: 'PST',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180267126,
    id: 5603100229750,
    name: 'British Columbia',
    code: 'BC',
    tax_name: 'PST',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180267126,
    id: 5603100262518,
    name: 'Manitoba',
    code: 'MB',
    tax_name: 'RST',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180267126,
    id: 5603100295286,
    name: 'New Brunswick',
    code: 'NB',
    tax_name: 'HST',
    tax_type: 'harmonized',
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180267126,
    id: 5603100328054,
    name: 'Newfoundland and Labrador',
    code: 'NL',
    tax_name: 'HST',
    tax_type: 'harmonized',
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180267126,
    id: 5603100360822,
    name: 'Northwest Territories',
    code: 'NT',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180267126,
    id: 5603100393590,
    name: 'Nova Scotia',
    code: 'NS',
    tax_name: 'HST',
    tax_type: 'harmonized',
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180267126,
    id: 5603100426358,
    name: 'Nunavut',
    code: 'NU',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180267126,
    id: 5603100459126,
    name: 'Ontario',
    code: 'ON',
    tax_name: 'HST',
    tax_type: 'harmonized',
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180267126,
    id: 5603100491894,
    name: 'Prince Edward Island',
    code: 'PE',
    tax_name: 'HST',
    tax_type: 'harmonized',
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180267126,
    id: 5603100524662,
    name: 'Quebec',
    code: 'QC',
    tax_name: 'QST',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180267126,
    id: 5603100557430,
    name: 'Saskatchewan',
    code: 'SK',
    tax_name: 'PST',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180267126,
    id: 5603100590198,
    name: 'Yukon',
    code: 'YT',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035112054,
    id: 5741019693174,
    name: 'Antofagasta',
    code: 'AN',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035112054,
    id: 5741019988086,
    name: 'Araucanía',
    code: 'AR',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035112054,
    id: 5741019627638,
    name: 'Arica and Parinacota',
    code: 'AP',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035112054,
    id: 5741019725942,
    name: 'Atacama',
    code: 'AT',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035112054,
    id: 5741020086390,
    name: 'Aysén',
    code: 'AI',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035112054,
    id: 5741019955318,
    name: 'Biobío',
    code: 'BI',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035112054,
    id: 5741019758710,
    name: 'Coquimbo',
    code: 'CO',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035112054,
    id: 5741020053622,
    name: 'Los Lagos',
    code: 'LL',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035112054,
    id: 5741020020854,
    name: 'Los Ríos',
    code: 'LR',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035112054,
    id: 5741020119158,
    name: 'Magallanes',
    code: 'MA',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035112054,
    id: 5741019889782,
    name: 'Maule',
    code: 'ML',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035112054,
    id: 5741019922550,
    name: 'Ñuble',
    code: 'NB',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035112054,
    id: 5741019857014,
    name: "O'Higgins",
    code: 'LI',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035112054,
    id: 5741019824246,
    name: 'Santiago',
    code: 'RM',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035112054,
    id: 5741019660406,
    name: 'Tarapacá',
    code: 'TA',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035112054,
    id: 5741019791478,
    name: 'Valparaíso',
    code: 'VS',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539836612726,
    id: 6043602780278,
    name: 'Anhui',
    code: 'AH',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539836612726,
    id: 6043602813046,
    name: 'Beijing',
    code: 'BJ',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539836612726,
    id: 6043602845814,
    name: 'Chongqing',
    code: 'CQ',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539836612726,
    id: 6043602878582,
    name: 'Fujian',
    code: 'FJ',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539836612726,
    id: 6043602911350,
    name: 'Gansu',
    code: 'GS',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539836612726,
    id: 6043602944118,
    name: 'Guangdong',
    code: 'GD',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539836612726,
    id: 6043602976886,
    name: 'Guangxi',
    code: 'GX',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539836612726,
    id: 6043603009654,
    name: 'Guizhou',
    code: 'GZ',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539836612726,
    id: 6043603042422,
    name: 'Hainan',
    code: 'HI',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539836612726,
    id: 6043603075190,
    name: 'Hebei',
    code: 'HE',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539836612726,
    id: 6043603107958,
    name: 'Heilongjiang',
    code: 'HL',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539836612726,
    id: 6043603140726,
    name: 'Henan',
    code: 'HA',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539836612726,
    id: 6043603173494,
    name: 'Hubei',
    code: 'HB',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539836612726,
    id: 6043603206262,
    name: 'Hunan',
    code: 'HN',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539836612726,
    id: 6043603239030,
    name: 'Inner Mongolia',
    code: 'NM',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539836612726,
    id: 6043603271798,
    name: 'Jiangsu',
    code: 'JS',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539836612726,
    id: 6043603304566,
    name: 'Jiangxi',
    code: 'JX',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539836612726,
    id: 6043603337334,
    name: 'Jilin',
    code: 'JL',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539836612726,
    id: 6043603370102,
    name: 'Liaoning',
    code: 'LN',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539836612726,
    id: 6043603402870,
    name: 'Ningxia',
    code: 'NX',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539836612726,
    id: 6043603435638,
    name: 'Qinghai',
    code: 'QH',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539836612726,
    id: 6043603468406,
    name: 'Shaanxi',
    code: 'SN',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539836612726,
    id: 6043603501174,
    name: 'Shandong',
    code: 'SD',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539836612726,
    id: 6043603533942,
    name: 'Shanghai',
    code: 'SH',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539836612726,
    id: 6043603566710,
    name: 'Shanxi',
    code: 'SX',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539836612726,
    id: 6043603599478,
    name: 'Sichuan',
    code: 'SC',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539836612726,
    id: 6043603632246,
    name: 'Tianjin',
    code: 'TJ',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539836612726,
    id: 6043603665014,
    name: 'Xinjiang',
    code: 'XJ',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539836612726,
    id: 6043603697782,
    name: 'Xizang',
    code: 'YZ',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539836612726,
    id: 6043603730550,
    name: 'Yunnan',
    code: 'YN',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539836612726,
    id: 6043603763318,
    name: 'Zhejiang',
    code: 'ZJ',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035144822,
    id: 5741020184694,
    name: 'Amazonas',
    code: 'AMA',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035144822,
    id: 5741020217462,
    name: 'Antioquia',
    code: 'ANT',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035144822,
    id: 5741020250230,
    name: 'Arauca',
    code: 'ARA',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035144822,
    id: 5741020282998,
    name: 'Atlántico',
    code: 'ATL',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035144822,
    id: 5741020151926,
    name: 'Bogotá, D.C.',
    code: 'DC',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035144822,
    id: 5741020315766,
    name: 'Bolívar',
    code: 'BOL',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035144822,
    id: 5741020348534,
    name: 'Boyacá',
    code: 'BOY',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035144822,
    id: 5741020381302,
    name: 'Caldas',
    code: 'CAL',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035144822,
    id: 5741020414070,
    name: 'Caquetá',
    code: 'CAQ',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035144822,
    id: 5741020446838,
    name: 'Casanare',
    code: 'CAS',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035144822,
    id: 5741020479606,
    name: 'Cauca',
    code: 'CAU',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035144822,
    id: 5741020512374,
    name: 'Cesar',
    code: 'CES',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035144822,
    id: 5741020545142,
    name: 'Chocó',
    code: 'CHO',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035144822,
    id: 5741020577910,
    name: 'Córdoba',
    code: 'COR',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035144822,
    id: 5741020610678,
    name: 'Cundinamarca',
    code: 'CUN',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035144822,
    id: 5741020643446,
    name: 'Guainía',
    code: 'GUA',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035144822,
    id: 5741020676214,
    name: 'Guaviare',
    code: 'GUV',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035144822,
    id: 5741020708982,
    name: 'Huila',
    code: 'HUI',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035144822,
    id: 5741020741750,
    name: 'La Guajira',
    code: 'LAG',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035144822,
    id: 5741020774518,
    name: 'Magdalena',
    code: 'MAG',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035144822,
    id: 5741020807286,
    name: 'Meta',
    code: 'MET',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035144822,
    id: 5741020840054,
    name: 'Nariño',
    code: 'NAR',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035144822,
    id: 5741020872822,
    name: 'Norte de Santander',
    code: 'NSA',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035144822,
    id: 5741020905590,
    name: 'Putumayo',
    code: 'PUT',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035144822,
    id: 5741020938358,
    name: 'Quindío',
    code: 'QUI',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035144822,
    id: 5741020971126,
    name: 'Risaralda',
    code: 'RIS',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035144822,
    id: 5741021003894,
    name: 'San Andrés, Providencia y Santa Catalina',
    code: 'SAP',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035144822,
    id: 5741021036662,
    name: 'Santander',
    code: 'SAN',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035144822,
    id: 5741021069430,
    name: 'Sucre',
    code: 'SUC',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035144822,
    id: 5741021102198,
    name: 'Tolima',
    code: 'TOL',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035144822,
    id: 5741021134966,
    name: 'Valle del Cauca',
    code: 'VAC',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035144822,
    id: 5741021167734,
    name: 'Vaupés',
    code: 'VAU',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035144822,
    id: 5741021200502,
    name: 'Vichada',
    code: 'VID',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518033506422,
    id: 5741015072886,
    name: 'Alajuela',
    code: 'CR-A',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518033506422,
    id: 5741015105654,
    name: 'Cartago',
    code: 'CR-C',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518033506422,
    id: 5741015138422,
    name: 'Guanacaste',
    code: 'CR-G',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518033506422,
    id: 5741015171190,
    name: 'Heredia',
    code: 'CR-H',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518033506422,
    id: 5741015203958,
    name: 'Limón',
    code: 'CR-L',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518033506422,
    id: 5741015236726,
    name: 'Puntarenas',
    code: 'CR-P',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518033506422,
    id: 5741015269494,
    name: 'San José',
    code: 'CR-SJ',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539835138166,
    id: 6043600617590,
    name: '6th of October',
    code: 'SU',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539835138166,
    id: 6043600650358,
    name: 'Al Sharqia',
    code: 'SHR',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539835138166,
    id: 6043600683126,
    name: 'Alexandria',
    code: 'ALX',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539835138166,
    id: 6043600715894,
    name: 'Aswan',
    code: 'ASN',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539835138166,
    id: 6043600748662,
    name: 'Asyut',
    code: 'AST',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539835138166,
    id: 6043600781430,
    name: 'Beheira',
    code: 'BH',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539835138166,
    id: 6043600814198,
    name: 'Beni Suef',
    code: 'BNS',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539835138166,
    id: 6043600846966,
    name: 'Cairo',
    code: 'C',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539835138166,
    id: 6043600879734,
    name: 'Dakahlia',
    code: 'DK',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539835138166,
    id: 6043600912502,
    name: 'Damietta',
    code: 'DT',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539835138166,
    id: 6043600945270,
    name: 'Faiyum',
    code: 'FYM',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539835138166,
    id: 6043600978038,
    name: 'Gharbia',
    code: 'GH',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539835138166,
    id: 6043601010806,
    name: 'Giza',
    code: 'GZ',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539835138166,
    id: 6043601043574,
    name: 'Helwan',
    code: 'HU',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539835138166,
    id: 6043601076342,
    name: 'Ismailia',
    code: 'IS',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539835138166,
    id: 6043601109110,
    name: 'Kafr el-Sheikh',
    code: 'KFS',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539835138166,
    id: 6043601141878,
    name: 'Luxor',
    code: 'LX',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539835138166,
    id: 6043601174646,
    name: 'Matrouh',
    code: 'MT',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539835138166,
    id: 6043601207414,
    name: 'Minya',
    code: 'MN',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539835138166,
    id: 6043601240182,
    name: 'Monufia',
    code: 'MNF',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539835138166,
    id: 6043601272950,
    name: 'New Valley',
    code: 'WAD',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539835138166,
    id: 6043601305718,
    name: 'North Sinai',
    code: 'SIN',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539835138166,
    id: 6043601338486,
    name: 'Port Said',
    code: 'PTS',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539835138166,
    id: 6043601371254,
    name: 'Qalyubia',
    code: 'KB',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539835138166,
    id: 6043601404022,
    name: 'Qena',
    code: 'KN',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539835138166,
    id: 6043601436790,
    name: 'Red Sea',
    code: 'BA',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539835138166,
    id: 6043601469558,
    name: 'Sohag',
    code: 'SHG',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539835138166,
    id: 6043601502326,
    name: 'South Sinai',
    code: 'JS',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539835138166,
    id: 6043601535094,
    name: 'Suez',
    code: 'SUZ',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518033637494,
    id: 5741015302262,
    name: 'Ahuachapán',
    code: 'SV-AH',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518033637494,
    id: 5741015335030,
    name: 'Cabañas',
    code: 'SV-CA',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518033637494,
    id: 5741015367798,
    name: 'Chalatenango',
    code: 'SV-CH',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518033637494,
    id: 5741015400566,
    name: 'Cuscatlán',
    code: 'SV-CU',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518033637494,
    id: 5741015433334,
    name: 'La Libertad',
    code: 'SV-LI',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518033637494,
    id: 5741015466102,
    name: 'La Paz',
    code: 'SV-PA',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518033637494,
    id: 5741015498870,
    name: 'La Unión',
    code: 'SV-UN',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518033637494,
    id: 5741015531638,
    name: 'Morazán',
    code: 'SV-MO',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518033637494,
    id: 5741015564406,
    name: 'San Miguel',
    code: 'SV-SM',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518033637494,
    id: 5741015597174,
    name: 'San Salvador',
    code: 'SV-SS',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518033637494,
    id: 5741015629942,
    name: 'San Vicente',
    code: 'SV-SV',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518033637494,
    id: 5741015662710,
    name: 'Santa Ana',
    code: 'SV-SA',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518033637494,
    id: 5741015695478,
    name: 'Sonsonate',
    code: 'SV-SO',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518033637494,
    id: 5741015728246,
    name: 'Usulután',
    code: 'SV-US',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518033768566,
    id: 5741015761014,
    name: 'Alta Verapaz',
    code: 'AVE',
    tax_name: 'IVA',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518033768566,
    id: 5741015793782,
    name: 'Baja Verapaz',
    code: 'BVE',
    tax_name: 'IVA',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518033768566,
    id: 5741015826550,
    name: 'Chimaltenango',
    code: 'CMT',
    tax_name: 'IVA',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518033768566,
    id: 5741015859318,
    name: 'Chiquimula',
    code: 'CQM',
    tax_name: 'IVA',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518033768566,
    id: 5741015892086,
    name: 'El Progreso',
    code: 'EPR',
    tax_name: 'IVA',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518033768566,
    id: 5741015924854,
    name: 'Escuintla',
    code: 'ESC',
    tax_name: 'IVA',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518033768566,
    id: 5741015957622,
    name: 'Guatemala',
    code: 'GUA',
    tax_name: 'IVA',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518033768566,
    id: 5741015990390,
    name: 'Huehuetenango',
    code: 'HUE',
    tax_name: 'IVA',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518033768566,
    id: 5741016023158,
    name: 'Izabal',
    code: 'IZA',
    tax_name: 'IVA',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518033768566,
    id: 5741016055926,
    name: 'Jalapa',
    code: 'JAL',
    tax_name: 'IVA',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518033768566,
    id: 5741016088694,
    name: 'Jutiapa',
    code: 'JUT',
    tax_name: 'IVA',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518033768566,
    id: 5741016121462,
    name: 'Petén',
    code: 'PET',
    tax_name: 'IVA',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518033768566,
    id: 5741016154230,
    name: 'Quetzaltenango',
    code: 'QUE',
    tax_name: 'IVA',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518033768566,
    id: 5741016186998,
    name: 'Quiché',
    code: 'QUI',
    tax_name: 'IVA',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518033768566,
    id: 5741016219766,
    name: 'Retalhuleu',
    code: 'RET',
    tax_name: 'IVA',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518033768566,
    id: 5741016252534,
    name: 'Sacatepéquez',
    code: 'SAC',
    tax_name: 'IVA',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518033768566,
    id: 5741016285302,
    name: 'San Marcos',
    code: 'SMA',
    tax_name: 'IVA',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518033768566,
    id: 5741016318070,
    name: 'Santa Rosa',
    code: 'SRO',
    tax_name: 'IVA',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518033768566,
    id: 5741016350838,
    name: 'Sololá',
    code: 'SOL',
    tax_name: 'IVA',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518033768566,
    id: 5741016383606,
    name: 'Suchitepéquez',
    code: 'SUC',
    tax_name: 'IVA',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518033768566,
    id: 5741016416374,
    name: 'Totonicapán',
    code: 'TOT',
    tax_name: 'IVA',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518033768566,
    id: 5741016449142,
    name: 'Zacapa',
    code: 'ZAC',
    tax_name: 'IVA',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180562038,
    id: 5603102490742,
    name: 'Hong Kong Island',
    code: 'HK',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180562038,
    id: 5603102523510,
    name: 'Kowloon',
    code: 'KL',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180562038,
    id: 5603102556278,
    name: 'New Territories',
    code: 'NT',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539836645494,
    id: 6043603796086,
    name: 'Andaman and Nicobar Islands',
    code: 'AN',
    tax_name: 'IGST',
    tax_type: 'harmonized',
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539836645494,
    id: 6043603828854,
    name: 'Andhra Pradesh',
    code: 'AP',
    tax_name: 'IGST',
    tax_type: 'harmonized',
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539836645494,
    id: 6043603861622,
    name: 'Arunachal Pradesh',
    code: 'AR',
    tax_name: 'IGST',
    tax_type: 'harmonized',
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539836645494,
    id: 6043603894390,
    name: 'Assam',
    code: 'AS',
    tax_name: 'IGST',
    tax_type: 'harmonized',
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539836645494,
    id: 6043603927158,
    name: 'Bihar',
    code: 'BR',
    tax_name: 'IGST',
    tax_type: 'harmonized',
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539836645494,
    id: 6043603959926,
    name: 'Chandigarh',
    code: 'CH',
    tax_name: 'IGST',
    tax_type: 'harmonized',
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539836645494,
    id: 6043603992694,
    name: 'Chhattisgarh',
    code: 'CG',
    tax_name: 'IGST',
    tax_type: 'harmonized',
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539836645494,
    id: 6043604025462,
    name: 'Dadra and Nagar Haveli',
    code: 'DN',
    tax_name: 'IGST',
    tax_type: 'harmonized',
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539836645494,
    id: 6043604058230,
    name: 'Daman and Diu',
    code: 'DD',
    tax_name: 'IGST',
    tax_type: 'harmonized',
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539836645494,
    id: 6043604090998,
    name: 'Delhi',
    code: 'DL',
    tax_name: 'IGST',
    tax_type: 'harmonized',
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539836645494,
    id: 6043604123766,
    name: 'Goa',
    code: 'GA',
    tax_name: 'IGST',
    tax_type: 'harmonized',
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539836645494,
    id: 6043604156534,
    name: 'Gujarat',
    code: 'GJ',
    tax_name: 'IGST',
    tax_type: 'harmonized',
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539836645494,
    id: 6043604189302,
    name: 'Haryana',
    code: 'HR',
    tax_name: 'IGST',
    tax_type: 'harmonized',
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539836645494,
    id: 6043604222070,
    name: 'Himachal Pradesh',
    code: 'HP',
    tax_name: 'IGST',
    tax_type: 'harmonized',
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539836645494,
    id: 6043604254838,
    name: 'Jammu and Kashmir',
    code: 'JK',
    tax_name: 'IGST',
    tax_type: 'harmonized',
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539836645494,
    id: 6043604287606,
    name: 'Jharkhand',
    code: 'JH',
    tax_name: 'IGST',
    tax_type: 'harmonized',
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539836645494,
    id: 6043604320374,
    name: 'Karnataka',
    code: 'KA',
    tax_name: 'SGST',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539836645494,
    id: 6043604353142,
    name: 'Kerala',
    code: 'KL',
    tax_name: 'IGST',
    tax_type: 'harmonized',
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539836645494,
    id: 6043604385910,
    name: 'Ladakh',
    code: 'LA',
    tax_name: 'IGST',
    tax_type: 'harmonized',
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539836645494,
    id: 6043604418678,
    name: 'Lakshadweep',
    code: 'LD',
    tax_name: 'IGST',
    tax_type: 'harmonized',
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539836645494,
    id: 6043604451446,
    name: 'Madhya Pradesh',
    code: 'MP',
    tax_name: 'IGST',
    tax_type: 'harmonized',
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539836645494,
    id: 6043604484214,
    name: 'Maharashtra',
    code: 'MH',
    tax_name: 'IGST',
    tax_type: 'harmonized',
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539836645494,
    id: 6043604516982,
    name: 'Manipur',
    code: 'MN',
    tax_name: 'IGST',
    tax_type: 'harmonized',
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539836645494,
    id: 6043604549750,
    name: 'Meghalaya',
    code: 'ML',
    tax_name: 'IGST',
    tax_type: 'harmonized',
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539836645494,
    id: 6043604582518,
    name: 'Mizoram',
    code: 'MZ',
    tax_name: 'IGST',
    tax_type: 'harmonized',
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539836645494,
    id: 6043604615286,
    name: 'Nagaland',
    code: 'NL',
    tax_name: 'IGST',
    tax_type: 'harmonized',
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539836645494,
    id: 6043604648054,
    name: 'Odisha',
    code: 'OR',
    tax_name: 'IGST',
    tax_type: 'harmonized',
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539836645494,
    id: 6043604680822,
    name: 'Puducherry',
    code: 'PY',
    tax_name: 'IGST',
    tax_type: 'harmonized',
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539836645494,
    id: 6043604713590,
    name: 'Punjab',
    code: 'PB',
    tax_name: 'IGST',
    tax_type: 'harmonized',
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539836645494,
    id: 6043604746358,
    name: 'Rajasthan',
    code: 'RJ',
    tax_name: 'IGST',
    tax_type: 'harmonized',
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539836645494,
    id: 6043604779126,
    name: 'Sikkim',
    code: 'SK',
    tax_name: 'IGST',
    tax_type: 'harmonized',
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539836645494,
    id: 6043604811894,
    name: 'Tamil Nadu',
    code: 'TN',
    tax_name: 'IGST',
    tax_type: 'harmonized',
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539836645494,
    id: 6043604844662,
    name: 'Telangana',
    code: 'TS',
    tax_name: 'IGST',
    tax_type: 'harmonized',
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539836645494,
    id: 6043604877430,
    name: 'Tripura',
    code: 'TR',
    tax_name: 'IGST',
    tax_type: 'harmonized',
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539836645494,
    id: 6043604910198,
    name: 'Uttar Pradesh',
    code: 'UP',
    tax_name: 'IGST',
    tax_type: 'harmonized',
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539836645494,
    id: 6043604942966,
    name: 'Uttarakhand',
    code: 'UK',
    tax_name: 'IGST',
    tax_type: 'harmonized',
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539836645494,
    id: 6043604975734,
    name: 'West Bengal',
    code: 'WB',
    tax_name: 'IGST',
    tax_type: 'harmonized',
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031114358,
    id: 5741004456054,
    name: 'Aceh',
    code: 'AC',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031114358,
    id: 5741004488822,
    name: 'Bali',
    code: 'BA',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031114358,
    id: 5741004521590,
    name: 'Bangka Belitung',
    code: 'BB',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031114358,
    id: 5741004554358,
    name: 'Banten',
    code: 'BT',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031114358,
    id: 5741004587126,
    name: 'Bengkulu',
    code: 'BE',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031114358,
    id: 5741004619894,
    name: 'Gorontalo',
    code: 'GO',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031114358,
    id: 5741004652662,
    name: 'Jakarta',
    code: 'JK',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031114358,
    id: 5741004685430,
    name: 'Jambi',
    code: 'JA',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031114358,
    id: 5741004718198,
    name: 'Jawa Barat',
    code: 'JB',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031114358,
    id: 5741004750966,
    name: 'Jawa Tengah',
    code: 'JT',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031114358,
    id: 5741004783734,
    name: 'Jawa Timur',
    code: 'JI',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031114358,
    id: 5741004816502,
    name: 'Kalimantan Barat',
    code: 'KB',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031114358,
    id: 5741004849270,
    name: 'Kalimantan Selatan',
    code: 'KS',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031114358,
    id: 5741004882038,
    name: 'Kalimantan Tengah',
    code: 'KT',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031114358,
    id: 5741004914806,
    name: 'Kalimantan Timur',
    code: 'KI',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031114358,
    id: 5741004947574,
    name: 'Kalimantan Utara',
    code: 'KU',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031114358,
    id: 5741004980342,
    name: 'Kepulauan Riau',
    code: 'KR',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031114358,
    id: 5741005013110,
    name: 'Lampung',
    code: 'LA',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031114358,
    id: 5741005045878,
    name: 'Maluku',
    code: 'MA',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031114358,
    id: 5741005078646,
    name: 'Maluku Utara',
    code: 'MU',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031114358,
    id: 5741005111414,
    name: 'North Sumatra',
    code: 'SU',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031114358,
    id: 5741005144182,
    name: 'Nusa Tenggara Barat',
    code: 'NB',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031114358,
    id: 5741005176950,
    name: 'Nusa Tenggara Timur',
    code: 'NT',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031114358,
    id: 5741005209718,
    name: 'Papua',
    code: 'PA',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031114358,
    id: 5741005242486,
    name: 'Papua Barat',
    code: 'PB',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031114358,
    id: 5741005275254,
    name: 'Riau',
    code: 'RI',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031114358,
    id: 5741005308022,
    name: 'South Sumatra',
    code: 'SS',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031114358,
    id: 5741005340790,
    name: 'Sulawesi Barat',
    code: 'SR',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031114358,
    id: 5741005373558,
    name: 'Sulawesi Selatan',
    code: 'SN',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031114358,
    id: 5741005406326,
    name: 'Sulawesi Tengah',
    code: 'ST',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031114358,
    id: 5741005439094,
    name: 'Sulawesi Tenggara',
    code: 'SG',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031114358,
    id: 5741005471862,
    name: 'Sulawesi Utara',
    code: 'SA',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031114358,
    id: 5741005504630,
    name: 'West Sumatra',
    code: 'SB',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031114358,
    id: 5741005537398,
    name: 'Yogyakarta',
    code: 'YO',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180594806,
    id: 5603102589046,
    name: 'Carlow',
    code: 'CW',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180594806,
    id: 5603102621814,
    name: 'Cavan',
    code: 'CN',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180594806,
    id: 5603102654582,
    name: 'Clare',
    code: 'CE',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180594806,
    id: 5603102687350,
    name: 'Cork',
    code: 'CO',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180594806,
    id: 5603102720118,
    name: 'Donegal',
    code: 'DL',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180594806,
    id: 5603102752886,
    name: 'Dublin',
    code: 'D',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180594806,
    id: 5603102785654,
    name: 'Galway',
    code: 'G',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180594806,
    id: 5603102818422,
    name: 'Kerry',
    code: 'KY',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180594806,
    id: 5603102851190,
    name: 'Kildare',
    code: 'KE',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180594806,
    id: 5603102883958,
    name: 'Kilkenny',
    code: 'KK',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180594806,
    id: 5603102916726,
    name: 'Laois',
    code: 'LS',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180594806,
    id: 5603102949494,
    name: 'Leitrim',
    code: 'LM',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180594806,
    id: 5603102982262,
    name: 'Limerick',
    code: 'LK',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180594806,
    id: 5603103015030,
    name: 'Longford',
    code: 'LD',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180594806,
    id: 5603103047798,
    name: 'Louth',
    code: 'LH',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180594806,
    id: 5603103080566,
    name: 'Mayo',
    code: 'MO',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180594806,
    id: 5603103113334,
    name: 'Meath',
    code: 'MH',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180594806,
    id: 5603103146102,
    name: 'Monaghan',
    code: 'MN',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180594806,
    id: 5603103178870,
    name: 'Offaly',
    code: 'OY',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180594806,
    id: 5603103211638,
    name: 'Roscommon',
    code: 'RN',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180594806,
    id: 5603103244406,
    name: 'Sligo',
    code: 'SO',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180594806,
    id: 5603103277174,
    name: 'Tipperary',
    code: 'TA',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180594806,
    id: 5603103309942,
    name: 'Waterford',
    code: 'WD',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180594806,
    id: 5603103342710,
    name: 'Westmeath',
    code: 'WH',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180594806,
    id: 5603103375478,
    name: 'Wexford',
    code: 'WX',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180594806,
    id: 5603103408246,
    name: 'Wicklow',
    code: 'WW',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603103441014,
    name: 'Agrigento',
    code: 'AG',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603103473782,
    name: 'Alessandria',
    code: 'AL',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603103506550,
    name: 'Ancona',
    code: 'AN',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603103539318,
    name: 'Aosta',
    code: 'AO',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603103572086,
    name: 'Arezzo',
    code: 'AR',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603103604854,
    name: 'Ascoli Piceno',
    code: 'AP',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603103637622,
    name: 'Asti',
    code: 'AT',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603103670390,
    name: 'Avellino',
    code: 'AV',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603103703158,
    name: 'Bari',
    code: 'BA',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603103735926,
    name: 'Barletta-Andria-Trani',
    code: 'BT',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603103768694,
    name: 'Belluno',
    code: 'BL',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603103801462,
    name: 'Benevento',
    code: 'BN',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603103834230,
    name: 'Bergamo',
    code: 'BG',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603103866998,
    name: 'Biella',
    code: 'BI',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603103899766,
    name: 'Bologna',
    code: 'BO',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603103932534,
    name: 'Bolzano',
    code: 'BZ',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603103965302,
    name: 'Brescia',
    code: 'BS',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603103998070,
    name: 'Brindisi',
    code: 'BR',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603104030838,
    name: 'Cagliari',
    code: 'CA',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603104063606,
    name: 'Caltanissetta',
    code: 'CL',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603104096374,
    name: 'Campobasso',
    code: 'CB',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603104129142,
    name: 'Carbonia-Iglesias',
    code: 'CI',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603104161910,
    name: 'Caserta',
    code: 'CE',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603104194678,
    name: 'Catania',
    code: 'CT',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603104227446,
    name: 'Catanzaro',
    code: 'CZ',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603104260214,
    name: 'Chieti',
    code: 'CH',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603104292982,
    name: 'Como',
    code: 'CO',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603104325750,
    name: 'Cosenza',
    code: 'CS',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603104358518,
    name: 'Cremona',
    code: 'CR',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603104391286,
    name: 'Crotone',
    code: 'KR',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603104424054,
    name: 'Cuneo',
    code: 'CN',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603104456822,
    name: 'Enna',
    code: 'EN',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603104489590,
    name: 'Fermo',
    code: 'FM',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603104522358,
    name: 'Ferrara',
    code: 'FE',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603104555126,
    name: 'Firenze',
    code: 'FI',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603104587894,
    name: 'Foggia',
    code: 'FG',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603104620662,
    name: 'Forlì-Cesena',
    code: 'FC',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603104653430,
    name: 'Frosinone',
    code: 'FR',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603104686198,
    name: 'Genova',
    code: 'GE',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603104718966,
    name: 'Gorizia',
    code: 'GO',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603104751734,
    name: 'Grosseto',
    code: 'GR',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603104784502,
    name: 'Imperia',
    code: 'IM',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603104817270,
    name: 'Isernia',
    code: 'IS',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603104850038,
    name: "L'Aquila",
    code: 'AQ',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603104882806,
    name: 'La Spezia',
    code: 'SP',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603104915574,
    name: 'Latina',
    code: 'LT',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603104948342,
    name: 'Lecce',
    code: 'LE',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603104981110,
    name: 'Lecco',
    code: 'LC',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603105013878,
    name: 'Livorno',
    code: 'LI',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603105046646,
    name: 'Lodi',
    code: 'LO',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603105079414,
    name: 'Lucca',
    code: 'LU',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603105112182,
    name: 'Macerata',
    code: 'MC',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603105144950,
    name: 'Mantova',
    code: 'MN',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603105177718,
    name: 'Massa-Carrara',
    code: 'MS',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603105210486,
    name: 'Matera',
    code: 'MT',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603105243254,
    name: 'Medio Campidano',
    code: 'VS',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603105276022,
    name: 'Messina',
    code: 'ME',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603105308790,
    name: 'Milano',
    code: 'MI',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603105341558,
    name: 'Modena',
    code: 'MO',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603105374326,
    name: 'Monza e Brianza',
    code: 'MB',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603105407094,
    name: 'Napoli',
    code: 'NA',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603105439862,
    name: 'Novara',
    code: 'NO',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603105472630,
    name: 'Nuoro',
    code: 'NU',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603105505398,
    name: 'Ogliastra',
    code: 'OG',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603105538166,
    name: 'Olbia-Tempio',
    code: 'OT',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603105570934,
    name: 'Oristano',
    code: 'OR',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603105603702,
    name: 'Padova',
    code: 'PD',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603105636470,
    name: 'Palermo',
    code: 'PA',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603105669238,
    name: 'Parma',
    code: 'PR',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603105702006,
    name: 'Pavia',
    code: 'PV',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603105734774,
    name: 'Perugia',
    code: 'PG',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603105767542,
    name: 'Pesaro e Urbino',
    code: 'PU',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603105800310,
    name: 'Pescara',
    code: 'PE',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603105833078,
    name: 'Piacenza',
    code: 'PC',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603105865846,
    name: 'Pisa',
    code: 'PI',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603105898614,
    name: 'Pistoia',
    code: 'PT',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603105931382,
    name: 'Pordenone',
    code: 'PN',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603105964150,
    name: 'Potenza',
    code: 'PZ',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603105996918,
    name: 'Prato',
    code: 'PO',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603106029686,
    name: 'Ragusa',
    code: 'RG',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603106062454,
    name: 'Ravenna',
    code: 'RA',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603106095222,
    name: 'Reggio Calabria',
    code: 'RC',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603106127990,
    name: 'Reggio Emilia',
    code: 'RE',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603106160758,
    name: 'Rieti',
    code: 'RI',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603106193526,
    name: 'Rimini',
    code: 'RN',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603106226294,
    name: 'Roma',
    code: 'RM',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603106259062,
    name: 'Rovigo',
    code: 'RO',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603106291830,
    name: 'Salerno',
    code: 'SA',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603106324598,
    name: 'Sassari',
    code: 'SS',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603106357366,
    name: 'Savona',
    code: 'SV',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603106390134,
    name: 'Siena',
    code: 'SI',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603106422902,
    name: 'Siracusa',
    code: 'SR',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603106455670,
    name: 'Sondrio',
    code: 'SO',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603106488438,
    name: 'Taranto',
    code: 'TA',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603106521206,
    name: 'Teramo',
    code: 'TE',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603106553974,
    name: 'Terni',
    code: 'TR',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603106586742,
    name: 'Torino',
    code: 'TO',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603106619510,
    name: 'Trapani',
    code: 'TP',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603106652278,
    name: 'Trento',
    code: 'TN',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603106685046,
    name: 'Treviso',
    code: 'TV',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603106717814,
    name: 'Trieste',
    code: 'TS',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603106750582,
    name: 'Udine',
    code: 'UD',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603106783350,
    name: 'Varese',
    code: 'VA',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603106816118,
    name: 'Venezia',
    code: 'VE',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603106848886,
    name: 'Verbano-Cusio-Ossola',
    code: 'VB',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603106881654,
    name: 'Vercelli',
    code: 'VC',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603106914422,
    name: 'Verona',
    code: 'VR',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603106947190,
    name: 'Vibo Valentia',
    code: 'VV',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603106979958,
    name: 'Vicenza',
    code: 'VI',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180660342,
    id: 5603107012726,
    name: 'Viterbo',
    code: 'VT',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180693110,
    id: 5603107766390,
    name: 'Aichi',
    code: 'JP-23',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180693110,
    id: 5603107176566,
    name: 'Akita',
    code: 'JP-05',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180693110,
    id: 5603107078262,
    name: 'Aomori',
    code: 'JP-02',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180693110,
    id: 5603107405942,
    name: 'Chiba',
    code: 'JP-12',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180693110,
    id: 5603108257910,
    name: 'Ehime',
    code: 'JP-38',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180693110,
    id: 5603107602550,
    name: 'Fukui',
    code: 'JP-18',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180693110,
    id: 5603108323446,
    name: 'Fukuoka',
    code: 'JP-40',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180693110,
    id: 5603107242102,
    name: 'Fukushima',
    code: 'JP-07',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180693110,
    id: 5603107700854,
    name: 'Gifu',
    code: 'JP-21',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180693110,
    id: 5603107340406,
    name: 'Gunma',
    code: 'JP-10',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180693110,
    id: 5603108126838,
    name: 'Hiroshima',
    code: 'JP-34',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180693110,
    id: 5603107045494,
    name: 'Hokkaidō',
    code: 'JP-01',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180693110,
    id: 5603107930230,
    name: 'Hyōgo',
    code: 'JP-28',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180693110,
    id: 5603107274870,
    name: 'Ibaraki',
    code: 'JP-08',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180693110,
    id: 5603107569782,
    name: 'Ishikawa',
    code: 'JP-17',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180693110,
    id: 5603107111030,
    name: 'Iwate',
    code: 'JP-03',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180693110,
    id: 5603108225142,
    name: 'Kagawa',
    code: 'JP-37',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180693110,
    id: 5603108520054,
    name: 'Kagoshima',
    code: 'JP-46',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180693110,
    id: 5603107471478,
    name: 'Kanagawa',
    code: 'JP-14',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180693110,
    id: 5603108290678,
    name: 'Kōchi',
    code: 'JP-39',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180693110,
    id: 5603108421750,
    name: 'Kumamoto',
    code: 'JP-43',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180693110,
    id: 5603107864694,
    name: 'Kyōto',
    code: 'JP-26',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180693110,
    id: 5603107799158,
    name: 'Mie',
    code: 'JP-24',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180693110,
    id: 5603107143798,
    name: 'Miyagi',
    code: 'JP-04',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180693110,
    id: 5603108487286,
    name: 'Miyazaki',
    code: 'JP-45',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180693110,
    id: 5603107668086,
    name: 'Nagano',
    code: 'JP-20',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180693110,
    id: 5603108388982,
    name: 'Nagasaki',
    code: 'JP-42',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180693110,
    id: 5603107962998,
    name: 'Nara',
    code: 'JP-29',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180693110,
    id: 5603107504246,
    name: 'Niigata',
    code: 'JP-15',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180693110,
    id: 5603108454518,
    name: 'Ōita',
    code: 'JP-44',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180693110,
    id: 5603108094070,
    name: 'Okayama',
    code: 'JP-33',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180693110,
    id: 5603108552822,
    name: 'Okinawa',
    code: 'JP-47',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180693110,
    id: 5603107897462,
    name: 'Ōsaka',
    code: 'JP-27',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180693110,
    id: 5603108356214,
    name: 'Saga',
    code: 'JP-41',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180693110,
    id: 5603107373174,
    name: 'Saitama',
    code: 'JP-11',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180693110,
    id: 5603107831926,
    name: 'Shiga',
    code: 'JP-25',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180693110,
    id: 5603108061302,
    name: 'Shimane',
    code: 'JP-32',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180693110,
    id: 5603107733622,
    name: 'Shizuoka',
    code: 'JP-22',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180693110,
    id: 5603107307638,
    name: 'Tochigi',
    code: 'JP-09',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180693110,
    id: 5603108192374,
    name: 'Tokushima',
    code: 'JP-36',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180693110,
    id: 5603107438710,
    name: 'Tōkyō',
    code: 'JP-13',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180693110,
    id: 5603108028534,
    name: 'Tottori',
    code: 'JP-31',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180693110,
    id: 5603107537014,
    name: 'Toyama',
    code: 'JP-16',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180693110,
    id: 5603107995766,
    name: 'Wakayama',
    code: 'JP-30',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180693110,
    id: 5603107209334,
    name: 'Yamagata',
    code: 'JP-06',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180693110,
    id: 5603108159606,
    name: 'Yamaguchi',
    code: 'JP-35',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180693110,
    id: 5603107635318,
    name: 'Yamanashi',
    code: 'JP-19',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031212662,
    id: 5741005570166,
    name: 'Al Ahmadi',
    code: 'KW-AH',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031212662,
    id: 5741005602934,
    name: 'Al Asimah',
    code: 'KW-KU',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031212662,
    id: 5741005635702,
    name: 'Al Farwaniyah',
    code: 'KW-FA',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031212662,
    id: 5741005668470,
    name: 'Al Jahra',
    code: 'KW-JA',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031212662,
    id: 5741005701238,
    name: 'Hawalli',
    code: 'KW-HA',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031212662,
    id: 5741005734006,
    name: 'Mubarak Al-Kabeer',
    code: 'KW-MU',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180758646,
    id: 5603109142646,
    name: 'Johor',
    code: 'JHR',
    tax_name: 'SST',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180758646,
    id: 5603109175414,
    name: 'Kedah',
    code: 'KDH',
    tax_name: 'SST',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180758646,
    id: 5603109208182,
    name: 'Kelantan',
    code: 'KTN',
    tax_name: 'SST',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180758646,
    id: 5603109240950,
    name: 'Kuala Lumpur',
    code: 'KUL',
    tax_name: 'SST',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180758646,
    id: 5603109273718,
    name: 'Labuan',
    code: 'LBN',
    tax_name: 'SST',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180758646,
    id: 5603109306486,
    name: 'Melaka',
    code: 'MLK',
    tax_name: 'SST',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180758646,
    id: 5603109339254,
    name: 'Negeri Sembilan',
    code: 'NSN',
    tax_name: 'SST',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180758646,
    id: 5603109372022,
    name: 'Pahang',
    code: 'PHG',
    tax_name: 'SST',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180758646,
    id: 5603109404790,
    name: 'Penang',
    code: 'PNG',
    tax_name: 'SST',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180758646,
    id: 5603109437558,
    name: 'Perak',
    code: 'PRK',
    tax_name: 'SST',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180758646,
    id: 5603109470326,
    name: 'Perlis',
    code: 'PLS',
    tax_name: 'SST',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180758646,
    id: 5603109503094,
    name: 'Putrajaya',
    code: 'PJY',
    tax_name: 'SST',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180758646,
    id: 5603109535862,
    name: 'Sabah',
    code: 'SBH',
    tax_name: 'SST',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180758646,
    id: 5603109568630,
    name: 'Sarawak',
    code: 'SWK',
    tax_name: 'SST',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180758646,
    id: 5603109601398,
    name: 'Selangor',
    code: 'SGR',
    tax_name: 'SST',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180758646,
    id: 5603109634166,
    name: 'Terengganu',
    code: 'TRG',
    tax_name: 'SST',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518033932406,
    id: 5741016481910,
    name: 'Aguascalientes',
    code: 'AGS',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518033932406,
    id: 5741016514678,
    name: 'Baja California',
    code: 'BC',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518033932406,
    id: 5741016547446,
    name: 'Baja California Sur',
    code: 'BCS',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518033932406,
    id: 5741016580214,
    name: 'Campeche',
    code: 'CAMP',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518033932406,
    id: 5741016612982,
    name: 'Chiapas',
    code: 'CHIS',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518033932406,
    id: 5741016645750,
    name: 'Chihuahua',
    code: 'CHIH',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518033932406,
    id: 5741016678518,
    name: 'Ciudad de México',
    code: 'DF',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518033932406,
    id: 5741016711286,
    name: 'Coahuila',
    code: 'COAH',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518033932406,
    id: 5741016744054,
    name: 'Colima',
    code: 'COL',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518033932406,
    id: 5741016776822,
    name: 'Durango',
    code: 'DGO',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518033932406,
    id: 5741016809590,
    name: 'Guanajuato',
    code: 'GTO',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518033932406,
    id: 5741016842358,
    name: 'Guerrero',
    code: 'GRO',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518033932406,
    id: 5741016875126,
    name: 'Hidalgo',
    code: 'HGO',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518033932406,
    id: 5741016907894,
    name: 'Jalisco',
    code: 'JAL',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518033932406,
    id: 5741016940662,
    name: 'México',
    code: 'MEX',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518033932406,
    id: 5741016973430,
    name: 'Michoacán',
    code: 'MICH',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518033932406,
    id: 5741017006198,
    name: 'Morelos',
    code: 'MOR',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518033932406,
    id: 5741017038966,
    name: 'Nayarit',
    code: 'NAY',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518033932406,
    id: 5741017071734,
    name: 'Nuevo León',
    code: 'NL',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518033932406,
    id: 5741017104502,
    name: 'Oaxaca',
    code: 'OAX',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518033932406,
    id: 5741017137270,
    name: 'Puebla',
    code: 'PUE',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518033932406,
    id: 5741017170038,
    name: 'Querétaro',
    code: 'QRO',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518033932406,
    id: 5741017202806,
    name: 'Quintana Roo',
    code: 'Q ROO',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518033932406,
    id: 5741017235574,
    name: 'San Luis Potosí',
    code: 'SLP',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518033932406,
    id: 5741017268342,
    name: 'Sinaloa',
    code: 'SIN',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518033932406,
    id: 5741017301110,
    name: 'Sonora',
    code: 'SON',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518033932406,
    id: 5741017333878,
    name: 'Tabasco',
    code: 'TAB',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518033932406,
    id: 5741017366646,
    name: 'Tamaulipas',
    code: 'TAMPS',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518033932406,
    id: 5741017399414,
    name: 'Tlaxcala',
    code: 'TLAX',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518033932406,
    id: 5741017432182,
    name: 'Veracruz',
    code: 'VER',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518033932406,
    id: 5741017464950,
    name: 'Yucatán',
    code: 'YUC',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518033932406,
    id: 5741017497718,
    name: 'Zacatecas',
    code: 'ZAC',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180856950,
    id: 5603109666934,
    name: 'Auckland',
    code: 'AUK',
    tax_name: 'GST',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180856950,
    id: 5603109699702,
    name: 'Bay of Plenty',
    code: 'BOP',
    tax_name: 'GST',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180856950,
    id: 5603109732470,
    name: 'Canterbury',
    code: 'CAN',
    tax_name: 'GST',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180856950,
    id: 5603109765238,
    name: 'Chatham Islands',
    code: 'CIT',
    tax_name: 'GST',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180856950,
    id: 5603109798006,
    name: 'Gisborne',
    code: 'GIS',
    tax_name: 'GST',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180856950,
    id: 5603109830774,
    name: "Hawke's Bay",
    code: 'HKB',
    tax_name: 'GST',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180856950,
    id: 5603109863542,
    name: 'Manawatu-Wanganui',
    code: 'MWT',
    tax_name: 'GST',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180856950,
    id: 5603109896310,
    name: 'Marlborough',
    code: 'MBH',
    tax_name: 'GST',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180856950,
    id: 5603109929078,
    name: 'Nelson',
    code: 'NSN',
    tax_name: 'GST',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180856950,
    id: 5603109961846,
    name: 'Northland',
    code: 'NTL',
    tax_name: 'GST',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180856950,
    id: 5603109994614,
    name: 'Otago',
    code: 'OTA',
    tax_name: 'GST',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180856950,
    id: 5603110027382,
    name: 'Southland',
    code: 'STL',
    tax_name: 'GST',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180856950,
    id: 5603110060150,
    name: 'Taranaki',
    code: 'TKI',
    tax_name: 'GST',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180856950,
    id: 5603110092918,
    name: 'Tasman',
    code: 'TAS',
    tax_name: 'GST',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180856950,
    id: 5603110125686,
    name: 'Waikato',
    code: 'WKO',
    tax_name: 'GST',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180856950,
    id: 5603110158454,
    name: 'Wellington',
    code: 'WGN',
    tax_name: 'GST',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180856950,
    id: 5603110191222,
    name: 'West Coast',
    code: 'WTC',
    tax_name: 'GST',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539835957366,
    id: 6043601567862,
    name: 'Abia',
    code: 'AB',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539835957366,
    id: 6043601600630,
    name: 'Abuja Federal Capital Territory',
    code: 'FC',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539835957366,
    id: 6043601633398,
    name: 'Adamawa',
    code: 'AD',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539835957366,
    id: 6043601666166,
    name: 'Akwa Ibom',
    code: 'AK',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539835957366,
    id: 6043601698934,
    name: 'Anambra',
    code: 'AN',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539835957366,
    id: 6043601731702,
    name: 'Bauchi',
    code: 'BA',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539835957366,
    id: 6043601764470,
    name: 'Bayelsa',
    code: 'BY',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539835957366,
    id: 6043601797238,
    name: 'Benue',
    code: 'BE',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539835957366,
    id: 6043601830006,
    name: 'Borno',
    code: 'BO',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539835957366,
    id: 6043601862774,
    name: 'Cross River',
    code: 'CR',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539835957366,
    id: 6043601895542,
    name: 'Delta',
    code: 'DE',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539835957366,
    id: 6043601928310,
    name: 'Ebonyi',
    code: 'EB',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539835957366,
    id: 6043601961078,
    name: 'Edo',
    code: 'ED',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539835957366,
    id: 6043601993846,
    name: 'Ekiti',
    code: 'EK',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539835957366,
    id: 6043602026614,
    name: 'Enugu',
    code: 'EN',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539835957366,
    id: 6043602059382,
    name: 'Gombe',
    code: 'GO',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539835957366,
    id: 6043602092150,
    name: 'Imo',
    code: 'IM',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539835957366,
    id: 6043602124918,
    name: 'Jigawa',
    code: 'JI',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539835957366,
    id: 6043602157686,
    name: 'Kaduna',
    code: 'KD',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539835957366,
    id: 6043602190454,
    name: 'Kano',
    code: 'KN',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539835957366,
    id: 6043602223222,
    name: 'Katsina',
    code: 'KT',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539835957366,
    id: 6043602255990,
    name: 'Kebbi',
    code: 'KE',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539835957366,
    id: 6043602288758,
    name: 'Kogi',
    code: 'KO',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539835957366,
    id: 6043602321526,
    name: 'Kwara',
    code: 'KW',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539835957366,
    id: 6043602354294,
    name: 'Lagos',
    code: 'LA',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539835957366,
    id: 6043602387062,
    name: 'Nasarawa',
    code: 'NA',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539835957366,
    id: 6043602419830,
    name: 'Niger',
    code: 'NI',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539835957366,
    id: 6043602452598,
    name: 'Ogun',
    code: 'OG',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539835957366,
    id: 6043602485366,
    name: 'Ondo',
    code: 'ON',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539835957366,
    id: 6043602518134,
    name: 'Osun',
    code: 'OS',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539835957366,
    id: 6043602550902,
    name: 'Oyo',
    code: 'OY',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539835957366,
    id: 6043602583670,
    name: 'Plateau',
    code: 'PL',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539835957366,
    id: 6043602616438,
    name: 'Rivers',
    code: 'RI',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539835957366,
    id: 6043602649206,
    name: 'Sokoto',
    code: 'SO',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539835957366,
    id: 6043602681974,
    name: 'Taraba',
    code: 'TA',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539835957366,
    id: 6043602714742,
    name: 'Yobe',
    code: 'YO',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 539835957366,
    id: 6043602747510,
    name: 'Zamfara',
    code: 'ZA',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518034030710,
    id: 5741017530486,
    name: 'Bocas del Toro',
    code: 'PA-1',
    tax_name: 'ITBMS',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518034030710,
    id: 5741017563254,
    name: 'Chiriquí',
    code: 'PA-4',
    tax_name: 'ITBMS',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518034030710,
    id: 5741017596022,
    name: 'Coclé',
    code: 'PA-2',
    tax_name: 'ITBMS',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518034030710,
    id: 5741017628790,
    name: 'Colón',
    code: 'PA-3',
    tax_name: 'ITBMS',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518034030710,
    id: 5741017661558,
    name: 'Darién',
    code: 'PA-5',
    tax_name: 'ITBMS',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518034030710,
    id: 5741017694326,
    name: 'Emberá',
    code: 'PA-EM',
    tax_name: 'ITBMS',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518034030710,
    id: 5741017727094,
    name: 'Herrera',
    code: 'PA-6',
    tax_name: 'ITBMS',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518034030710,
    id: 5741017759862,
    name: 'Kuna Yala',
    code: 'PA-KY',
    tax_name: 'ITBMS',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518034030710,
    id: 5741017792630,
    name: 'Los Santos',
    code: 'PA-7',
    tax_name: 'ITBMS',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518034030710,
    id: 5741017825398,
    name: 'Ngöbe-Buglé',
    code: 'PA-NB',
    tax_name: 'ITBMS',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518034030710,
    id: 5741017858166,
    name: 'Panamá',
    code: 'PA-8',
    tax_name: 'ITBMS',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518034030710,
    id: 5741017890934,
    name: 'Panamá Oeste',
    code: 'PA-10',
    tax_name: 'ITBMS',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518034030710,
    id: 5741017923702,
    name: 'Veraguas',
    code: 'PA-9',
    tax_name: 'ITBMS',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035341430,
    id: 5741021233270,
    name: 'Amazonas',
    code: 'PE-AMA',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035341430,
    id: 5741021266038,
    name: 'Áncash',
    code: 'PE-ANC',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035341430,
    id: 5741021298806,
    name: 'Apurímac',
    code: 'PE-APU',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035341430,
    id: 5741021331574,
    name: 'Arequipa',
    code: 'PE-ARE',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035341430,
    id: 5741021364342,
    name: 'Ayacucho',
    code: 'PE-AYA',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035341430,
    id: 5741021397110,
    name: 'Cajamarca',
    code: 'PE-CAJ',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035341430,
    id: 5741021429878,
    name: 'Callao',
    code: 'PE-CAL',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035341430,
    id: 5741021462646,
    name: 'Cuzco',
    code: 'PE-CUS',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035341430,
    id: 5741021495414,
    name: 'Huancavelica',
    code: 'PE-HUV',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035341430,
    id: 5741021528182,
    name: 'Huánuco',
    code: 'PE-HUC',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035341430,
    id: 5741021560950,
    name: 'Ica',
    code: 'PE-ICA',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035341430,
    id: 5741021593718,
    name: 'Junín',
    code: 'PE-JUN',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035341430,
    id: 5741021626486,
    name: 'La Libertad',
    code: 'PE-LAL',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035341430,
    id: 5741021659254,
    name: 'Lambayeque',
    code: 'PE-LAM',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035341430,
    id: 5741021692022,
    name: 'Lima (departamento)',
    code: 'PE-LIM',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035341430,
    id: 5741021724790,
    name: 'Lima (provincia)',
    code: 'PE-LMA',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035341430,
    id: 5741021757558,
    name: 'Loreto',
    code: 'PE-LOR',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035341430,
    id: 5741021790326,
    name: 'Madre de Dios',
    code: 'PE-MDD',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035341430,
    id: 5741021823094,
    name: 'Moquegua',
    code: 'PE-MOQ',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035341430,
    id: 5741021855862,
    name: 'Pasco',
    code: 'PE-PAS',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035341430,
    id: 5741021888630,
    name: 'Piura',
    code: 'PE-PIU',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035341430,
    id: 5741021921398,
    name: 'Puno',
    code: 'PE-PUN',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035341430,
    id: 5741021954166,
    name: 'San Martín',
    code: 'PE-SAM',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035341430,
    id: 5741021986934,
    name: 'Tacna',
    code: 'PE-TAC',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035341430,
    id: 5741022019702,
    name: 'Tumbes',
    code: 'PE-TUM',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035341430,
    id: 5741022052470,
    name: 'Ucayali',
    code: 'PE-UCA',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741005766774,
    name: 'Abra',
    code: 'PH-ABR',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741005799542,
    name: 'Agusan del Norte',
    code: 'PH-AGN',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741005832310,
    name: 'Agusan del Sur',
    code: 'PH-AGS',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741005865078,
    name: 'Aklan',
    code: 'PH-AKL',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741005897846,
    name: 'Albay',
    code: 'PH-ALB',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741005930614,
    name: 'Antique',
    code: 'PH-ANT',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741005963382,
    name: 'Apayao',
    code: 'PH-APA',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741005996150,
    name: 'Aurora',
    code: 'PH-AUR',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741006028918,
    name: 'Basilan',
    code: 'PH-BAS',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741006061686,
    name: 'Bataan',
    code: 'PH-BAN',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741006094454,
    name: 'Batanes',
    code: 'PH-BTN',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741006127222,
    name: 'Batangas',
    code: 'PH-BTG',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741006159990,
    name: 'Benguet',
    code: 'PH-BEN',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741006192758,
    name: 'Biliran',
    code: 'PH-BIL',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741006225526,
    name: 'Bohol',
    code: 'PH-BOH',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741006258294,
    name: 'Bukidnon',
    code: 'PH-BUK',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741006291062,
    name: 'Bulacan',
    code: 'PH-BUL',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741006323830,
    name: 'Cagayan',
    code: 'PH-CAG',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741006356598,
    name: 'Camarines Norte',
    code: 'PH-CAN',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741006389366,
    name: 'Camarines Sur',
    code: 'PH-CAS',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741006422134,
    name: 'Camiguin',
    code: 'PH-CAM',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741006454902,
    name: 'Capiz',
    code: 'PH-CAP',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741006487670,
    name: 'Catanduanes',
    code: 'PH-CAT',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741006520438,
    name: 'Cavite',
    code: 'PH-CAV',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741006553206,
    name: 'Cebu',
    code: 'PH-CEB',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741006585974,
    name: 'Cotabato',
    code: 'PH-NCO',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741006684278,
    name: 'Davao de Oro',
    code: 'PH-COM',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741006717046,
    name: 'Davao del Norte',
    code: 'PH-DAV',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741006749814,
    name: 'Davao del Sur',
    code: 'PH-DAS',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741006618742,
    name: 'Davao Occidental',
    code: 'PH-DVO',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741006651510,
    name: 'Davao Oriental',
    code: 'PH-DAO',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741006782582,
    name: 'Dinagat Islands',
    code: 'PH-DIN',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741006815350,
    name: 'Eastern Samar',
    code: 'PH-EAS',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741006848118,
    name: 'Guimaras',
    code: 'PH-GUI',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741006880886,
    name: 'Ifugao',
    code: 'PH-IFU',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741006913654,
    name: 'Ilocos Norte',
    code: 'PH-ILN',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741006946422,
    name: 'Ilocos Sur',
    code: 'PH-ILS',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741006979190,
    name: 'Iloilo',
    code: 'PH-ILI',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741007011958,
    name: 'Isabela',
    code: 'PH-ISA',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741007044726,
    name: 'Kalinga',
    code: 'PH-KAL',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741007077494,
    name: 'La Union',
    code: 'PH-LUN',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741007110262,
    name: 'Laguna',
    code: 'PH-LAG',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741007143030,
    name: 'Lanao del Norte',
    code: 'PH-LAN',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741007175798,
    name: 'Lanao del Sur',
    code: 'PH-LAS',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741007208566,
    name: 'Leyte',
    code: 'PH-LEY',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741007241334,
    name: 'Maguindanao',
    code: 'PH-MAG',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741007274102,
    name: 'Marinduque',
    code: 'PH-MAD',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741007306870,
    name: 'Masbate',
    code: 'PH-MAS',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741007339638,
    name: 'Metro Manila',
    code: 'PH-00',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741007372406,
    name: 'Misamis Occidental',
    code: 'PH-MSC',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741007405174,
    name: 'Misamis Oriental',
    code: 'PH-MSR',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741007437942,
    name: 'Mountain Province',
    code: 'PH-MOU',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741007470710,
    name: 'Negros Occidental',
    code: 'PH-NEC',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741007503478,
    name: 'Negros Oriental',
    code: 'PH-NER',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741007536246,
    name: 'Northern Samar',
    code: 'PH-NSA',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741007569014,
    name: 'Nueva Ecija',
    code: 'PH-NUE',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741007601782,
    name: 'Nueva Vizcaya',
    code: 'PH-NUV',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741007634550,
    name: 'Occidental Mindoro',
    code: 'PH-MDC',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741007667318,
    name: 'Oriental Mindoro',
    code: 'PH-MDR',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741007700086,
    name: 'Palawan',
    code: 'PH-PLW',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741007732854,
    name: 'Pampanga',
    code: 'PH-PAM',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741007765622,
    name: 'Pangasinan',
    code: 'PH-PAN',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741007798390,
    name: 'Quezon',
    code: 'PH-QUE',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741007831158,
    name: 'Quirino',
    code: 'PH-QUI',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741007863926,
    name: 'Rizal',
    code: 'PH-RIZ',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741007896694,
    name: 'Romblon',
    code: 'PH-ROM',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741007929462,
    name: 'Samar',
    code: 'PH-WSA',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741007962230,
    name: 'Sarangani',
    code: 'PH-SAR',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741007994998,
    name: 'Siquijor',
    code: 'PH-SIG',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741008027766,
    name: 'Sorsogon',
    code: 'PH-SOR',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741008060534,
    name: 'South Cotabato',
    code: 'PH-SCO',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741008093302,
    name: 'Southern Leyte',
    code: 'PH-SLE',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741008126070,
    name: 'Sultan Kudarat',
    code: 'PH-SUK',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741008158838,
    name: 'Sulu',
    code: 'PH-SLU',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741008191606,
    name: 'Surigao del Norte',
    code: 'PH-SUN',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741008224374,
    name: 'Surigao del Sur',
    code: 'PH-SUR',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741008257142,
    name: 'Tarlac',
    code: 'PH-TAR',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741008289910,
    name: 'Tawi-Tawi',
    code: 'PH-TAW',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741008322678,
    name: 'Zambales',
    code: 'PH-ZMB',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741008388214,
    name: 'Zamboanga del Norte',
    code: 'PH-ZAN',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741008420982,
    name: 'Zamboanga del Sur',
    code: 'PH-ZAS',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031605878,
    id: 5741008355446,
    name: 'Zamboanga Sibugay',
    code: 'PH-ZSI',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180922486,
    id: 5603110223990,
    name: 'Açores',
    code: 'PT-20',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180922486,
    id: 5603110256758,
    name: 'Aveiro',
    code: 'PT-01',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180922486,
    id: 5603110289526,
    name: 'Beja',
    code: 'PT-02',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180922486,
    id: 5603110322294,
    name: 'Braga',
    code: 'PT-03',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180922486,
    id: 5603110355062,
    name: 'Bragança',
    code: 'PT-04',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180922486,
    id: 5603110387830,
    name: 'Castelo Branco',
    code: 'PT-05',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180922486,
    id: 5603110420598,
    name: 'Coimbra',
    code: 'PT-06',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180922486,
    id: 5603110453366,
    name: 'Évora',
    code: 'PT-07',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180922486,
    id: 5603110486134,
    name: 'Faro',
    code: 'PT-08',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180922486,
    id: 5603110518902,
    name: 'Guarda',
    code: 'PT-09',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180922486,
    id: 5603110551670,
    name: 'Leiria',
    code: 'PT-10',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180922486,
    id: 5603110584438,
    name: 'Lisboa',
    code: 'PT-11',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180922486,
    id: 5603110617206,
    name: 'Madeira',
    code: 'PT-30',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180922486,
    id: 5603110649974,
    name: 'Portalegre',
    code: 'PT-12',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180922486,
    id: 5603110682742,
    name: 'Porto',
    code: 'PT-13',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180922486,
    id: 5603110715510,
    name: 'Santarém',
    code: 'PT-14',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180922486,
    id: 5603110748278,
    name: 'Setúbal',
    code: 'PT-15',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180922486,
    id: 5603110781046,
    name: 'Viana do Castelo',
    code: 'PT-16',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180922486,
    id: 5603110813814,
    name: 'Vila Real',
    code: 'PT-17',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180922486,
    id: 5603110846582,
    name: 'Viseu',
    code: 'PT-18',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032883830,
    id: 5741011009654,
    name: 'Alba',
    code: 'AB',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032883830,
    id: 5741011042422,
    name: 'Arad',
    code: 'AR',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032883830,
    id: 5741011075190,
    name: 'Argeș',
    code: 'AG',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032883830,
    id: 5741011107958,
    name: 'Bacău',
    code: 'BC',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032883830,
    id: 5741011140726,
    name: 'Bihor',
    code: 'BH',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032883830,
    id: 5741011173494,
    name: 'Bistrița-Năsăud',
    code: 'BN',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032883830,
    id: 5741011206262,
    name: 'Botoșani',
    code: 'BT',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032883830,
    id: 5741011239030,
    name: 'Brăila',
    code: 'BR',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032883830,
    id: 5741011271798,
    name: 'Brașov',
    code: 'BV',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032883830,
    id: 5741011304566,
    name: 'București',
    code: 'B',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032883830,
    id: 5741011337334,
    name: 'Buzău',
    code: 'BZ',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032883830,
    id: 5741011501174,
    name: 'Călărași',
    code: 'CL',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032883830,
    id: 5741011370102,
    name: 'Caraș-Severin',
    code: 'CS',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032883830,
    id: 5741011402870,
    name: 'Cluj',
    code: 'CJ',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032883830,
    id: 5741011435638,
    name: 'Constanța',
    code: 'CT',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032883830,
    id: 5741011468406,
    name: 'Covasna',
    code: 'CV',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032883830,
    id: 5741011566710,
    name: 'Dâmbovița',
    code: 'DB',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032883830,
    id: 5741011533942,
    name: 'Dolj',
    code: 'DJ',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032883830,
    id: 5741011599478,
    name: 'Galați',
    code: 'GL',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032883830,
    id: 5741011632246,
    name: 'Giurgiu',
    code: 'GR',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032883830,
    id: 5741011665014,
    name: 'Gorj',
    code: 'GJ',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032883830,
    id: 5741011697782,
    name: 'Harghita',
    code: 'HR',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032883830,
    id: 5741011730550,
    name: 'Hunedoara',
    code: 'HD',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032883830,
    id: 5741011763318,
    name: 'Ialomița',
    code: 'IL',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032883830,
    id: 5741011796086,
    name: 'Iași',
    code: 'IS',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032883830,
    id: 5741011828854,
    name: 'Ilfov',
    code: 'IF',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032883830,
    id: 5741011861622,
    name: 'Maramureș',
    code: 'MM',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032883830,
    id: 5741011894390,
    name: 'Mehedinți',
    code: 'MH',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032883830,
    id: 5741011927158,
    name: 'Mureș',
    code: 'MS',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032883830,
    id: 5741011959926,
    name: 'Neamț',
    code: 'NT',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032883830,
    id: 5741011992694,
    name: 'Olt',
    code: 'OT',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032883830,
    id: 5741012025462,
    name: 'Prahova',
    code: 'PH',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032883830,
    id: 5741012058230,
    name: 'Sălaj',
    code: 'SJ',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032883830,
    id: 5741012090998,
    name: 'Satu Mare',
    code: 'SM',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032883830,
    id: 5741012123766,
    name: 'Sibiu',
    code: 'SB',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032883830,
    id: 5741012156534,
    name: 'Suceava',
    code: 'SV',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032883830,
    id: 5741012189302,
    name: 'Teleorman',
    code: 'TR',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032883830,
    id: 5741012222070,
    name: 'Timiș',
    code: 'TM',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032883830,
    id: 5741012254838,
    name: 'Tulcea',
    code: 'TL',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032883830,
    id: 5741012287606,
    name: 'Vâlcea',
    code: 'VL',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032883830,
    id: 5741012320374,
    name: 'Vaslui',
    code: 'VS',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032883830,
    id: 5741012353142,
    name: 'Vrancea',
    code: 'VN',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741012385910,
    name: 'Altai Krai',
    code: 'ALT',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741012418678,
    name: 'Altai Republic',
    code: 'AL',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741012451446,
    name: 'Amur Oblast',
    code: 'AMU',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741012484214,
    name: 'Arkhangelsk Oblast',
    code: 'ARK',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741012516982,
    name: 'Astrakhan Oblast',
    code: 'AST',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741012549750,
    name: 'Belgorod Oblast',
    code: 'BEL',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741012582518,
    name: 'Bryansk Oblast',
    code: 'BRY',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741012615286,
    name: 'Chechen Republic',
    code: 'CE',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741012648054,
    name: 'Chelyabinsk Oblast',
    code: 'CHE',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741012680822,
    name: 'Chukotka Autonomous Okrug',
    code: 'CHU',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741012713590,
    name: 'Chuvash Republic',
    code: 'CU',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741012746358,
    name: 'Irkutsk Oblast',
    code: 'IRK',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741012779126,
    name: 'Ivanovo Oblast',
    code: 'IVA',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741012811894,
    name: 'Jewish Autonomous Oblast',
    code: 'YEV',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741012844662,
    name: 'Kabardino-Balkarian Republic',
    code: 'KB',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741012877430,
    name: 'Kaliningrad Oblast',
    code: 'KGD',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741012910198,
    name: 'Kaluga Oblast',
    code: 'KLU',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741012942966,
    name: 'Kamchatka Krai',
    code: 'KAM',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741012975734,
    name: 'Karachay–Cherkess Republic',
    code: 'KC',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741013008502,
    name: 'Kemerovo Oblast',
    code: 'KEM',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741013041270,
    name: 'Khabarovsk Krai',
    code: 'KHA',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741013074038,
    name: 'Khanty-Mansi Autonomous Okrug',
    code: 'KHM',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741013106806,
    name: 'Kirov Oblast',
    code: 'KIR',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741013139574,
    name: 'Komi Republic',
    code: 'KO',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741013172342,
    name: 'Kostroma Oblast',
    code: 'KOS',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741013205110,
    name: 'Krasnodar Krai',
    code: 'KDA',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741013237878,
    name: 'Krasnoyarsk Krai',
    code: 'KYA',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741013270646,
    name: 'Kurgan Oblast',
    code: 'KGN',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741013303414,
    name: 'Kursk Oblast',
    code: 'KRS',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741013336182,
    name: 'Leningrad Oblast',
    code: 'LEN',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741013368950,
    name: 'Lipetsk Oblast',
    code: 'LIP',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741013401718,
    name: 'Magadan Oblast',
    code: 'MAG',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741013434486,
    name: 'Mari El Republic',
    code: 'ME',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741013467254,
    name: 'Moscow',
    code: 'MOW',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741013500022,
    name: 'Moscow Oblast',
    code: 'MOS',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741013532790,
    name: 'Murmansk Oblast',
    code: 'MUR',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741013565558,
    name: 'Nizhny Novgorod Oblast',
    code: 'NIZ',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741013598326,
    name: 'Novgorod Oblast',
    code: 'NGR',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741013631094,
    name: 'Novosibirsk Oblast',
    code: 'NVS',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741013663862,
    name: 'Omsk Oblast',
    code: 'OMS',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741013696630,
    name: 'Orenburg Oblast',
    code: 'ORE',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741013729398,
    name: 'Oryol Oblast',
    code: 'ORL',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741013762166,
    name: 'Penza Oblast',
    code: 'PNZ',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741013794934,
    name: 'Perm Krai',
    code: 'PER',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741013827702,
    name: 'Primorsky Krai',
    code: 'PRI',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741013860470,
    name: 'Pskov Oblast',
    code: 'PSK',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741013893238,
    name: 'Republic of Adygeya',
    code: 'AD',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741013926006,
    name: 'Republic of Bashkortostan',
    code: 'BA',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741013958774,
    name: 'Republic of Buryatia',
    code: 'BU',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741013991542,
    name: 'Republic of Dagestan',
    code: 'DA',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741014024310,
    name: 'Republic of Ingushetia',
    code: 'IN',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741014057078,
    name: 'Republic of Kalmykia',
    code: 'KL',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741014089846,
    name: 'Republic of Karelia',
    code: 'KR',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741014122614,
    name: 'Republic of Khakassia',
    code: 'KK',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741014155382,
    name: 'Republic of Mordovia',
    code: 'MO',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741014188150,
    name: 'Republic of North Ossetia–Alania',
    code: 'SE',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741014220918,
    name: 'Republic of Tatarstan',
    code: 'TA',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741014253686,
    name: 'Rostov Oblast',
    code: 'ROS',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741014286454,
    name: 'Ryazan Oblast',
    code: 'RYA',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741014319222,
    name: 'Saint Petersburg',
    code: 'SPE',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741014351990,
    name: 'Sakha Republic (Yakutia)',
    code: 'SA',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741014384758,
    name: 'Sakhalin Oblast',
    code: 'SAK',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741014417526,
    name: 'Samara Oblast',
    code: 'SAM',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741014450294,
    name: 'Saratov Oblast',
    code: 'SAR',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741014483062,
    name: 'Smolensk Oblast',
    code: 'SMO',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741014515830,
    name: 'Stavropol Krai',
    code: 'STA',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741014548598,
    name: 'Sverdlovsk Oblast',
    code: 'SVE',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741014581366,
    name: 'Tambov Oblast',
    code: 'TAM',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741014614134,
    name: 'Tomsk Oblast',
    code: 'TOM',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741014646902,
    name: 'Tula Oblast',
    code: 'TUL',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741014679670,
    name: 'Tver Oblast',
    code: 'TVE',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741014712438,
    name: 'Tyumen Oblast',
    code: 'TYU',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741014745206,
    name: 'Tyva Republic',
    code: 'TY',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741014777974,
    name: 'Udmurtia',
    code: 'UD',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741014810742,
    name: 'Ulyanovsk Oblast',
    code: 'ULY',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741014843510,
    name: 'Vladimir Oblast',
    code: 'VLA',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741014876278,
    name: 'Volgograd Oblast',
    code: 'VGG',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741014909046,
    name: 'Vologda Oblast',
    code: 'VLG',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741014941814,
    name: 'Voronezh Oblast',
    code: 'VOR',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741014974582,
    name: 'Yamalo-Nenets Autonomous Okrug',
    code: 'YAN',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741015007350,
    name: 'Yaroslavl Oblast',
    code: 'YAR',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518032916598,
    id: 5741015040118,
    name: 'Zabaykalsky Krai',
    code: 'ZAB',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 538588315766,
    id: 6026415702134,
    name: 'Eastern Cape',
    code: 'EC',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 538588315766,
    id: 6026415734902,
    name: 'Free State',
    code: 'FS',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 538588315766,
    id: 6026415767670,
    name: 'Gauteng',
    code: 'GP',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 538588315766,
    id: 6026415800438,
    name: 'KwaZulu-Natal',
    code: 'NL',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 538588315766,
    id: 6026415833206,
    name: 'Limpopo',
    code: 'LP',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 538588315766,
    id: 6026415865974,
    name: 'Mpumalanga',
    code: 'MP',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 538588315766,
    id: 6026415898742,
    name: 'North West',
    code: 'NW',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 538588315766,
    id: 6026415931510,
    name: 'Northern Cape',
    code: 'NC',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 538588315766,
    id: 6026415964278,
    name: 'Western Cape',
    code: 'WC',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180725878,
    id: 5603108585590,
    name: 'Busan',
    code: 'KR-26',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180725878,
    id: 5603108618358,
    name: 'Chungbuk',
    code: 'KR-43',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180725878,
    id: 5603108651126,
    name: 'Chungnam',
    code: 'KR-44',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180725878,
    id: 5603108683894,
    name: 'Daegu',
    code: 'KR-27',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180725878,
    id: 5603108716662,
    name: 'Daejeon',
    code: 'KR-30',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180725878,
    id: 5603108749430,
    name: 'Gangwon',
    code: 'KR-42',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180725878,
    id: 5603108782198,
    name: 'Gwangju',
    code: 'KR-29',
    tax_name: '0.0',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180725878,
    id: 5603108814966,
    name: 'Gyeongbuk',
    code: 'KR-47',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180725878,
    id: 5603108847734,
    name: 'Gyeonggi',
    code: 'KR-41',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180725878,
    id: 5603108880502,
    name: 'Gyeongnam',
    code: 'KR-48',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180725878,
    id: 5603108913270,
    name: 'Incheon',
    code: 'KR-28',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180725878,
    id: 5603108946038,
    name: 'Jeju',
    code: 'KR-49',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180725878,
    id: 5603108978806,
    name: 'Jeonbuk',
    code: 'KR-45',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180725878,
    id: 5603109011574,
    name: 'Jeonnam',
    code: 'KR-46',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180725878,
    id: 5603109044342,
    name: 'Sejong',
    code: 'KR-50',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180725878,
    id: 5603109077110,
    name: 'Seoul',
    code: 'KR-11',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180725878,
    id: 5603109109878,
    name: 'Ulsan',
    code: 'KR-31',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180430966,
    id: 5603100622966,
    name: 'A Coruña',
    code: 'C',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180430966,
    id: 5603100655734,
    name: 'Álava',
    code: 'VI',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180430966,
    id: 5603100688502,
    name: 'Albacete',
    code: 'AB',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180430966,
    id: 5603100721270,
    name: 'Alicante',
    code: 'A',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180430966,
    id: 5603100754038,
    name: 'Almería',
    code: 'AL',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180430966,
    id: 5603100786806,
    name: 'Asturias',
    code: 'O',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180430966,
    id: 5603100819574,
    name: 'Ávila',
    code: 'AV',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180430966,
    id: 5603100852342,
    name: 'Badajoz',
    code: 'BA',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180430966,
    id: 5603100885110,
    name: 'Balears',
    code: 'PM',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180430966,
    id: 5603100917878,
    name: 'Barcelona',
    code: 'B',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180430966,
    id: 5603100950646,
    name: 'Burgos',
    code: 'BU',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180430966,
    id: 5603100983414,
    name: 'Cáceres',
    code: 'CC',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180430966,
    id: 5603101016182,
    name: 'Cádiz',
    code: 'CA',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180430966,
    id: 5603101048950,
    name: 'Cantabria',
    code: 'S',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180430966,
    id: 5603101081718,
    name: 'Castellón',
    code: 'CS',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180430966,
    id: 5603101114486,
    name: 'Ceuta',
    code: 'CE',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180430966,
    id: 5603101147254,
    name: 'Ciudad Real',
    code: 'CR',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180430966,
    id: 5603101180022,
    name: 'Córdoba',
    code: 'CO',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180430966,
    id: 5603101212790,
    name: 'Cuenca',
    code: 'CU',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180430966,
    id: 5603101245558,
    name: 'Girona',
    code: 'GI',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180430966,
    id: 5603101278326,
    name: 'Granada',
    code: 'GR',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180430966,
    id: 5603101311094,
    name: 'Guadalajara',
    code: 'GU',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180430966,
    id: 5603101343862,
    name: 'Guipúzcoa',
    code: 'SS',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180430966,
    id: 5603101376630,
    name: 'Huelva',
    code: 'H',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180430966,
    id: 5603101409398,
    name: 'Huesca',
    code: 'HU',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180430966,
    id: 5603101442166,
    name: 'Jaén',
    code: 'J',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180430966,
    id: 5603101474934,
    name: 'La Rioja',
    code: 'LO',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180430966,
    id: 5603101507702,
    name: 'Las Palmas',
    code: 'GC',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180430966,
    id: 5603101540470,
    name: 'León',
    code: 'LE',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180430966,
    id: 5603101573238,
    name: 'Lleida',
    code: 'L',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180430966,
    id: 5603101606006,
    name: 'Lugo',
    code: 'LU',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180430966,
    id: 5603101638774,
    name: 'Madrid',
    code: 'M',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180430966,
    id: 5603101671542,
    name: 'Málaga',
    code: 'MA',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180430966,
    id: 5603101704310,
    name: 'Melilla',
    code: 'ML',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180430966,
    id: 5603101737078,
    name: 'Murcia',
    code: 'MU',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180430966,
    id: 5603101769846,
    name: 'Navarra',
    code: 'NA',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180430966,
    id: 5603101802614,
    name: 'Ourense',
    code: 'OR',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180430966,
    id: 5603101835382,
    name: 'Palencia',
    code: 'P',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180430966,
    id: 5603101868150,
    name: 'Pontevedra',
    code: 'PO',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180430966,
    id: 5603101900918,
    name: 'Salamanca',
    code: 'SA',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180430966,
    id: 5603101933686,
    name: 'Santa Cruz de Tenerife',
    code: 'TF',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180430966,
    id: 5603101966454,
    name: 'Segovia',
    code: 'SG',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180430966,
    id: 5603101999222,
    name: 'Sevilla',
    code: 'SE',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180430966,
    id: 5603102031990,
    name: 'Soria',
    code: 'SO',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180430966,
    id: 5603102064758,
    name: 'Tarragona',
    code: 'T',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180430966,
    id: 5603102097526,
    name: 'Teruel',
    code: 'TE',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180430966,
    id: 5603102130294,
    name: 'Toledo',
    code: 'TO',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180430966,
    id: 5603102163062,
    name: 'Valencia',
    code: 'V',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180430966,
    id: 5603102195830,
    name: 'Valladolid',
    code: 'VA',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180430966,
    id: 5603102228598,
    name: 'Vizcaya',
    code: 'BI',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180430966,
    id: 5603102261366,
    name: 'Zamora',
    code: 'ZA',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180430966,
    id: 5603102294134,
    name: 'Zaragoza',
    code: 'Z',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031802486,
    id: 5741008453750,
    name: 'Amnat Charoen',
    code: 'TH-37',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031802486,
    id: 5741008486518,
    name: 'Ang Thong',
    code: 'TH-15',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031802486,
    id: 5741008519286,
    name: 'Bangkok',
    code: 'TH-10',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031802486,
    id: 5741008552054,
    name: 'Bueng Kan',
    code: 'TH-38',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031802486,
    id: 5741008584822,
    name: 'Buriram',
    code: 'TH-31',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031802486,
    id: 5741008617590,
    name: 'Chachoengsao',
    code: 'TH-24',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031802486,
    id: 5741008650358,
    name: 'Chai Nat',
    code: 'TH-18',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031802486,
    id: 5741008683126,
    name: 'Chaiyaphum',
    code: 'TH-36',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031802486,
    id: 5741008715894,
    name: 'Chanthaburi',
    code: 'TH-22',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031802486,
    id: 5741008748662,
    name: 'Chiang Mai',
    code: 'TH-50',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031802486,
    id: 5741008781430,
    name: 'Chiang Rai',
    code: 'TH-57',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031802486,
    id: 5741008814198,
    name: 'Chon Buri',
    code: 'TH-20',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031802486,
    id: 5741008846966,
    name: 'Chumphon',
    code: 'TH-86',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031802486,
    id: 5741008879734,
    name: 'Kalasin',
    code: 'TH-46',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031802486,
    id: 5741008912502,
    name: 'Kamphaeng Phet',
    code: 'TH-62',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031802486,
    id: 5741008945270,
    name: 'Kanchanaburi',
    code: 'TH-71',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031802486,
    id: 5741008978038,
    name: 'Khon Kaen',
    code: 'TH-40',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031802486,
    id: 5741009010806,
    name: 'Krabi',
    code: 'TH-81',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031802486,
    id: 5741009043574,
    name: 'Lampang',
    code: 'TH-52',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031802486,
    id: 5741009076342,
    name: 'Lamphun',
    code: 'TH-51',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031802486,
    id: 5741009109110,
    name: 'Loei',
    code: 'TH-42',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031802486,
    id: 5741009141878,
    name: 'Lopburi',
    code: 'TH-16',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031802486,
    id: 5741009174646,
    name: 'Mae Hong Son',
    code: 'TH-58',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031802486,
    id: 5741009207414,
    name: 'Maha Sarakham',
    code: 'TH-44',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031802486,
    id: 5741009240182,
    name: 'Mukdahan',
    code: 'TH-49',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031802486,
    id: 5741009272950,
    name: 'Nakhon Nayok',
    code: 'TH-26',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031802486,
    id: 5741009305718,
    name: 'Nakhon Pathom',
    code: 'TH-73',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031802486,
    id: 5741009338486,
    name: 'Nakhon Phanom',
    code: 'TH-48',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031802486,
    id: 5741009371254,
    name: 'Nakhon Ratchasima',
    code: 'TH-30',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031802486,
    id: 5741009404022,
    name: 'Nakhon Sawan',
    code: 'TH-60',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031802486,
    id: 5741009436790,
    name: 'Nakhon Si Thammarat',
    code: 'TH-80',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031802486,
    id: 5741009469558,
    name: 'Nan',
    code: 'TH-55',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031802486,
    id: 5741009502326,
    name: 'Narathiwat',
    code: 'TH-96',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031802486,
    id: 5741009535094,
    name: 'Nong Bua Lam Phu',
    code: 'TH-39',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031802486,
    id: 5741009567862,
    name: 'Nong Khai',
    code: 'TH-43',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031802486,
    id: 5741009600630,
    name: 'Nonthaburi',
    code: 'TH-12',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031802486,
    id: 5741009633398,
    name: 'Pathum Thani',
    code: 'TH-13',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031802486,
    id: 5741009666166,
    name: 'Pattani',
    code: 'TH-94',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031802486,
    id: 5741009698934,
    name: 'Pattaya',
    code: 'TH-S',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031802486,
    id: 5741009731702,
    name: 'Phangnga',
    code: 'TH-82',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031802486,
    id: 5741009764470,
    name: 'Phatthalung',
    code: 'TH-93',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031802486,
    id: 5741009797238,
    name: 'Phayao',
    code: 'TH-56',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031802486,
    id: 5741009830006,
    name: 'Phetchabun',
    code: 'TH-67',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031802486,
    id: 5741009862774,
    name: 'Phetchaburi',
    code: 'TH-76',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031802486,
    id: 5741009895542,
    name: 'Phichit',
    code: 'TH-66',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031802486,
    id: 5741009928310,
    name: 'Phitsanulok',
    code: 'TH-65',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031802486,
    id: 5741009961078,
    name: 'Phra Nakhon Si Ayutthaya',
    code: 'TH-14',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031802486,
    id: 5741009993846,
    name: 'Phrae',
    code: 'TH-54',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031802486,
    id: 5741010026614,
    name: 'Phuket',
    code: 'TH-83',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031802486,
    id: 5741010059382,
    name: 'Prachin Buri',
    code: 'TH-25',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031802486,
    id: 5741010092150,
    name: 'Prachuap Khiri Khan',
    code: 'TH-77',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031802486,
    id: 5741010124918,
    name: 'Ranong',
    code: 'TH-85',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031802486,
    id: 5741010157686,
    name: 'Ratchaburi',
    code: 'TH-70',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031802486,
    id: 5741010190454,
    name: 'Rayong',
    code: 'TH-21',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031802486,
    id: 5741010223222,
    name: 'Roi Et',
    code: 'TH-45',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031802486,
    id: 5741010255990,
    name: 'Sa Kaeo',
    code: 'TH-27',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031802486,
    id: 5741010288758,
    name: 'Sakon Nakhon',
    code: 'TH-47',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031802486,
    id: 5741010321526,
    name: 'Samut Prakan',
    code: 'TH-11',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031802486,
    id: 5741010354294,
    name: 'Samut Sakhon',
    code: 'TH-74',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031802486,
    id: 5741010387062,
    name: 'Samut Songkhram',
    code: 'TH-75',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031802486,
    id: 5741010419830,
    name: 'Saraburi',
    code: 'TH-19',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031802486,
    id: 5741010452598,
    name: 'Satun',
    code: 'TH-91',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031802486,
    id: 5741010485366,
    name: 'Sing Buri',
    code: 'TH-17',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031802486,
    id: 5741010518134,
    name: 'Sisaket',
    code: 'TH-33',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031802486,
    id: 5741010550902,
    name: 'Songkhla',
    code: 'TH-90',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031802486,
    id: 5741010583670,
    name: 'Sukhothai',
    code: 'TH-64',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031802486,
    id: 5741010616438,
    name: 'Suphan Buri',
    code: 'TH-72',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031802486,
    id: 5741010649206,
    name: 'Surat Thani',
    code: 'TH-84',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031802486,
    id: 5741010681974,
    name: 'Surin',
    code: 'TH-32',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031802486,
    id: 5741010714742,
    name: 'Tak',
    code: 'TH-63',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031802486,
    id: 5741010747510,
    name: 'Trang',
    code: 'TH-92',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031802486,
    id: 5741010780278,
    name: 'Trat',
    code: 'TH-23',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031802486,
    id: 5741010813046,
    name: 'Ubon Ratchathani',
    code: 'TH-34',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031802486,
    id: 5741010845814,
    name: 'Udon Thani',
    code: 'TH-41',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031802486,
    id: 5741010878582,
    name: 'Uthai Thani',
    code: 'TH-61',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031802486,
    id: 5741010911350,
    name: 'Uttaradit',
    code: 'TH-53',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031802486,
    id: 5741010944118,
    name: 'Yala',
    code: 'TH-95',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518031802486,
    id: 5741010976886,
    name: 'Yasothon',
    code: 'TH-35',
    tax_name: 'Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180136054,
    id: 5603099705462,
    name: 'Abu Dhabi',
    code: 'AZ',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180136054,
    id: 5603099738230,
    name: 'Ajman',
    code: 'AJ',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180136054,
    id: 5603099770998,
    name: 'Dubai',
    code: 'DU',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180136054,
    id: 5603099803766,
    name: 'Fujairah',
    code: 'FU',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180136054,
    id: 5603099836534,
    name: 'Ras al-Khaimah',
    code: 'RK',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180136054,
    id: 5603099869302,
    name: 'Sharjah',
    code: 'SH',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180136054,
    id: 5603099902070,
    name: 'Umm al-Quwain',
    code: 'UQ',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180529270,
    id: 5603102326902,
    name: 'British Forces',
    code: 'BFP',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180529270,
    id: 5603102359670,
    name: 'England',
    code: 'ENG',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180529270,
    id: 5603102392438,
    name: 'Northern Ireland',
    code: 'NIR',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180529270,
    id: 5603102425206,
    name: 'Scotland',
    code: 'SCT',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180529270,
    id: 5603102457974,
    name: 'Wales',
    code: 'WLS',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180103286,
    id: 5603097673846,
    name: 'Alabama',
    code: 'AL',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180103286,
    id: 5603097706614,
    name: 'Alaska',
    code: 'AK',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180103286,
    id: 5603097739382,
    name: 'American Samoa',
    code: 'AS',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180103286,
    id: 5603097772150,
    name: 'Arizona',
    code: 'AZ',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180103286,
    id: 5603097804918,
    name: 'Arkansas',
    code: 'AR',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180103286,
    id: 5603099607158,
    name: 'Armed Forces Americas',
    code: 'AA',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180103286,
    id: 5603099639926,
    name: 'Armed Forces Europe',
    code: 'AE',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180103286,
    id: 5603099672694,
    name: 'Armed Forces Pacific',
    code: 'AP',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180103286,
    id: 5603097837686,
    name: 'California',
    code: 'CA',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180103286,
    id: 5603097870454,
    name: 'Colorado',
    code: 'CO',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180103286,
    id: 5603097903222,
    name: 'Connecticut',
    code: 'CT',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180103286,
    id: 5603097935990,
    name: 'Delaware',
    code: 'DE',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180103286,
    id: 5603099443318,
    name: 'District of Columbia',
    code: 'DC',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180103286,
    id: 5603097968758,
    name: 'Federated States of Micronesia',
    code: 'FM',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180103286,
    id: 5603098001526,
    name: 'Florida',
    code: 'FL',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180103286,
    id: 5603098034294,
    name: 'Georgia',
    code: 'GA',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180103286,
    id: 5603098067062,
    name: 'Guam',
    code: 'GU',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180103286,
    id: 5603098099830,
    name: 'Hawaii',
    code: 'HI',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180103286,
    id: 5603098132598,
    name: 'Idaho',
    code: 'ID',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180103286,
    id: 5603098165366,
    name: 'Illinois',
    code: 'IL',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180103286,
    id: 5603098198134,
    name: 'Indiana',
    code: 'IN',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180103286,
    id: 5603098230902,
    name: 'Iowa',
    code: 'IA',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180103286,
    id: 5603098263670,
    name: 'Kansas',
    code: 'KS',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180103286,
    id: 5603098296438,
    name: 'Kentucky',
    code: 'KY',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180103286,
    id: 5603098329206,
    name: 'Louisiana',
    code: 'LA',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180103286,
    id: 5603098361974,
    name: 'Maine',
    code: 'ME',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180103286,
    id: 5603098394742,
    name: 'Marshall Islands',
    code: 'MH',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180103286,
    id: 5603098427510,
    name: 'Maryland',
    code: 'MD',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180103286,
    id: 5603098460278,
    name: 'Massachusetts',
    code: 'MA',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180103286,
    id: 5603098493046,
    name: 'Michigan',
    code: 'MI',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180103286,
    id: 5603098525814,
    name: 'Minnesota',
    code: 'MN',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180103286,
    id: 5603098558582,
    name: 'Mississippi',
    code: 'MS',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180103286,
    id: 5603098591350,
    name: 'Missouri',
    code: 'MO',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180103286,
    id: 5603098624118,
    name: 'Montana',
    code: 'MT',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180103286,
    id: 5603098656886,
    name: 'Nebraska',
    code: 'NE',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180103286,
    id: 5603098689654,
    name: 'Nevada',
    code: 'NV',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180103286,
    id: 5603098722422,
    name: 'New Hampshire',
    code: 'NH',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180103286,
    id: 5603098755190,
    name: 'New Jersey',
    code: 'NJ',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180103286,
    id: 5603098787958,
    name: 'New Mexico',
    code: 'NM',
    tax_name: 'GRT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180103286,
    id: 5603098820726,
    name: 'New York',
    code: 'NY',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180103286,
    id: 5603098853494,
    name: 'North Carolina',
    code: 'NC',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180103286,
    id: 5603098886262,
    name: 'North Dakota',
    code: 'ND',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180103286,
    id: 5603098919030,
    name: 'Northern Mariana Islands',
    code: 'MP',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180103286,
    id: 5603098951798,
    name: 'Ohio',
    code: 'OH',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180103286,
    id: 5603098984566,
    name: 'Oklahoma',
    code: 'OK',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180103286,
    id: 5603099017334,
    name: 'Oregon',
    code: 'OR',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180103286,
    id: 5603099050102,
    name: 'Palau',
    code: 'PW',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180103286,
    id: 5603099082870,
    name: 'Pennsylvania',
    code: 'PA',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180103286,
    id: 5603099115638,
    name: 'Puerto Rico',
    code: 'PR',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180103286,
    id: 5603099148406,
    name: 'Rhode Island',
    code: 'RI',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180103286,
    id: 5603099181174,
    name: 'South Carolina',
    code: 'SC',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180103286,
    id: 5603099213942,
    name: 'South Dakota',
    code: 'SD',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180103286,
    id: 5603099246710,
    name: 'Tennessee',
    code: 'TN',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180103286,
    id: 5603099279478,
    name: 'Texas',
    code: 'TX',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180103286,
    id: 5603099312246,
    name: 'Utah',
    code: 'UT',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180103286,
    id: 5603099345014,
    name: 'Vermont',
    code: 'VT',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180103286,
    id: 5603099574390,
    name: 'Virgin Islands',
    code: 'VI',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180103286,
    id: 5603099377782,
    name: 'Virginia',
    code: 'VA',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180103286,
    id: 5603099410550,
    name: 'Washington',
    code: 'WA',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180103286,
    id: 5603099476086,
    name: 'West Virginia',
    code: 'WV',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180103286,
    id: 5603099508854,
    name: 'Wisconsin',
    code: 'WI',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 508180103286,
    id: 5603099541622,
    name: 'Wyoming',
    code: 'WY',
    tax_name: 'State Tax',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035439734,
    id: 5741022085238,
    name: 'Artigas',
    code: 'UY-AR',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035439734,
    id: 5741022118006,
    name: 'Canelones',
    code: 'UY-CA',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035439734,
    id: 5741022150774,
    name: 'Cerro Largo',
    code: 'UY-CL',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035439734,
    id: 5741022183542,
    name: 'Colonia',
    code: 'UY-CO',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035439734,
    id: 5741022216310,
    name: 'Durazno',
    code: 'UY-DU',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035439734,
    id: 5741022249078,
    name: 'Flores',
    code: 'UY-FS',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035439734,
    id: 5741022281846,
    name: 'Florida',
    code: 'UY-FD',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035439734,
    id: 5741022314614,
    name: 'Lavalleja',
    code: 'UY-LA',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035439734,
    id: 5741022347382,
    name: 'Maldonado',
    code: 'UY-MA',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035439734,
    id: 5741022380150,
    name: 'Montevideo',
    code: 'UY-MO',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035439734,
    id: 5741022412918,
    name: 'Paysandú',
    code: 'UY-PA',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035439734,
    id: 5741022445686,
    name: 'Río Negro',
    code: 'UY-RN',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035439734,
    id: 5741022478454,
    name: 'Rivera',
    code: 'UY-RV',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035439734,
    id: 5741022511222,
    name: 'Rocha',
    code: 'UY-RO',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035439734,
    id: 5741022543990,
    name: 'Salto',
    code: 'UY-SA',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035439734,
    id: 5741022576758,
    name: 'San José',
    code: 'UY-SJ',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035439734,
    id: 5741022609526,
    name: 'Soriano',
    code: 'UY-SO',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035439734,
    id: 5741022642294,
    name: 'Tacuarembó',
    code: 'UY-TA',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035439734,
    id: 5741022675062,
    name: 'Treinta y Tres',
    code: 'UY-TT',
    tax_name: 'VAT',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035472502,
    id: 5741022707830,
    name: 'Amazonas',
    code: 'VE-Z',
    tax_name: 'IVA',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035472502,
    id: 5741022740598,
    name: 'Anzoátegui',
    code: 'VE-B',
    tax_name: 'IVA',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035472502,
    id: 5741022773366,
    name: 'Apure',
    code: 'VE-C',
    tax_name: 'IVA',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035472502,
    id: 5741022806134,
    name: 'Aragua',
    code: 'VE-D',
    tax_name: 'IVA',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035472502,
    id: 5741022838902,
    name: 'Barinas',
    code: 'VE-E',
    tax_name: 'IVA',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035472502,
    id: 5741022871670,
    name: 'Bolívar',
    code: 'VE-F',
    tax_name: 'IVA',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035472502,
    id: 5741022904438,
    name: 'Carabobo',
    code: 'VE-G',
    tax_name: 'IVA',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035472502,
    id: 5741022937206,
    name: 'Cojedes',
    code: 'VE-H',
    tax_name: 'IVA',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035472502,
    id: 5741022969974,
    name: 'Delta Amacuro',
    code: 'VE-Y',
    tax_name: 'IVA',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035472502,
    id: 5741023002742,
    name: 'Dependencias Federales',
    code: 'VE-W',
    tax_name: 'IVA',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035472502,
    id: 5741023035510,
    name: 'Distrito Capital',
    code: 'VE-A',
    tax_name: 'IVA',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035472502,
    id: 5741023068278,
    name: 'Falcón',
    code: 'VE-I',
    tax_name: 'IVA',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035472502,
    id: 5741023101046,
    name: 'Guárico',
    code: 'VE-J',
    tax_name: 'IVA',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035472502,
    id: 5741023133814,
    name: 'La Guaira',
    code: 'VE-X',
    tax_name: 'IVA',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035472502,
    id: 5741023166582,
    name: 'Lara',
    code: 'VE-K',
    tax_name: 'IVA',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035472502,
    id: 5741023199350,
    name: 'Mérida',
    code: 'VE-L',
    tax_name: 'IVA',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035472502,
    id: 5741023232118,
    name: 'Miranda',
    code: 'VE-M',
    tax_name: 'IVA',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035472502,
    id: 5741023264886,
    name: 'Monagas',
    code: 'VE-N',
    tax_name: 'IVA',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035472502,
    id: 5741023297654,
    name: 'Nueva Esparta',
    code: 'VE-O',
    tax_name: 'IVA',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035472502,
    id: 5741023330422,
    name: 'Portuguesa',
    code: 'VE-P',
    tax_name: 'IVA',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035472502,
    id: 5741023363190,
    name: 'Sucre',
    code: 'VE-R',
    tax_name: 'IVA',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035472502,
    id: 5741023395958,
    name: 'Táchira',
    code: 'VE-S',
    tax_name: 'IVA',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035472502,
    id: 5741023428726,
    name: 'Trujillo',
    code: 'VE-T',
    tax_name: 'IVA',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035472502,
    id: 5741023461494,
    name: 'Yaracuy',
    code: 'VE-U',
    tax_name: 'IVA',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
  {
    country_id: 518035472502,
    id: 5741023494262,
    name: 'Zulia',
    code: 'VE-V',
    tax_name: 'IVA',
    tax_type: null,
    shipping_zone_id: null,
    tax: 0,
    tax_percentage: 0,
  },
];
